(ns pfo.task.component (:require
            [clojure.data]
            [reagent.core :as reagent :refer [atom track!] :refer-macros [with-let]]
            [reagent.ratom :refer-macros [run! reaction]]
            [taoensso.timbre :as timbre
                :refer [log trace debug info warn error fatal report logf
                        tracef debugf infof warnf errorf fatalf reportf spy]]
            [cljs-pikaday.reagent :as pikaday]
            [cljs-time.coerce :as time-coerce]
            [cljs-time.core :as time-core :refer [plus minus hours minutes seconds days before? after? sec minute in-seconds interval date-time year month day]]
            [cljs-time.format :as time-format]
            [pfo.widget.tree :refer [tree-view]]
            [pfo.time :refer [now now-js-date now-millis ceil is-now-within-window]]
            [goog.string :refer [format]]
            [promesa.core :as p]
            [pfo.auth.model :as auth-model :refer [perm has-perm filter-families has-any-of-perms-in-family]]
            [pfo.auth.component :as auth-component]
            [pfo.api :as api]
            [dommy.core :as dommy :refer-macros [sel sel1]]
            [lentes.core :as l]
            [pfo.tz :as tz]
            [pfo.state :as state :refer [ui-state]]
            [pfo.automation.component :as automation]
            [pfo.assignment.component :refer [assignments-add-new get-initial-ui-assignments
                                                assignments-add-new-notable
                                                assignments-edit-notable-redesign
                                                collection-field-header
                                                get-collection-ids assignments-table assignment-list
                                                assignment-list-with-header
                                                collection-list group-chooser nav-search]]
            [pfo.category.model :as category-model]
            [pfo.category.component :as category-component]
            [pfo.collection.model :as collection-model]
            [pfo.coltype.model :as coltype-model]
            [pfo.common.component :refer [sidebar sidebar-rounded header date-filter filter-exclude chosen-options adjust-checkboxes disable] :as common]
            [pfo.common.model :as common-model]
            [pfo.common.event :as common-event]
            [pfo.comment.component :as comment-comp]
            [pfo.link.component :as link]
            [pfo.admin.model :as admin-model]
            [pfo.link.model :as link-model]
            [pfo.document.model :as document-model]
            [pfo.form :as form :refer [set-checked set-selected option-value checked? reset-choice unselect-if-no-value]]
            [pfo.controller :as controller :refer [subscribe]]
            [pfo.signature.component :as signature]
            [pfo.widget.tabs :refer [tabs tab]]
            [pfo.widget.paginator :refer [paginator load-more tfoot-paginator]]
            [pfo.widget.calendar :refer [calendar]]
            [pfo.widget.timepicker :as timepicker :refer [datetimepair datetimepicker]]
            [pfo.widget.list :refer [orderer]]
            [pfo.widget.select :refer [nested-select default-select-sizer]]
            [pfo.widget.countdown :refer [countdown countdown-for-ability]]
            [pfo.widget.modal :refer [modal]]
            [pfo.widget.toggler :refer [toggler]]
            [pfo.util :as util :refer [entity handler event-value reset-from-event date-to-rfc3339 to-value set-location back split-string print-and-return disable-tool] :rename {split-string split}]
            [pfo.flash :refer [set-flash]]
            [pfo.flag :refer [enabled]]
            [pfo.valid :as valid]
            [pfo.api :refer [process-error]]
            [pfo.task.model :as model]
            [pfo.task.spec :as spec]
            [pfo.task.signature :as task-signature]
            [pfo.task.chart :as chart]
            [clojure.string :as string]
            [bidi.bidi :as bidi]
            [pfo.revroutes :refer [path-for set-waypoint go-to-deletion-waypoint go-to-last-waypoint]]
            [pfo.widget.icons :refer [padlock]]
            [pfo.widget.autocomplete :refer [react-select-styles]]
            [pfo.revroutes :refer [path-for]]
            ["react-select" :default Select :refer (components)]
            [pfo.notify :as notify]
            ["react-dropzone-component" :default ReactDropzone]
            [clojure.string :as str]
            [pfo.activity.component :as activity]
            [pfo.label.component :as label-component]))

(declare simple-task-edit task-add multistep-task-add apply-from-template task-filter event-filter event-list
         task-links multi-step-task assignments-description-list linked-items-all-multi-step linked-items-all-single-step
         task-details-component step-details single-task events-calendar
         calendar-container-dates toggle-complete-button task-type-name signature-status
         bulk-edit-form bulk-edit-global-form bulk-edit-user-form bulk-edit-date-form step-number-chooser
         tree bulk-apply-from-template-collection-chooser apply-from-template-collection-chooser apply-from-template-details-form
         bulk-apply-from-template-status process-compliance-conflicts-error boir-transmission-details-button fincen-comm-log-download-button
         report-mode-button group-independent-tasks keep-document-date-checker)

(def task-group-max-manage-age (minutes 15))

(def catom clojure.core/atom)

(def prefer-task-collections true)

(defn get-assignments [task-or-event]
  (let [to-task-collections (fn [collections]
                                (mapv (fn [col] {:collection_id (:id col)
                                                 :collection col})
                                      (:collections task-or-event)))]
    (if prefer-task-collections
     (if-let [task-collections (seq (:task_collections task-or-event))]
       task-collections
       (to-task-collections (:collections task-or-event)))
     (if-let [collections (seq (:collections task-or-event))]
       (to-task-collections collections)
       (:task_collections task-or-event)))))

(def rule-type-monthly 5)
(def rule-type-quarterly 6)
(def rule-type-yearly 7)
(def disposition-allowed-rule-types 
  (hash-set rule-type-monthly rule-type-quarterly rule-type-yearly))

(def alert-position-left "left")
(def alert-position-right "right")

(defn rule-chooser [options value-atom]
  (let [rules (atom [])
        load-rules (fn []
                     (controller/dispatch :rule-list :load))]
    (->> (load-rules)
         (p/map (fn [response]
                  (reset! rules (filterv #(% (:recurring-object-type options)) response))
                  (when-not (:allow-no-choice options)
                    (when (and (:must-repeat options) (not @value-atom)) (reset! value-atom (:id (first @rules)))))))
         (process-error))
    (fn []
      [:select (merge {:on-change (reset-from-event value-atom)
                       :value @value-atom} (when (:disabled options) {:disabled "disabled"}))
       (when (:allow-no-choice options)
         [:option {:value "ignore"}  (or (:allow-no-choice-label options) "Keep unchanged")])
       (when-not (:must-repeat options)
         [:option {:value ""} "Don't repeat"])
       (doall
         (for [arule @rules]
           [:option {:value (:id arule) :key (model/rule-key arule)} (:name arule)]))])))

(defn priority-chooser [options value-atom]
  [:select {:on-change (reset-from-event value-atom)
            :disabled (:disabled options)}
   (doall (map (fn [value]
                 [:option (set-selected @value-atom value {:value value}) (model/priorities value)])
               [2 3 1]))])

(defn signature-scope-chooser [options family-id value-atom]
  (let [boir (not (:compliance options))]
    [:select {:on-change (reset-from-event value-atom)
              :disabled (:disabled options)
              :value (or @value-atom "n")}
     (doall (map (fn [value]
                   [:option {:value value :key value} (model/signature-types value)])
              (concat [model/signature-type-none
                       model/signature-type-step
                       model/signature-type-cycle
                       model/signature-type-document]
                (when (enabled "dropbox-sign")
                  [model/signature-type-dropbox-sign-delete
                   model/signature-type-dropbox-sign-retain])
                (when boir [model/signature-type-boir
                            model/signature-type-boir-link
                            model/signature-type-boir-link-sign])
                (when (and boir (collection-model/has-boir-efile-enabled family-id))
                  [model/signature-type-boir-e-file]))))]))

(defn alert-list-buttons [filter-show]
  [:div.o-margin-elements--xs
   [:button {:on-click (util/handler #(swap! filter-show not))} "Filter"]])

(defn task-list-buttons [options collection-id filter-show report-mode-atom]
  [:div.o-margin-elements--xs
   (when (has-perm :can_add_task)
     [:button {:on-click #(set-location (str (path-for :task-add) "?task_type=task&action_type=simple&collection_id=" collection-id))}
      "Add task"])
   [report-mode-button options report-mode-atom]
   [:button {:on-click (util/handler #(swap! filter-show not))} "Filter"]])

(defn compliance-list-buttons [options collection-id filter-show bulk-edit-atom report-mode-atom]
  [:div.o-margin-elements--xs
   (when (has-perm :can_add_compliance)
     [:button {:on-click #(set-location (str (path-for :task-add) "?task_type=compliance&action_type=apply&collection_id=" collection-id))}
      "Add compliance"])
   [report-mode-button options report-mode-atom]
   (when (and (has-perm :can_do_bulk_operations) @filter-show (not @report-mode-atom))
     [:button (merge {:on-click (util/handler (fn [] 
                                                (swap! bulk-edit-atom (fn [old-value]
                                                                        (case old-value
                                                                          nil :filter
                                                                          :filter nil)))
                                                (when-not @bulk-edit-atom
                                                  (reset! (:show-steps-atom options) false)
                                                  (reset! (:chosen-tasks-atom options) #{})
                                                  (reset! (:select-all-atom options) false))))}
                     (when-not @(:filter-collection-id-atom options) {:disabled :disabled
                                                                      :title "Family or collection must be selected to enable bulk edit"}))
      "Bulk edit"])
   [:button (merge
              {:on-click (util/handler #(swap! filter-show not))}
              (when @bulk-edit-atom {:disabled :disabled})) "Filter"]
   (when (enabled "compliance-report")
     (when-let [get-task-list-params (some-> (:get-task-list-params-atom options) deref)]
       [:button {:on-click (util/handler (fn []
                                           (->> (apply model/task-report (get-task-list-params))
                                                (p/map (fn [response]
                                                         (let [link (.createElement js/document "a")
                                                               blob (js/Blob. (clj->js [response]))
                                                               url (.createObjectURL (.-URL js/window) blob)]
                                                           (aset link "href" url)
                                                           (aset link "download" "report.pdf")
                                                           (.click link))))
                                                (process-error))))} "Report"] ))])
(defn signature-list-buttons [filter-show]
  [:div.o-margin-elements--xs
   [:button {:on-click (util/handler #(swap! filter-show not))} "Filter"]])

(defn back-button []
  [:p
    [:button {:on-click util/back} "Back"]])

(defn operations-list [options operations next-from]
  (fn [options operations next-from]
    (if (seq operations)
      [:div
       [:table.operation-list.t-table
        [:thead
         [:tr
          [:th.assignments "Collections"]
          [:th.icon]
          [:th.name  "Name"]
          [:th "Category" ]
          [:th.middle.due-date "Due Date" ]
          [:th "Assigned To" ]]]
         [:tbody (doall (for [operation operations]
                   (if  (= (:type operation) 2)
                     [:tr {:key (model/operation-key operation)}
                      [:td.assignments [assignment-list (get-assignments operation)]]
                      [:td.icon {:class  "event"}]
                      [:td.name (when-let [group-name (not-empty (:group_name operation))] [:p.group-name group-name])
                       [:a {:href (str "#/event/details/" (:key operation) "/")} (:name operation)] (when (> (:comment_count (:counters operation)) 0) [:span " " [:span.comment-count (:comment_count (:counters operation))]])]
                      [:td.category (:category_name operation)]
                      [:td.middle.event-date (model/event-time-string operation "M/d/yy")]
                      [:td.assigned-to (when-let [user (:user operation)] (auth-model/get-full-name (:user operation)))]]
                     [:tr {:key (model/operation-key operation)}
                      [:td.assignments [assignment-list (get-assignments operation)]]
                      [:td.icon {:class (cond (= (:type operation) 2 ) "event" (:compliance operation) "compliance" :else "task")}]
                      [:td.name (when-let [group-name (not-empty (:group_name operation))] [:p.group-name group-name])
                       [:a {:href (str "#/task/details/" (:id operation) "/" (util/date-string (:complete_by operation)) "/")}
                        (:name operation)] (when (> (:comment_count (:counters operation)) 0) [:span " " [:span.comment-count (:comment_count (:counters operation))]])
                       (when (:labels operation)
                         [:div (into [label-component/label] (map :name (:labels operation)))])]
                      [:td.category (:category_name operation)]
                      [:td.middle.due-date (util/date-reformat (:complete_by operation))]
                      [:td.assigned-to (when-let [user (:user operation)] (auth-model/get-full-name (:user operation)))]])))]

         (when (not-empty next-from)
           [tfoot-paginator
            [load-more (handler #((:load-operations options) next-from))] 6 (not-empty next-from)])]]

      [:p.no-results "No pending operations"])))

(defn filter-param [task-type] (keyword (str task-type "-filter")))
(defn get-url-ui-state [task-type] (some-> ((filter-param task-type) (util/get-location-params)) (util/base64-url-unmarshal)))
(defn ui-state-value [task-type akey] (akey (get-url-ui-state task-type)))

(defn report-mode-button [options report-mode-atom]
  (let [collection-id-atom (:filter-collection-id-atom options)
        family-id-atom (atom nil)
        load-family-id (fn [collection-id]
                         (if-let [family-id (get @state/collection-family collection-id)]
                           (reset! family-id-atom family-id)
                           (->> (collection-model/collection-details collection-id)
                                (p/map (fn [collection]
                                         (swap! state/collection-family assoc collection-id (:group_id collection))
                                         (reset! family-id-atom (:group_id collection))))
                                (process-error))))
        report-mode-visible? (atom false)
        set-report-mode-visibility (fn []
                                     (reset! report-mode-visible?
                                             (if @collection-id-atom
                                               (collection-model/has-report-mode-enabled @family-id-atom)
                                               (some true? (vals (:report_mode_enabled @state/family-settings))))))]

    (add-watch family-id-atom :family-id-atom set-report-mode-visibility)
    (add-watch collection-id-atom :collection-id-atom (fn [_ _ _ new-collection-id] 
                                                        (if new-collection-id 
                                                          (load-family-id new-collection-id)
                                                          (reset! family-id-atom nil))))
    (set-report-mode-visibility)
    (when @collection-id-atom
      (load-family-id @collection-id-atom))
    (reagent/create-class
      {:component-will-unmount
       ;; collection-id-atom is owned by the parent and outlives this component;
       ;; the watch must not survive unmount (#2884). family-id-atom is local.
       (fn [_]
         (remove-watch collection-id-atom :collection-id-atom))
       :reagent-render
       (fn []
         (when @report-mode-visible?
           [:button (merge
                     {:on-click (util/handler #(swap! report-mode-atom not))})
            (if @report-mode-atom "Normal Mode" "Report Mode")]))})))

(defn- choose-existing-controls [_ {:keys [num-selected-tasks
                                          select-all-atom
                                          chosen-tasks-atom
                                          filter-show-atom
                                          save-fn]}]
  [:div.c-document-list__controls.o-media--bottom-shadow
   [:button.back {:on-click util/back} "Back"]
   [:button {:on-click (util/handler #(swap! filter-show-atom not))} "Filter"]
   [:button {:on-click (util/handler
                         (fn []
                           (swap! select-all-atom not)
                           (reset! chosen-tasks-atom #{})))}
    (if @select-all-atom
      "Unselect All"
      "Select All")]
   (when (not (zero? num-selected-tasks))
     [:button.save {:on-click save-fn} "Save"])])

(defn- selected-tasks [_ {:keys [select-all
                                       num-selected-tasks
                                       task-id-to-name-fn
                                       chosen-tasks-atom]}]
  [:>
   Select
   (merge
     {:isMulti     true
      :value       (if @select-all
                     {:value nil :label (str num-selected-tasks " task(s) selected")}
                     (util/uniq-by :label ;; Show task group name if any step selected; :value not really important, widget read only
                       (map
                         (fn [task-id] {:value task-id :label (task-id-to-name-fn task-id)})
                         @chosen-tasks-atom)))
      :className   (when (zero? num-selected-tasks) :u-display--none)
      :placeholder nil
      :clearable   false
      :components  (clj->js
                     {:Menu               (fn [] nil)
                      :Input              (fn [] nil)
                      :IndicatorSeparator (fn [] nil)
                      :DropdownIndicator  (fn [] nil)
                      :ClearIndicator     (fn [] nil)
                      :MultiValueRemove   (fn [] nil)})}
     (:second react-select-styles))])

(defn diff-watch [fn watch-key _ old-value new-value]
  (if (not= old-value new-value)
    (do
      (debug "Watch triggered:" watch-key "| value change" (take 2 (clojure.data/diff old-value new-value)))
      (fn))
    (debug "Watch triggered:" watch-key "| value unchanged, not executing")))

(defn task-list [{:keys [report-mode-atom]
                  :as options} collection-id assigned-to-current-user task-type filter-show]
  (let [choose (:choose options)
        chosen-tasks (or (:chosen-tasks-atom options) (atom #{})) 
        tasks (atom nil)
        get-tasks-id-map (fn [tasks]
                           (into {} (mapv (fn [task] [(:cycle_key task) task]) tasks)))
        tasks-id-map (atom (get-tasks-id-map (:results @tasks)))
        current-page (atom (or (ui-state-value task-type :page) 1))
        order (atom "date")
        include-subcollections (atom (first (filter some? [(:include-subcollections (get-url-ui-state task-type)) @state/include-descendants (ui-state-value task-type :include-subcollections)])))
        _ (prn "SIGN? " (:signature options) (ui-state-value task-type :signature) " :dashboard " (:dashboard options))
        filter-params (atom (let [filter-signature (boolean (or (:signature options) (ui-state-value task-type :signature)))
                                  filter-dropbox-sign (boolean (or (:dropbox-sign options) (ui-state-value task-type :dropbox-sign)))
                                  filter-e-boir (boolean (or (:e-boir options) (ui-state-value task-type :e-boir)))]
                              {:alert-active (boolean (:alert-active options))
                               :alert-enabled (boolean (ui-state-value task-type :alert-enabled))
                               :alert-exclude (ui-state-value task-type :alert-exclude)
                               :all (not (or filter-signature filter-dropbox-sign filter-e-boir)) ;; Auxiliary, don't pass to model
                               :assigned-user-id (into #{}  (if assigned-to-current-user #{(api/get-auth-info :user-id)} (ui-state-value task-type :assigned-user-id)))
                               :assigned-user-exclude (ui-state-value task-type :assigned-user-exclude)
                               :category-id (set (ui-state-value task-type :category-id))
                               :category-exclude (ui-state-value task-type :category-exclude)
                               :collection-type-id (set (ui-state-value task-type :collection-type-id))
                               :collection-type-exclude (ui-state-value task-type :collection-type-exclude)
                               :complete (ui-state-value task-type :complete)
                               :completed-from (ui-state-value task-type :completed-from)
                               :completed-to (ui-state-value task-type :completed-to)
                               :dropbox-sign filter-dropbox-sign
                               :dropbox-sign-pending (boolean (or (:dropbox-sign-pending options) (ui-state-value task-type :dropbox-sign-pending)))
                               :due-exclude (ui-state-value task-type :due-exclude)
                               :e-boir filter-e-boir
                               :e-boir-failed (boolean (or (:e-boir-failed options) (ui-state-value task-type :e-boir-failed)))
                               :e-boir-not-started (boolean (or (:e-boir-not-started options) (ui-state-value task-type :e-boir-not-started)))
                               :e-boir-pending (boolean (or (:e-boir-pending options) (ui-state-value task-type :e-boir-pending)))
                               :e-boir-rejected (boolean (or (:e-boir-rejected options) (ui-state-value task-type :e-boir-rejected)))
                               :future (boolean (ui-state-value task-type :future))
                               :label-ids (ui-state-value task-type :label-ids)
                               :late (boolean (ui-state-value task-type :late))
                               :period (ui-state-value task-type :period)
                               :period-exclude (ui-state-value task-type :period-exclude)
                               :priority (or (ui-state-value task-type :priority) #{})
                               :priority-exclude (ui-state-value task-type :priority-exclude)
                               :rule-id (set (ui-state-value task-type :rule-id))
                               :rule-exclude (ui-state-value task-type :rule-exclude)
                               :signature filter-signature
                               :signatures (:signatures options)
                               :signatures-dropbox-sign true
                               :signatures-other (not (:focus-dropbox-sign-pending options))
                               :signatures-pending true
                               :signatures-complete false
                               :today (boolean (ui-state-value task-type :today))}))
        _ (dorun (map (partial common/disable-exclude-on-unselect! filter-params)
                   [[:period :period-exclude]
                    [:category-id :category-exclude]
                    [:collection-type-id :collection-type-exclude]
                    [:rule-id :rule-exclude]
                    [:assigned-user-id :assigned-user-exclude]
                    [:priority :priority-exclude]]))
        filter-show (or filter-show (atom false))
        filter-watches-enabled (atom @filter-show)
        filter-collection-id (or (:filter-collection-id-atom options) (atom nil))
        _ (reset! filter-collection-id
            (or (:choose-collection-ids options) collection-id (ui-state-value task-type :collection-id)))
        report-mode-atom (or report-mode-atom (atom false))
        report-template-group-id (atom (or (ui-state-value task-type :report-template-group-id) nil))
        report-selected-step-index (atom nil)
        report-next-only (atom (or (ui-state-value task-type :report-next-only) false))
        report-current-period-only (atom (or (ui-state-value task-type :report-current-period-only) false))
        show-steps (or (:show-steps-atom options) (atom false))
        steps-next-to-do (atom (or (ui-state-value task-type :steps-next-to-do) true))
        step-number (atom (or (ui-state-value task-type :step-number) nil))

        template-shapes (subscribe :template-shapes)
        report-selected-template-shape (track! (fn [] (first (filter #(= (str (:id %)) @report-template-group-id) @template-shapes))))
        template-id-subscriber-id-map (track! (fn [] (into {} (map (fn [shape] [(:id shape) (:subscriber_id shape)]) @template-shapes))))

        get-task-list-params (fn []
                               (let [[year quarter] (mapv util/somestr-to-int (split (str (:period @filter-params)) "-"))]
                                 (->
                                  ;; The result must conform with spec/filter-params -- this will be sent to back-end,
                                  ;; with keys translatefrom kebab case to snake case.
                                  @filter-params
                                  (merge
                                   {:collection-id (cond
                                                     (and
                                                      (vector? @filter-collection-id )
                                                      (seq @filter-collection-id)) (mapv util/somestr-to-int @filter-collection-id)
                                                     (number? @filter-collection-id) [@filter-collection-id]
                                                     (not-empty @filter-collection-id) [(util/somestr-to-int @filter-collection-id)]
                                                     :else nil)
                                    :page @current-page
                                    :order @order
                                    :include-subcollections @include-subcollections
                                    :assigned-user-id (into [] (:assigned-user-id @filter-params))
                                    :task-type task-type
                                    :collection-type-id (into [] (mapcat identity (:collection-type-id @filter-params)))
                                    :category-id (into [] (mapcat identity (:category-id @filter-params)))
                                    :rule-id (into [] (:rule-id @filter-params))
                                    :year year
                                    :quarter quarter
                                    :completed-from (and (:completed-from @filter-params) (util/date-to-rfc3339 (:completed-from @filter-params)))
                                    :completed-to (and (:completed-to @filter-params) (util/date-to-rfc3339 (:completed-to @filter-params)))
                                    :priority (into [] (:priority @filter-params))
                                    :steps (when @show-steps (if @steps-next-to-do "n" "c"))
                                    :step-number (when @steps-next-to-do @step-number)
                                    :report @report-mode-atom
                                    :report-next-only @report-next-only
                                    :report-current-period-only @report-current-period-only
                                    :report-template-group-id (util/somestr-to-int (not-empty @report-template-group-id))
                                    :report-template-group-subscriber-id (@template-id-subscriber-id-map (util/somestr-to-int @report-template-group-id))})
                                  (merge (when report-selected-step-index {:report-selected-step-index @report-selected-step-index}))
                                  (dissoc :all :period))))
        _ (some-> (:get-task-list-params-atom options) (reset! get-task-list-params))

        ;; Flattens the results, relevant if @show-steps selected in bulk edit
        get-results (fn [tasks-response]
                      (if @show-steps
                        (flatten (mapcat (fn [item]
                                           (filter identity [(assoc item :steps-item-type :group)
                                                             (map
                                                               ;; Make step look like the whole thing from the perspective
                                                               ;; of model/group-task-name
                                                               ;; Results in task group name being used when presenting
                                                               ;; steps selected in bulk edit
                                                               (fn [step] (assoc step :group_name (:group_name item)))
                                                               (:steps item))]))
                                   (:results tasks-response)))
                        (:results tasks-response)))

        load-tasks (fn [page]
                     (reset! current-page page)
                     (->> (model/task-list (get-task-list-params) (:choose-parent options))
                       (p/map
                         (fn [tasks-response] (reset! tasks tasks-response)
                           (swap! tasks-id-map merge (get-tasks-id-map (get-results tasks-response)))))
                       (process-error)))

        template-shapes (subscribe :template-shapes)
        report-template-schape-count (subscribe :template-shape-chart-count)

        simple-task? (= "simple" task-type)
        alert-active? (boolean (:alert-active options))
        bulk-edit (or (:bulk-edit-atom options) (atom false))
        is-bulk-edit #(= % @bulk-edit)
        select-all (or (:select-all-atom options) (atom false))
        num-selected-tasks (track! #(if @select-all
                                      (- (:count @tasks) (count @chosen-tasks))
                                      (count @chosen-tasks)))
        checked? (fn [occurrence-key chosen-atom] ((if @select-all not identity) (contains? @chosen-atom occurrence-key)))
        load-template-shape-count-fn (fn [] (when @report-template-group-id
                                              (controller/dispatch :template-shape-chart-count :load
                                                                   (get-task-list-params))))
        load-shapes-fn (fn []
                         (if @filter-collection-id
                           (controller/dispatch :collection-details :load
                             {:collection-id @filter-collection-id
                              :on-success (fn [col]
                                            (controller/dispatch :template-shapes :load
                                              {:family-id (:group_id col)
                                               :task-type (case task-type
                                                            "simple" :task
                                                            "compliance" :compliance)}))})
                           (controller/dispatch :template-shapes :load
                             {:task-type (case task-type
                                           "simple" :task
                                           "compliance" :compliance)})))
        filter-change-fn (fn []
                           (load-tasks @current-page)
                           (load-template-shape-count-fn))
        filter-watch-fn (fn [watch-key _ old-value new-value]
                          (if @filter-watches-enabled
                            (if (not= old-value new-value)
                              (do
                                (debug "Filter watch triggered:" watch-key "| watches enabled | value change" (take 2 (clojure.data/diff old-value new-value)))
                                (filter-change-fn))
                              (debug "Filter watch triggered:" watch-key "| watches enabled | value unchanged, not reloading"))
                            (debug "Filter watch triggered:" watch-key "| watches disabled")))
        today (date-time (year (now)) (month (now)) (day (now)))]
    (when-not (:hide-filter @ui-state)
      (when (some util/pytrue?
                  (concat
                   [(when (not= (:include-subcollections @filter-params) @state/include-descendants)
                      (:include-subcollections @filter-params))]
                   (vals
                    (select-keys @filter-params
                                 [:dropbox-sign
                                  :complete
                                  :alert-enabled
                                  :collection-id
                                  :collection-type-id
                                  :category-id
                                  :rule-id
                                  :late
                                  :today
                                  :future
                                  :priority
                                  :period
                                  :label-ids]))))
        (reset! filter-show true)))

    (add-watch filter-show :disable-filter-watches (fn [_ _ _ newstate]
                                                     (when-not newstate (reset! filter-watches-enabled false))))

    (add-watch order :changed-order (fn [& _] (load-tasks @current-page)))
    (add-watch state/include-descendants :include-descendant-tasks #(reset! include-subcollections %4))
    (add-watch filter-params :task-filter-params-watch filter-watch-fn)
    (add-watch filter-collection-id :task-filter-collection-id-watch filter-watch-fn)
    (add-watch include-subcollections :task-filter-include-subcollections-watch (partial diff-watch #(load-tasks @current-page)))
    (add-watch show-steps :task-filter-show-steps-watch filter-watch-fn)
    (add-watch steps-next-to-do :task-filter-steps-next-to-do filter-watch-fn)
    (add-watch step-number :task-filter-step-number filter-watch-fn)
    (add-watch report-template-group-id :report-tempolate-group-id-watch (partial diff-watch filter-change-fn))
    (add-watch report-next-only :report-next-only (partial diff-watch filter-change-fn))
    (add-watch report-current-period-only :report-current-period-only (partial diff-watch filter-change-fn))
    (add-watch report-selected-step-index :report-selected-step-index-watch (partial diff-watch #(load-tasks @current-page)))

    (when-not @tasks
      (load-tasks @current-page))
    (controller/dispatch :collection-details :clear)

    (add-watch report-mode-atom :report-mode-watch
      (fn [_ _ old-value new-value]
        (when (and new-value (not old-value))
          (load-shapes-fn)
          (when @report-template-group-id
            (load-template-shape-count-fn)))
        (when (and old-value (not new-value))
          (reset! report-template-group-id nil))
        (when (not= old-value new-value)
          (load-tasks @current-page))))

    ;; Load shapes and data in case the report mode is initially on (coming from the URL param)
    (when @report-mode-atom
      (load-shapes-fn)
      (when @report-template-group-id
        (load-template-shape-count-fn)))

    (add-watch filter-collection-id :filter-collection-id-shapes #(when @report-mode-atom (load-shapes-fn)))

    (run!
      (let [list-state (merge @filter-params {:collection-id @filter-collection-id
                                              :report-mode @report-mode-atom
                                              :report-template-group-id @report-template-group-id
                                              :report-next-only @report-next-only
                                              :report-current-period-only @report-current-period-only})]

        (util/set-location-params {(filter-param task-type) (util/base64-url-marshal list-state)})
        (swap! ui-state merge
          ;; Convert into :task-filter-* format
          {task-type (into {} (map (fn [[k v]] [(keyword (str "task-filter-" (name k))) v] ) list-state))})))

    (reagent/create-class
      {:component-will-unmount
       ;; state/include-descendants is a module-level atom; the watch must not
       ;; survive this component (#2884). The other watches are on local atoms.
       (fn [_]
         (remove-watch state/include-descendants :include-descendant-tasks))
       :reagent-render
       (fn [& _]
      [:div.o-main-aside
       {:ref (fn [elem]
               (when (and elem @tasks (:focus-dropbox-sign-pending options))
                 (.scrollIntoView elem)))}
       [:main.o-main-aside__main
        (when (some-> report-mode-atom deref)
          [:div.o-media
           [:div.o-flex-align--element-to-right.o-flex-align-items-center.c-report-mode-info
            "Template: "
            [:select {:on-change (fn [event]
                                   (reset! report-template-group-id (event-value event)))
                      :value (str @report-template-group-id)}
             [:option {:value ""} "Choose"]
             (doall (for [group @template-shapes]
                      [:option {:key (:id group) :value (:id group)} (str
                                                                       (model/templategroup-name group)
                                                                       (when (:shape_difference group)
                                                                         (str " (" (:shape_difference group) ")")))]))]
            (when (not-empty @report-template-group-id)
              [:div.u-flex.u-flex--wrap.u-margin-left--xs
               [:label
                [:input (form/set-checked
                         @report-next-only
                         {:type "checkbox"
                          :on-change (fn [_] (swap! report-next-only not))})]
                "Next only"]
               (when (= "compliance" task-type)
                 [:label
                  [:input (form/set-checked
                           @report-current-period-only
                           {:type "checkbox"
                            :on-change (fn [_] (swap! report-current-period-only not))})]
                  "Current period"])])]
           (when @report-template-group-id
             [:div.u-margin-top--xs
              [:div
              (when (= "compliance" task-type)
                [:p "Current period compliances"])
               [:p "Total: " (:compliances_num @report-template-schape-count)]
               [:p "Complete: " (:current_period_complete_compliances_num @report-template-schape-count)]
               [:p "Pending: " (:current_period_incomplete_compliances_num @report-template-schape-count)]]
              (when (seq (:chart_records @report-template-schape-count))
              [chart/bar-chart nil {:selected-step-atom report-selected-step-index
                                   :data-atom report-template-schape-count
                                   :template-shape @report-selected-template-shape}])])])
        (when choose
          [choose-existing-controls nil {:num-selected-tasks @num-selected-tasks
                                         :select-all-atom select-all
                                         :chosen-tasks-atom chosen-tasks
                                         :filter-show-atom filter-show
                                         :save-fn (fn []
                                                    ((:choose-cb options)
                                                     (mapv #(@tasks-id-map %) @chosen-tasks)
                                                     (get-task-list-params)
                                                     @select-all))}])

        [selected-tasks nil {:select-all select-all
                             :num-selected-tasks @num-selected-tasks
                             :task-id-to-name-fn #(model/group-task-name (@tasks-id-map %))
                             :chosen-tasks-atom chosen-tasks}]
        (:choose-extra-component options)

        (let [results (get-results @tasks)]
          (if (seq results)
            [:table.task-list.t-table-redesign {:class (when @bulk-edit "choose")}
             [:thead
              [:tr
               [:th.assignments (orderer order "Collections" "collection_name")]
               [:th.icon]
               [:th.name (orderer order "Name" "name")]
               [:th (orderer order "Category" "category_name")]
               [:th.middle.due-date (orderer order "Due Date" "date")]
               (when-not alert-active?
                 [:th (orderer order "Assigned To" "user")])

               (when simple-task? [:th.priority (orderer order "Priority" "priority")])
               (when (:signatures options)
                 [:<>
                  [:th (orderer order "Type" "signature_scope_name")]
                  [:th "Sign"]])
               (when @bulk-edit
                 [:th.choose
                  (when (is-bulk-edit :filter)
                    [:span
                     [:a {:href "#"
                          :on-click (util/handler (fn []
                                                    (reset! select-all true)
                                                    (reset! chosen-tasks #{})))} "All" ] " | "
                     [:a {:href "#"
                          :on-click (util/handler (fn []
                                                    (reset! select-all false)
                                                    (reset! chosen-tasks #{})))} "None" ]])])
               (when choose
                 [:th.choose "Select"])]]

             [:tbody
              (doall
                (for [task results
                      :let [bulk-edit-checkbox-params (form/set-checked (checked? (:cycle_key task) chosen-tasks)
                                                        (merge {:on-change (fn [ev]
                                                                             (if ((if @select-all not identity) (form/checked? ev))
                                                                               (swap! chosen-tasks conj (:cycle_key task))
                                                                               (swap! chosen-tasks disj (:cycle_key task))))}
                                                          (when-not (is-bulk-edit :filter) {:disabled :disabled})))]]
                  (if @show-steps
                    (if (= :group (:steps-item-type task))

                      ;; Task group row (show steps)
                      [:tr.steps-item-group {:key (str (model/task-key task) "-group")}
                       [:td.assignments [assignment-list (get-assignments task)]]
                       [:td.icon {:class (if (:compliance task) "compliance" "task")}]

                       [:td.name (when-let [group-name (not-empty (:group_name task))] [:p.group-name group-name])
                        (when (> (:comment_count (:counters task)) 0) [:span " " [:span.comment-count (:comment_count (:counters task))]])
                        (when (get-in task [:group :labels])
                          [:div (into [label-component/label] (get-in task [:group :labels]))])]

                       [:td.category (:category_name task)]
                       [:td.middle.due-date]
                       [:td.assigned-to]
                       (when (= "simple" task-type) [:td.priority])
                       (when @bulk-edit
                         [:td.choose.u-text-align-center (when (not @steps-next-to-do) [:input bulk-edit-checkbox-params])])]

                      ;; Step row (show steps)
                      [:tr.steps-item-step {:key (model/task-key task)}

                       [:td {:colspan 4}
                        [:a {:href (path-for :task-details :id (:id task) :complete_by (util/date-string (:date task)))}

                         "Step " (:step_number task) " - " (model/task-name task)] (when (> (:comment_count (:counters task)) 0) [:span " " [:span.comment-count (:comment_count (:counters task))]])]

                       [:td.middle.due-date (util/date-reformat (:date task))]
                       [:td.assigned-to (when-let [user (:user task)] (auth-model/get-full-name user))]
                       (when (= "simple" task-type) [:td.priority (model/priorities (:priority task))])
                       (when @bulk-edit
                         [:td.choose.u-text-align-center
                          (when @steps-next-to-do [:input bulk-edit-checkbox-params])])])

                    [:tr {:key (model/task-key task)}
                     [:td.assignments [assignment-list (get-assignments task)]]
                     [:td.icon {:class (if (:compliance task) "compliance" "task")}]

                     [:td.name (when-let [group-name (not-empty (:group_name task))] [:p.group-name group-name])
                      [:a {:href (str (path-for :task-details :id (:id task) :complete_by (util/date-string (:date task))) (when alert-active? "/?highlighted=1"))}

                       (model/task-name task)] (when (> (:comment_count (:counters task)) 0) [:span " " [:span.comment-count (:comment_count (:counters task))]])
                      (when (get-in task [:group :labels])
                        [:div (into [label-component/label] (map :name (get-in task [:group :labels])))])]

                     [:td.category (:category_name task)]
                     [:td.middle.due-date [:span (when (and alert-active? (after? today (util/parse-datetime (:date task))))
                                                   {:class :u-color--red})
                                           (util/date-reformat (:date task))]]
                    (when-not alert-active? 
                     [:td.assigned-to (when-let [user (:user task)] (auth-model/get-full-name user))])
                     (when (= "simple" task-type) [:td.priority (model/priorities (:priority task))])
                     (when (:signatures options)
                       [:<>
                        [:td.date (:signature_scope_name task)]
                        [:td.date (when (:can_sign task)
                                    [:button {:on-click 
                                              (util/handler
                                                #(.open js/window
                                                   (path-for :sign-link :task-id (:id task) :date (util/date-string (:date task)))
                                                   "_blank"))}
                                     "Sign"])]])
                     (when @bulk-edit
                       [:td.choose.u-text-align-center [:input bulk-edit-checkbox-params]])
                     (when choose
                       [:td.choose.u-text-align-center
                        [:input
                         (form/set-checked (checked? (:cycle_key task) chosen-tasks)
                           (merge
                             {:on-change (fn [ev]
                                           (some-> (:choice-changed-cb options) (apply nil))
                                           (if ((if @select-all not identity) (form/checked? ev))
                                             (swap! chosen-tasks conj (:cycle_key task))
                                             (swap! chosen-tasks disj (:cycle_key task))))}
                             (when @select-all {:disabled "disabled"})))]])])))]

             [tfoot-paginator

              [paginator
               (map (fn [page-number]
                      {:number page-number
                       :on-click (handler #(load-tasks page-number))})
                 (:page_numbers @tasks))
               @current-page
               (when (:has_previous @tasks) (handler #(load-tasks (- @current-page 1))))
               (when (:has_next @tasks) (handler #(load-tasks (+ @current-page 1))))] (cond 
                                                                                        (or simple-task? @bulk-edit) 7 
                                                                                        (:alert-active options) 5
                                                                                        :else 6)
              (-> (:page_numbers @tasks) count (> 1))]]

            (if results
              (condp = task-type
                "simple" [:p.no-results.o-main-aside__main  "No pending tasks."]
                "compliance" [:p.no-results.o-main-aside__main "No pending compliance."]
                "all" [:p.no-results "No pending operations."])
              [:p])))]

       (when @filter-show
         [task-filter
          {:show-collection-filter (not (boolean (:choose-collection-ids options)))
           :collection-top-ancestor-id collection-id
           :signature (:signature options)
           :signatures (:signatures options)
           :dashboard (:dashboard options)
           :bulk-edit-atom bulk-edit
           :chosen-items-atom chosen-tasks
           :select-all-atom select-all
           :num-selected @num-selected-tasks
           :show-steps-atom show-steps
           :steps-next-to-do-atom steps-next-to-do
           :step-number-atom step-number
           :report-mode @report-mode-atom
           :e-boir-filter-show (:e-boir-filter-show options)
           :alert-active (:alert-active options)}
          filter-watches-enabled
          task-type
          filter-collection-id
          filter-params
          include-subcollections
          filter-show])])})))

(defn task-add-or-choose [options collection parent permitted-groups]
  (let [choose-existing (atom false)
        choose-errors (atom nil)]
    (fn []
      [common/standalone-form-redesign
       [:div.c-document-add-or-choose
        [:header {:class (when-not (:is-modal options) "c-header")}
          [:h2 "Add a task"
           (when-let [object (:object parent)]
             (str " from "
                  (get-in object [:collections 0 :name]) ", "
                  (case (get-in object [:linked_object :object_type])
                    ("to" "eo") (if (get-in object [:linked_object :task :group :multi_step])
                                  (str "Step " (get-in object [:linked_object :step_idx]) " - " (model/strip-step-prefix (get-in object [:linked_object :task :name])))
                                  (get-in object [:linked_object :task :name]))
                    "t" (get-in object [:linked_object :group :name])
                    "d" (get-in object [:linked_object :complex_name])
                    (get-in object [:linked_object :name]))))]
          [:aside
           [:b [:label [:input (form/set-checked (not @choose-existing) {:on-change #(swap! choose-existing not)})] "Add new"]] " "
           [:b [:label [:input (form/set-checked @choose-existing {:on-change #(swap! choose-existing not)})] "Choose existing"]]]]

        [:div {:class (when-not (:is-modal options) "standalone-form-redesign__list-or-form u-shadow--bottom ")}
          (if @choose-existing
            [task-list
             (merge
              {:choose                 true
               :choose-cb              (fn [tasks filter-params select-all]
                                         (let [task-ids (mapv #(:id %) tasks)]
                                           (->>
                                            (model/add-task-link filter-params (:parent-type parent) (:parent-id parent) (:complete-by parent) link/type-task task-ids select-all)
                                             (p/map (fn [response] (.go js/history -1)))
                                             (process-error choose-errors))))
               :bulk-edit-atom         (atom nil)
               :choose-collection-ids  (or (:parent-collection-ids parent) (get-in options [:collection :id]))
               :choose-parent          parent
               :choice-changed-cb      #(reset! choose-errors nil)
               :choose-extra-component (when (seq @choose-errors)
                                             [:p.o-media--small.error (:child_id @choose-errors)])}
              options)
             nil
             false
             "simple"
             (atom false)]
            [(if (:is-modal options) :div.regular-form common/standalone-form-redesign)
             [:div
              [task-add (assoc options :hide-header true) collection parent permitted-groups]]])]]])))

(defn rule-filter-multi [rules filter-rules]
  [:ul
   (doall
    (for [rule rules]
      (let [rule-id (:id rule)]
        [:li {:key rule-id}
         [:label
          [:input (set-checked
                   (contains? @filter-rules rule-id)
                   {:on-click (fn [ev]
                                (let [selected (-> ev .-target .-checked)]
                                  (if selected
                                    (swap! filter-rules conj rule-id)
                                    (swap! filter-rules disj rule-id))))})]
          (:name rule)]])))])


(defn rule-filter [options rules filter-rules]
  (let [clear-fn (util/handler #(reset! filter-rules #{}))]
    (when (not-empty @rules)
      [:div.filter-item.o-collapsable {:class (when (:collapsed options) "is-collapsed")}
       [:h3.u-padding-top.u-border-top--light-green.u-cursor--pointer.u-flex
        [:span {:on-click clear-fn} "Rule"]
        (:header-extra options)]
       [chosen-options @filter-rules @rules]
       [:p.u-font-size--smaller.u-flex.u-flex--justify-content-space-between
        (when (:clear options)
          [:a {:href "#"
               :on-click clear-fn} "CLEAR"])
        (:extra-option options)]
       (rule-filter-multi @rules filter-rules)])))

(defn task-filter [options watches-enabled-atom task-type filter-collection-id filter-params filter-include-subcollections filter-show]
  (let [filter-categories (l/derive (l/key :category-id) filter-params)
        filter-rules (l/derive (l/key :rule-id) filter-params)
        filter-collection-types (l/derive (l/key :collection-type-id) filter-params)
        filter-complete (l/derive (l/key :complete) filter-params)
        filter-period (l/derive (l/key :period) filter-params)
        filter-completed-from (l/derive (l/key :completed-from) filter-params)
        filter-completed-to (l/derive (l/key :completed-to) filter-params)
        filter-assigned-users (l/derive (l/key :assigned-user-id) filter-params)
        filter-late (l/derive (l/key :late) filter-params)
        filter-today (l/derive (l/key :today) filter-params)
        filter-future (l/derive (l/key :future) filter-params)
        filter-all (l/derive (l/key :all) filter-params)
        filter-signature (l/derive (l/key :signature) filter-params)
        filter-dropbox-sign (l/derive (l/key :dropbox-sign) filter-params)
        filter-dropbox-sign-pending (l/derive (l/key :dropbox-sign-pending) filter-params)
        filter-e-boir-not-started (l/derive (l/key :e-boir-not-started) filter-params)
        filter-e-boir-pending (l/derive (l/key :e-boir-pending) filter-params)
        filter-e-boir-rejected (l/derive (l/key :e-boir-rejected) filter-params)
        filter-e-boir (l/derive (l/key :e-boir) filter-params)
        filter-e-boir-failed (l/derive (l/key :e-boir-failed) filter-params)
        filter-priority (l/derive (l/key :priority) filter-params)
        filter-labels (l/derive (l/key :label-ids) filter-params)
        filter-alert-enabled (l/derive (l/key :alert-enabled) filter-params)
        filter-alert-active (l/derive (l/key :alert-active) filter-params)

        signatures-dropbox-sign (l/derive (l/key :signatures-dropbox-sign) filter-params)
        signatures-other(l/derive (l/key :signatures-other) filter-params)
        signatures-complete(l/derive (l/key :signatures-complete) filter-params)

        top-collection-id (:collection-top-ancestor-id options)
        initial-colleciton-id @filter-collection-id
        quarters (atom [])
        load-quarters (fn []
                        (->> (model/task-filter-dates task-type @filter-collection-id @filter-include-subcollections (@filter-params :complete))
                             (p/map (fn [response] (reset! quarters []) (reset! quarters response)))
                             (process-error)))
        categories (atom #{})
        load-categories (fn []
                          (->> (model/task-filter-categories task-type @filter-collection-id @filter-include-subcollections)
                               (p/map (fn [response]
                                        (reset! categories response)
                                        (reset-choice filter-categories response #(:id %) #{})))
                               (process-error)))
        rules (atom nil)
        load-rules (fn []
                     (->> (model/rule-list)
                          (p/map (fn [response]
                                   (reset! rules response)
                                   (reset-choice filter-rules response #(:id %) #{})))
                          (process-error)))
        collection-types (atom [])
        load-collection-types (fn []
                                (->> (model/task-filter-collection-types
                                      task-type @filter-collection-id @filter-include-subcollections)
                                     (p/map (fn [response]
                                              (reset! collection-types response)
                                              (reset-choice filter-collection-types response #(:id %) #{})))
                                     (process-error)))
        users-response (atom nil)
        users (atom [])
        load-users (fn []
                     (->> (model/task-filter-assigned-users task-type @filter-collection-id @filter-include-subcollections (@filter-params :complete))
                          (p/map (fn [response]
                                   (reset! users-response response)
                                   (reset! users (concat (when-not (:signatures options)
                                                           [{:id 0
                                                           :first_name "Nobody"}])
                                                            [{:id -1
                                                              :first_name "Inactive users"}] response))))
                          (process-error)))
        load-filter-data (fn []
                           (reset! watches-enabled-atom false)
                           (->> (p/all [(load-quarters)
                                        (load-categories)
                                        (load-collection-types)
                                        (load-users)])
                                (p/map (fn [& _] (reset! watches-enabled-atom true)))))
        group (atom nil)
        load-group  (fn [collection-id]
                      (if collection-id
                        (->> (collection-model/permitted-groups collection-id)
                             (p/map #(reset! group (:id (first %)))))
                        (reset! group nil)))
        bulk-edit (:bulk-edit-atom options)
        chosen-items (:chosen-items-atom options)
        show-steps (:show-steps-atom options)
        steps-next-to-do (:steps-next-to-do-atom options)
        step-number (:step-number-atom options)
        all-steps (atom true)
        filter-values (fn []
                        (let [[year quarter] (split (@filter-params :period) "-")]
                          (merge
                           (util/snakeize-keys
                            (select-keys @filter-params
                                         [:include_subcollections :complete :late :today :future
                                          :signature :dropbox-sign :dropbox-sign-pending :e-boir-not-started
                                          :e-boir-pending :e-boir-rejected :e-boir :e-boir-failed]))
                           {:collection_id (some-> @filter-collection-id js/parseInt vector)
                            :include_subcollections @filter-include-subcollections
                            :assigned_user_id (into [] (@filter-params :assigned-user-id))
                            :task_type task-type
                            :collection_type_id (into [] (mapcat identity (@filter-params :collection-type-id)))
                            :category_id (into [] (mapcat identity (@filter-params :category-id )))
                            :year (some-> year js/parseInt)
                            :completed_from (and (@filter-params :completed-from) (util/date-to-rfc3339 (@filter-params :completed-from)))
                            :completed_to (and (@filter-params :completed-to) (util/date-to-rfc3339 (@filter-params :completed-to)))
                            :priority (into [] (@filter-params :priority))
                            :quarter (some-> quarter js/parseInt)
                            :select @(:select-all-atom options)
                            :cycle_keys (into [] @chosen-items)
                            :steps (if @show-steps (if @steps-next-to-do "n" "c"))
                            :step_number @step-number
                            :label-ids (into [] (@filter-params :label-ids))
                            :alert_enabled (@filter-params :alert-enabled)
                            :alert_active (@filter-params :alert-active)})))
        with-watches-disabled (fn [func]
                                (let [current-state @watches-enabled-atom]
                                  (reset! watches-enabled-atom false)
                                  (func)
                                  (reset! watches-enabled-atom current-state)))
        silent-reset-filters (fn [filter-list]
                               (with-watches-disabled
                                 #(doseq [atom filter-list]
                                    (reset! atom false))))
        container-el (atom nil)
        filter-checkboxes-el (atom nil)
        silent-reset-all (fn []
                           (swap! filter-params merge
                                  (into {} (map (fn [key] [key false])
                                                [:signature :dropbox-sign-pending :dropbox-sign
                                                 :e-boir :e-boir-not-started :e-boir-pending
                                                 :e-boir-rejected :e-boir-failed])))
                           (adjust-checkboxes @container-el @filter-checkboxes-el))
        labels (subscribe :label-list)
        load-labels (fn []
                      (let [has-perms-in-family (and @group (has-any-of-perms-in-family @group #{:can_view_task :can_view_compliance}))
                            family-id  (when has-perms-in-family @group)]
                        (controller/dispatch :label-list :load {:family-id family-id 
                                                                :object-type admin-model/object-type-task-template-group})))
        collapsed-default (not (common/mobile?))
        collapsed? (atom {:alert collapsed-default
                          :collection collapsed-default
                          :collection-type collapsed-default
                          :category collapsed-default
                          :rule collapsed-default
                          :user collapsed-default
                          :due collapsed-default
                          :priority collapsed-default
                          :date collapsed-default})
        toggle-collapsed (fn [key]
                           (swap! collapsed? assoc key (not (get @collapsed? key))))
        collapsed-all? (atom true)
        toggle-collapsed-all (fn [value]
                               (swap! collapsed? (fn [c-map]
                                                   (zipmap (keys c-map) (repeat value)))))
        clear-trigger-collection (atom false)
        clear-trigger-date (atom false)
        clear-all (fn []
                    (swap! filter-params merge
                      {:alert-active false,
                       :alert-enabled false,
                       :alert-exclude nil,
                       :all false,
                       :assigned-user-exclude false,
                       :category-exclude nil,
                       :category-id #{},
                       :collection-type-exclude false,
                       :collection-type-id #{},
                       :complete false,
                       :completed-from nil,
                       :completed-to nil,
                       :dropbox-sign false,
                       :dropbox-sign-pending false,
                       :due-exclude nil,
                       :e-boir false,
                       :e-boir-failed false,
                       :e-boir-not-started false,
                       :e-boir-pending false,
                       :e-boir-rejected false,
                       :future false,
                       :label-ids [],
                       :late false,
                       :period nil,
                       :period-exclude nil,
                       :priority #{},
                       :priority-exclude nil,
                       :rule-exclude false,
                       :rule-id #{},
                       :signatures-dropbox-sign true
                       :signatures-other true
                       :signatures-pending true
                       :signatures-complete false
                       :today false}
                      (when-not (:signatures options)
                        {:signature false})
                      (when-not (:dashboard options)
                        {:assigned-user-id #{}}))
                    (swap! clear-trigger-collection not)
                    (swap! clear-trigger-date not))]
    (controller/dispatch :label-list :clear)
    (load-rules)
    (load-filter-data)
    (add-watch filter-collection-id :filter-collection-id-task-filter  #(when @watches-enabled-atom (load-filter-data)))
    (add-watch filter-collection-id :filter-collection-id-load-group  (fn [_ _ _ new-filter-collection-id] (load-group new-filter-collection-id)))
    (add-watch filter-include-subcollections :include-subcollections-task-filter #(when @watches-enabled-atom (load-filter-data)))
    (add-watch filter-complete :complete-task-filter (fn [& args]
                                                       (when @watches-enabled-atom
                                                         (when-not @filter-period
                                                           (load-quarters)) (->>
                                                                              (load-users)
                                                                              (p/map #(reset-choice filter-assigned-users @users :id #{})))) ))
    (add-watch filter-period :filter-period-task-filter (fn [_ _ old-state new-state]
                                                          (when @watches-enabled-atom
                                                            (when (and old-state (not new-state)) @filter-period
                                                                  (load-quarters)))))
    (add-watch group :filter-collection-id-label-filter #(load-labels))

    (fn [{:keys [report-mode] :as options} & _]
      [sidebar-rounded (case @bulk-edit
                         :global-form [bulk-edit-form (merge options {:name "compliance"
                                                                      :filter-values filter-values
                                                                      :filter-collection-id-atom filter-collection-id
                                                                      :group group})
                                       bulk-edit-global-form]
                         :dates-form [bulk-edit-form (merge options {:name "date" :filter-values filter-values
                                                                     :group group})
                                      bulk-edit-date-form]
                         :date-form [bulk-edit-form (merge options {:name "date" :filter-values filter-values
                                                                    :group group})
                                     bulk-edit-date-form]
                         :user-form [bulk-edit-form (merge options {:name "user"
                                                                    :filter-values filter-values
                                                                    :filter-collection-id-atom filter-collection-id
                                                                    :filter-include-subcollections-atom filter-include-subcollections
                                                                    :group group})
                                     bulk-edit-user-form]
                         [:div])
       ;; :div (when-not (contains? #{nil :filter} @bulk-edit) {:class "u-display--none"})
       [:div.o-media--margin {:ref (fn [el] (when el (reset! container-el el)))
                              :class (when (common/mobile?) :mobile)}
        [:div.filter-top.u-margin-bottom
         [common/filter-top filter-show clear-all toggle-collapsed-all collapsed-all?]
         [:span.filter-checkboxes {:ref (fn [el] (if el
                                                   (do
                                                     (reset! filter-checkboxes-el el)
                                                     (adjust-checkboxes @container-el el)
                                                     (common-event/set-event-listener :task-filter-boxes :resize
                                                       (fn [] (adjust-checkboxes @container-el el))))
                                                   ;; React calls the ref with nil on unmount (#2884)
                                                   (common-event/remove-event-listener :task-filter-boxes :resize))) }
          (if (:signatures options)
            [:<>
             [:label.filter-checkbox.u-padding-right--xs
              [:input.complete
               (form/set-checked
                 @signatures-dropbox-sign
                 {:type "checkbox"
                  :on-change (fn [ev]
                               (reset! signatures-dropbox-sign (if @signatures-other (checked? ev) true)))})]
              "Dropbox Sign"]
             [:label.filter-checkbox.u-padding-right--xs
              [:input.complete
               (form/set-checked
                 @signatures-other
                 {:type "checkbox"
                  :on-change (fn [ev]
                               (reset! signatures-other (if @signatures-dropbox-sign (checked? ev) true)))})]
              "Other"]
             [:label.filter-checkbox.u-padding-right--xs
              [:input.complete
               (form/set-checked
                 @signatures-complete
                 {:type "checkbox"
                  :on-change (fn [ev]
                               (reset! signatures-complete (checked? ev)))})]
              "Signed"]]
            [:<>
             (when @filter-collection-id
               [:label.filter-checkbox.u-padding-right--xs
                [:input.include-subcollections
                 (form/set-checked
                   @filter-include-subcollections
                   {:type "checkbox"
                    :on-change (fn [ev] (swap! filter-include-subcollections not))})]
                "Subcollections"])

             (when-not (or (:signature options) @filter-dropbox-sign @filter-e-boir)
               [:label.filter-checkbox.u-padding-right--xs
                [:input.complete
                 (form/set-checked
                   @filter-signature
                   {:type "checkbox"
                    :on-change (fn [ev]
                                 (silent-reset-all)
                                 (reset! filter-signature (checked? ev)))})]
                "Signatures"])

             (when-not (or @filter-signature @filter-e-boir)
               [:label.filter-checkbox.u-padding-right--xs
                [:input.complete
                 (form/set-checked
                   @filter-dropbox-sign
                   {:type "checkbox"
                    :on-change (fn [ev]
                                 (silent-reset-all)
                                 (reset! filter-dropbox-sign (checked? ev)))})]
                "Dropbox Sign"])
             (when @filter-dropbox-sign
               [:label.filter-checkbox.u-padding-right--xs
                [:input.complete
                 (form/set-checked
                   @filter-dropbox-sign-pending
                   {:type "checkbox"
                    :on-change (fn [ev]
                                 (silent-reset-filters [filter-complete])
                                 (reset! filter-dropbox-sign-pending (checked? ev)))})]
                "Pending"])

             (when (:e-boir-filter-show options)
               (when-not (or @filter-signature @filter-dropbox-sign)
                 [:label.filter-checkbox.u-padding-right--xs
                  [:input (set-checked @filter-e-boir
                            {:on-click (fn [ev]
                                         (silent-reset-all)
                                         (reset! filter-e-boir (checked? ev)))})]
                  "E-File BOIR"]))
             (when @filter-e-boir
               [:span
                [:label.filter-checkbox.u-padding-right--xs
                 [:input (set-checked @filter-e-boir-not-started {:on-click (fn [ev]
                                                                              (silent-reset-filters [filter-complete])
                                                                              (reset! filter-e-boir-not-started (checked? ev)))})] "Not started"]
                [:label.filter-checkbox.u-padding-right--xs
                 [:input (set-checked @filter-e-boir-pending {:on-click (fn [ev]
                                                                          (silent-reset-filters [filter-complete])
                                                                          (reset! filter-e-boir-pending (checked? ev)))})] "Pending"]
                [:label.filter-checkbox.u-padding-right--xs
                 [:input (set-checked @filter-e-boir-rejected {:on-click (fn [ev]
                                                                           (silent-reset-filters [filter-complete])
                                                                           (reset! filter-e-boir-rejected (checked? ev)))})] "Rejected"]
                [:label.filter-checkbox.u-padding-right--xs
                 [:input (set-checked @filter-e-boir-failed {:on-click (fn [ev]
                                                                         (silent-reset-filters [filter-complete])
                                                                         (reset! filter-e-boir-failed (checked? ev)))})] "Failed"]])
             (when-not report-mode
               [:label.filter-checkbox.u-padding-right--xs
                [:input.complete
                 (form/set-checked
                   @filter-complete
                   {:type "checkbox"
                    :on-change (fn [ev]
                                 (silent-reset-filters [filter-dropbox-sign-pending filter-e-boir-not-started filter-e-boir-pending filter-e-boir-rejected filter-e-boir-failed])
                                 (reset! filter-complete (checked? ev)))})]
                (if (or @filter-signature @filter-dropbox-sign) "Signed"
                    (if @filter-e-boir "Accepted" "Complete"))])])]]
        
        (when (= :filter @bulk-edit)
          [:div.filter-item.user-filter.u-padding-bottom
           [:h3.u-padding-top.u-border-top--light-green "Bulk edit"]
           [:ul
            [:li [:label [:input (form/set-checked @show-steps {:on-change (fn [] (swap! show-steps not))})] "Show steps"]]
            (when @show-steps
              [:div
               [:li [:label [:input (form/set-checked @steps-next-to-do {:on-change (fn []
                                                                                      (with-watches-disabled #(reset! all-steps true))
                                                                                      (reset! steps-next-to-do true))})] "Next to-do steps"]]
               [:li [:label [:input (form/set-checked (not @steps-next-to-do) {:on-change (fn []
                                                                                            (with-watches-disabled #(reset! step-number nil))
                                                                                            (reset! steps-next-to-do false))})]
                     "Occurrences with all steps incomplete"]]
               (when @steps-next-to-do
                 [:li.u-margin-top
                  [:label [:input (form/set-checked @all-steps {:on-change (util/handler (fn []
                                                                                           (with-watches-disabled #(do
                                                                                                                     (reset! all-steps true)
                                                                                                                     (reset! chosen-items #{})))
                                                                                           (reset! step-number nil)))})] "All steps"]  " "
                  [:label [:input (form/set-checked (not @all-steps) {:on-change (fn []
                                                                                   (with-watches-disabled
                                                                                     #(do (reset! chosen-items #{})
                                                                                          (reset! all-steps false)))
                                                                                   (reset! step-number 1))})] "Step number"]
                  (when-not @all-steps [step-number-chooser step-number])])])]
           [:div.u-margin-top--xs
            (let [button-options (fn [opts] (merge (when (= (:num-selected options) 0) {:disabled :disabled
                                                                                        :title "Select one or more items to edit"}) opts))]
              (if @show-steps
                (if (not @steps-next-to-do)
                  [:button.u-margin-right--xs (button-options {:on-click (util/handler #(reset! bulk-edit :dates-form))}) "Edit dates"]
                  [:span
                   [:button.u-margin-right--xs (button-options {:on-click (util/handler #(reset! bulk-edit :user-form))}) "Edit user"]
                   [:button.u-margin-right--xs (button-options {:on-click (util/handler #(reset! bulk-edit :date-form))}) "Edit date"]])
                [:button.u-margin-right--xs (button-options {:on-click (util/handler #(reset! bulk-edit :global-form))}) "Edit compliance"]))
            [:button.u-margin-right--xs {:on-click (util/handler (fn []
                                                                   (reset! bulk-edit nil)
                                                                   (reset! steps-next-to-do true)
                                                                   (reset! step-number nil)
                                                                   (reset! chosen-items #{})
                                                                   (reset! show-steps false)))} "Cancel"]]])
        
        (when-not (:alert-active options)
          [:div.u-margin-bottom.u-padding-top.u-border-top--light-green
           [:span.filter-checkboxes.u-nowrap
            [:label
             [:a.u-font-size--larger.u-bold.u-padding-right--xs
              {:href "#"
               :on-click (util/handler (fn []
                                         (reset! filter-alert-enabled false)
                                         (reset! filter-alert-active false)))} "Alert"]]
            [:label.filter-checkbox.u-border-right--light-green.u-padding-right--xs
             [:input (set-checked @filter-alert-enabled {:on-click (fn [ev] (reset! filter-alert-enabled (checked? ev)))})] "Enabled"]
            [:label.filter-checkbox
             [:input (set-checked @filter-alert-active {:on-click (fn [ev]
                                                                    (when (and (checked? ev) (not @filter-alert-enabled))
                                                                      (reset! filter-alert-enabled (checked? ev)))
                                                                    (reset! filter-alert-active (checked? ev)))})] "Active"]]])
        (when (:show-collection-filter options)
          [nested-select filter-collection-id {:initial-id initial-colleciton-id
                                               :top-id top-collection-id
                                               :limit-ancestors true
                                               :label "Collection"
                                               :children-loader collection-model/collection-list-promise
                                               :child-filter-pred (fn [child]
                                                                    (if @filter-collection-id
                                                                      true
                                                                      (or (not report-mode) (collection-model/has-report-mode-enabled (:id child)))))
                                               :ancestors-loader collection-model/collection-ancestors
                                               :sizer default-select-sizer
                                               :clear true
                                               :collapsed (:collection @collapsed?)
                                               :collapse-fn (fn []
                                                              (toggle-collapsed :collection))
                                               :clear-trigger clear-trigger-collection
                                               :green-box true
                                               :mobile (common/mobile?)}])
        [common/collection-type-filter
         {:extra-option [filter-exclude {:disabled (not (seq @filter-collection-types))} (l/derive (l/key :collection-type-exclude) filter-params)] 
          :header-extra [:a.o-collapsable__expander {:on-click #(toggle-collapsed :collection-type)}]
          :collapsed (:collection-type @collapsed?)
          :clear true}
         collection-types filter-collection-types]

        (when-not report-mode
          [common/category-filter
           {:extra-option [filter-exclude {:disabled (not (seq @filter-categories))} (l/derive (l/key :category-exclude) filter-params)]
            :header-extra [:a.o-collapsable__expander {:on-click #(toggle-collapsed :category)}]
            :collapsed (:category @collapsed?)
            :clear true}
           categories filter-categories])
        (when (and (not report-mode) (contains? #{"all" "compliance"} task-type))
          [common/rule-filter
           {:extra-option [filter-exclude {:disabled (not (seq @filter-rules))} (l/derive (l/key :rule-exclude) filter-params)]
            :collapsed (:rule @collapsed?)
            :header-extra [:a.o-collapsable__expander {:on-click #(toggle-collapsed :rule)}]
            :clear true}
           rules filter-rules])
        (when-not (or (:alert-active options) (and (:dashboard options) (:signatures options)))
          [common/user-filter
           (merge
             {:header-extra [:a.o-collapsable__expander {:on-click #(toggle-collapsed :user)}]
              :collapsed (:user @collapsed?)
              :clear true}
             (when-not (:signatures options)
               {:extra-option [filter-exclude {:disabled (not (seq @filter-assigned-users))} (l/derive (l/key :assigned-user-exclude) filter-params)]}))
           users filter-assigned-users])
        
        [:div.o-collapsable {:class (when (:due @collapsed?) "is-collapsed")} 
         (let [filter-due (atom nil)
               clear-fn (util/handler (fn [] (swap! filter-params merge {:late false :today false :future false :due-exclude false})))]
           [:div
            [:h3.u-padding-top.u-border-top--light-green.u-cursor--pointer.u-flex
             [:span {:on-click clear-fn} "Due"] [:a.o-collapsable__expander {:on-click #(toggle-collapsed :due)}]]
            [:span.u-font-size--smaller.u-color--secondary
             (when @filter-late "Late ")
             (when @filter-today "Today ")
             (when @filter-future "Future")]
            [:ul
             (let [has-value (or
                               @filter-late
                               @filter-today
                               @filter-future)]
               [:span.u-font-size--smaller.u-flex.u-flex--justify-content-space-between
                [disable [:a {:href "#"
                              :on-click clear-fn} "CLEAR"]
                 (not has-value)]
                [filter-exclude {:disabled (not has-value)} (l/derive (l/key :due-exclude) filter-params)]])
             (if (common/mobile?)
               [:div.u-border--green-rounded (common/multi-mobile-filter {:reset-value-atoms true} 
                                               [{:id 1 :name "Late" :value-atom filter-late} 
                                                {:id 2 :name "Today" :value-atom filter-today} 
                                                {:id 3 :name "Future" :value-atom filter-future}] filter-due)]
               [:div.u-border--green-rounded
                [:li [:label [:input (set-checked @filter-late {:on-click (fn [ev] (reset! filter-late (checked? ev)))})] "Late"]]
                [:li [:label [:input (set-checked @filter-today {:on-click (fn [ev] (reset! filter-today (checked? ev)))})] "Today"]]
                [:li [:label [:input (set-checked @filter-future {:on-click (fn [ev] (reset! filter-future (checked? ev)))})] "Future"]]])]])]

        (when-not (= "compliance" task-type)
          [:div.o-collapsable {:class (when (:priority @collapsed?) "is-collapsed")}
           (let [clear-fn (util/handler #(reset! filter-priority #{}))]
             [:div
              [:h3.u-padding-top.u-border-top--light-green.u-cursor--pointer.u-flex
               [:span {:on-click clear-fn}
                "Priority"]
               [:a.o-collapsable__expander {:on-click #(toggle-collapsed :priority)}]]
              [:span.u-font-size--smaller.u-color--secondary (->> @filter-priority (map model/priorities) (str/join ", "))]
              [:ul
               [:div.u-font-size--smaller.u-flex.u-flex--justify-content-space-between
                [:a {:href "#"
                     :on-click clear-fn} "CLEAR"]
                [filter-exclude {:disabled (not (seq @filter-priority))} (l/derive (l/key :priority-exclude) filter-params)]]
               (if (common/mobile?)
                 (common/multi-mobile-filter nil (map (fn [[id name]] {:id id :name name}) model/priorities) filter-priority)
                 (doall (for [[priority priority-name] model/priorities]
                          [:li {:key priority} [:label [:input (set-checked (contains? @filter-priority priority)
                                                                 {:on-click (fn [ev]
                                                                              (let [selected (-> ev .-target .-checked)]
                                                                                (if selected
                                                                                  (swap! filter-priority conj priority)
                                                                                  (swap! filter-priority disj priority))))})]
                                                priority-name]])))]])])
        
        [common/date-filter
         {:extra-option [filter-exclude {:disabled (not @filter-period)} (l/derive (l/key :period-exclude) filter-params)]
          :collapsed (:date @collapsed?)
          :collapse-fn (fn []
                         (toggle-collapsed :date))
          :clear-trigger clear-trigger-date}
         quarters filter-period]

        (when @filter-complete
          [:div.date-filter.u-padding-top.u-border-top--light-green.u-padding-bottom
           [:span.u-padding-right--xs 
            [:b.u-padding-right--xs "Completed from"] 
            [datetimepicker {:time-atom filter-completed-from
                             :show-time-picker false
                             :green-box true}]]
           [:span
            [:b.u-padding-right--xs "Completed to"] 
            [datetimepicker {:time-atom filter-completed-to
                             :show-time-picker false
                             :green-box true}]]])
        (when (seq (:results @labels))
          [label-component/filter-by-label {:label-ids-atom filter-labels 
                                            :title "Labels"
                                            :line-class "u-border-top--light-green"
                                            :select-styles :second}])]])))

(defn step-number-chooser [step-number-atom]
  [:span " "
   [:button.c-round-button {:on-click (util/handler #(if (> @step-number-atom 1) (swap! step-number-atom dec)))} "<"] " "
   @step-number-atom " "
   [:button.c-round-button {:on-click (util/handler #(swap! step-number-atom inc))} ">"]])

(defn bulk-edit-date-form [options]
  (let [errors (atom {})
        complete-by (atom nil)]
    (run!
      (reset! (:data-atom options)
              {:edit_type "date"
               :complete_by (some-> @complete-by util/local-date-time-to-date-string)
               :has-data (boolean @complete-by)}))
    (fn []
      [:div
       [:fieldset
        [:dl
          [:dt "Complete by"]
          [:dd
           [pikaday/date-selector {:date-atom complete-by}]
           [:span.error (:complete_by @errors "")]]]]])))

(defn bulk-edit-user-form [options]
  (let [errors (atom {})
        users (atom nil)
        assign-to (atom nil)]
    (run!
      (reset! (:data-atom options)
              {:edit_type "user"
               :assigned_user_id (some-> @assign-to js/parseInt)
               :has-data (boolean @assign-to)}))
    (->> (model/task-filter-assignable-users :compliance @(:filter-collection-id-atom options) @(:filter-include-subcollections-atom options))
         (p/map #(reset! users %))
         (process-error))
    (fn []
      [:div
       [:fieldset
        [:dl
         [:dt "Assign to"]
         [:dd [auth-component/user-chooser-fuzzy nil @users assign-to] [:span.error (:assigned_user_id @errors "")]]]]])))

(defn bulk-edit-global-form [options]
  (let [category (atom nil)
        rule (atom nil)
        group (atom nil)
        assignments (atom (get-initial-ui-assignments nil))
        errors (atom {})
        primary-collection-id-global (atom nil)
        include-inactive-collections (atom false)
        filter-collection-id (:filter-collection-id-atom options)
        label (atom nil)
        load-labels (fn []
                      (controller/dispatch :label-list :load {:family-id @group
                                                              :object-type admin-model/object-type-task-template-group
                                                              :errors-atom errors}))]
    (controller/dispatch :label-list :clear)
    (load-labels)
    (run!
     (reset! (:data-atom options)
             {:edit_type "global"
              :category (some-> @category js/parseInt)
              :rule (when-not (contains? #{nil "ignore"} @rule) (js/parseInt @rule))
              :group (some-> @group js/parseInt)
              :collection_id (mapv js/parseInt (get-collection-ids @assignments))
              :main_collection_id (some-> (:collection (first (filterv (fn [assignment] (:main assignment)) @assignments))) js/parseInt)
              :has-data (or
                          @category
                          (not (contains? #{nil "ignore"} @rule))
                          (seq (get-collection-ids @assignments))
                          (seq @label))
              :label @label}))
    (->> (collection-model/permitted-groups @filter-collection-id )
         (p/map #(reset! group (:id (first %)))))
    (fn []
      [:div
       (when @group
         [:fieldset.u-margin-left--xs
          [:dl
           [collection-field-header include-inactive-collections]
           [:dd
            [assignments-edit-notable-redesign {:include-inactive-atom include-inactive-collections} assignments errors nil (catom #{}) group
             primary-collection-id-global]]]
          [:dl
           [:dt "Service Category"]
           [:dd [category-component/category-chooser-fuzzy nil group category]]]
          [:dl
           [:dt "Assign label"]
           [:dd
            [label-component/label-chooser-multi (merge {:allow-empty true 
                                                         :keep-unchanged true}
                                                   (when (auth-model/is-user-family-admin @group)
                                                     {:allow-create-new true})) @group label]
            [:span.error (:label-chooser @errors "")]]]
          [:dl
           [:dt "Repeat"]
           [:dd
            [rule-chooser {:recurring-object-type :compliance
                           :must-repeat true
                           :allow-no-choice true
                           :disabled false} rule]]]])])))

(defn bulk-edit-form [options component]
  (let [form-data (atom {})
        format-label-params (fn [labels]
                              (if (and
                                    (= 1 (count labels))
                                    (contains? #{"delete" "unchanged"} (:id (first labels))))
                                {:delete_labels (= "delete" (:id (first labels)))}
                                {:label_id (into []
                                             (for [label labels
                                                   :when (not (:new label))]
                                               (:id label)))
                                 :label_name (filterv identity (map :name labels))}))
        set-label-params (fn [form-data]
                           (let [label (:label form-data)]
                             (if label 
                               (merge form-data (format-label-params label))
                               form-data)))]
    (fn [options component]
      [:div.filter-item.user-filter.u-margin-top--xs
       [:h3.u-margin-bottom.u-border-bottom "Bulk edit " (:name options)]
       [component (merge options {:data-atom form-data})]      
       [:p
        [:button
         (merge {:on-click
                 (util/handler (fn []
                                 (when (js/confirm (str (:num-selected options) " items will be affected. Continue?"))
                                   (->> (model/bulk-edit @(:group options) ((:filter-values options)) (dissoc (set-label-params @form-data) :has-data :label))
                                        (p/map (fn [_]
                                                 (set-flash :success "Bulk edit is in progress. You can see the status of its completion in the admin panel.")
                                                 (reset! (:bulk-edit-atom options) :filter)))
                                        (process-error)))))}
                (when-not (:has-data @form-data) {:disabled :disabled})) "Save"]
        [:button {:on-click (util/handler #(reset! (:bulk-edit-atom options) :filter))} "Back"]] ] )))

(defn main-task-list [task-type]
  (let [filter-show (atom (or (ui-state-value task-type :report-mode) false))
        bulk-edit (atom nil)
        show-steps (atom false)
        chosen-tasks (atom #{})
        select-all (atom false)
        filter-collection-id (atom nil)
        report-mode (atom (or (ui-state-value task-type :report-mode) false))
        get-task-list-params (atom nil)]
    (add-watch report-mode :report-mode-filter-show
      (fn [_ _ oldv newv]
        (when (and (not= oldv newv) newv)
          (reset! filter-show true))))
    (fn []
      [:div {:class (if @filter-show "with-filter" "")}

       [common/header-tab-wrapper
        (case task-type
          "simple" [:span [:img.tab-header {:src "/static/img/icons/task-blue.svg"}] (str "Tasks" (when @report-mode " Report"))]
          "compliance" [:span [:img.tab-header {:src "/static/img/icons/compliance-blue.svg"}] (str "Compliance" (when @report-mode " Report"))]
          "all" [:span [:img.tab-header {:src "/static/img/icons/compliance-blue.svg"}] "Tasks & Compliance"])

        [:div
         [task-list {:get-task-list-params-atom get-task-list-params
                     :filter-collection-id-atom filter-collection-id
                     :bulk-edit-atom bulk-edit
                     :show-steps-atom show-steps
                     :chosen-tasks-atom chosen-tasks
                     :select-all-atom select-all
                     :report-mode-atom report-mode
                     :e-boir-filter-show (and (= task-type "simple") (some true? (vals (:boir_efile_enabled @state/family-settings))))} nil nil task-type filter-show]]

        (condp = task-type
          "simple" [task-list-buttons {:filter-collection-id-atom filter-collection-id} nil filter-show report-mode]
          "compliance" [compliance-list-buttons {:get-task-list-params-atom get-task-list-params
                                                 :filter-collection-id-atom filter-collection-id
                                                 :show-steps-atom show-steps
                                                 :chosen-tasks-atom chosen-tasks
                                                 :select-all-atom select-all} nil filter-show bulk-edit report-mode]
          "all" [back-button])]])))

(defn common-task-list [_ collection-id assigned-to-current-user filter-show]
  (let [show-types (atom {:simple (has-perm :can_view_task)
                          :compliance (has-perm :can_view_compliance)
                          :event (has-perm :can_view_event)
                          })
        toggle-type (fn [show-types-map atype]
                      (let [current-value (show-types-map atype)
                            num-checked (count (filter identity (vals show-types-map)))]
                        (if (or (not current-value) (> num-checked 1))
                          (assoc show-types-map atype (not current-value))
                          show-types-map)))
        operations (atom [])
        next-from (atom nil)
        include-subcollections (atom @state/include-descendants)
        _ (add-watch state/include-descendants :include-descendant-operations #(reset! include-subcollections %4))
        load-operations (fn [from]
                          (->> (model/operations-list collection-id @include-subcollections from
                                                      (into [] (for [[k,v] @show-types :when v] (name k)))
                                                      (when assigned-to-current-user (vector (api/get-auth-info :user-id))))
                               (p/map (fn [operations-response]
                                        (if from
                                          (swap! operations concat (:operations operations-response))
                                          (reset! operations (:operations operations-response)))
                                        (reset! next-from (:next_from operations-response))))
                               (process-error)))
        _ (add-watch include-subcollections :operations-include-subcollections
            (partial diff-watch (fn []
                                  (reset! next-from nil)
                                  (load-operations @next-from)) ))
        handle-show-types-change (fn [operation-type]
                                   (swap! show-types toggle-type operation-type)
                                   (load-operations nil))]

    (load-operations @next-from)

    (reagent/create-class
      {:component-will-unmount
       ;; state/include-descendants is a module-level atom; the watch must not
       ;; survive this component (#2884). include-subcollections is local.
       (fn [_]
         (remove-watch state/include-descendants :include-descendant-operations))
       :reagent-render
       (fn []
      [:div
       (when @filter-show
         [:div.filter.task-filter
          (when (some identity (map has-perm [:can_view_task :can_view_compliance :can_view_event]))
            [:div.o-media--medium
             (perm :can_view_task
                   [:label [:input.complete
                            (form/set-checked (:simple @show-types) {:on-change #(handle-show-types-change :simple)})] "Tasks"])
             (perm :can_view_compliance
                   [:label [:input.complete
                            (form/set-checked (:compliance @show-types) {:on-change #(handle-show-types-change :compliance)})] "Compliance"])
             (perm :can_view_event
                   [:label [:input.complete (form/set-checked (:event @show-types) {:on-change #(handle-show-types-change :event)})] "Events"])])])

       [operations-list {:load-operations load-operations} @operations @next-from]])})))

(defn task-submit [options task errors parent form-data]
  (if-let [submit-fn (:submit-fn options)]
    (submit-fn form-data errors)
    (->>
      ((if task
         (partial model/single-task-update (:id task form-data))
         model/task-add)
       form-data)
      (p/map (fn [task-data]
               (set-flash :success "Task saved")
               (if-let [success-cb (:success-cb options)]
                 (success-cb)
                 (if (get-in task-data [:perms :can_view])
                   (set-location
                     (str "#/task/details/" (:id task-data) "/" (:complete_by form-data) "/"))
                   (when parent
                     (util/set-location (link/parent-info-url parent)))))))
      (process-error errors) )))

(defn task-add [options collection parent permitted-groups]
  (let [task-type (atom (or (:task-type options) :task))
        action-type (cond
                      (:action-type options) (atom (:action-type options))
                      (:action-type-atom options) (:action-type-atom options)
                      :else (atom :simple))
        opts (merge options
               {:task-type task-type
                :action-type action-type})]
    (fn []
       [:section {:class (when-not (:is-modal options) :redesign.u-shadow--bottom)}
       (when-not (:hide-header options)
         [header
          :title (str "Add a new " (when (and (not= @task-type :compliance) (= :multi @action-type)) "multi step") " "
                      (task-type-name task-type) (if collection (str " to " (:name collection))))
          :simple? true])

       (case @action-type
         :simple [simple-task-edit opts collection nil parent permitted-groups]
         :multi [multistep-task-add opts collection parent permitted-groups]
         :apply [apply-from-template opts apply-from-template-collection-chooser collection parent permitted-groups])])))

(defn show-task-add-modal [options]
  (reset! state/task-add-modal (merge options {:enabled true :lower-layer true})))

(defn show-task-add-modal-preselected-collection [options collection-id]
  (->>
   (p/all
    [(collection-model/collection-details collection-id)
     (collection-model/permitted-groups collection-id)])
   (p/map
    (fn [[collection permitted-groups]]
      (show-task-add-modal
        (merge options
          {:collection       collection
           :permitted-groups (filter-families permitted-groups :can_add_task)}))))
   (process-error)))

(defn hide-task-add-modal []
  (reset! state/task-add-modal {:enabled false}))

(defn task-add-modal []
  [modal
   [task-add
    (merge
      {:back-cb hide-task-add-modal
       :success-cb hide-task-add-modal }
      @state/task-add-modal
      {:task-type   :task
       :action-type (:action-type @state/task-add-modal)
       :is-modal true})
    (:collection @state/task-add-modal)
    nil
    (:permitted-groups @state/task-add-modal)]
   state/task-add-modal])

(defn task-type-name [task-type-atom]
  (case @task-type-atom
    :task "task"
    :compliance "compliance"))

(defn task-edit [task add-new-step permitted-groups]

  [:section.redesign.u-shadow--bottom
   [header
    :supertitle (get-in task [:task_collections 0 :collection :ancestors 0 :name])
    :aside-title "task"
    :title [:span [:span.u-font-weight--lighter "Edit task: "] (model/group-task-name task)]
    :subsubtitle  (when-let [category (get-in task [:category])] 
                    [:span 
                     [:p.u-font-size--larger [:span.type-circle [:span (:type category)]] [:span (:name category)]]
                     (when (:labels task)
                       [:p [label-component/label (get-in task [:labels 0 :name])]])])
    :aside-subtitles (list ["Created" (when-let [date (get-in task [:created_at])] (util/date-reformat date))]
                           ["Modified" (when-let [date (get-in task [:updated_at])] (util/date-reformat date))])]

   [simple-task-edit nil nil task nil permitted-groups]])


(defn action-type-chooser [task-type action-type task parent]
  (let [type-name (task-type-name task-type)]
    [:section.o-margin-elements--lg
     (when (= :task @task-type)
       [:label [:input (set-checked
                         (= @action-type :simple)
                         {:type :checkbox
                          :on-change (fn [ev]
                                       (when (checked? ev) (reset! action-type :simple)))})]
        "Single-step " type-name])
     [:label [:input (set-checked
                       (= @action-type :multi)
                       {:type :checkbox
                        :on-change (fn [ev]
                                     (when (checked? ev) (reset! action-type :multi)))})]
      "Multi-step " type-name]
     [:label [:input (set-checked
                       (= @action-type :apply)
                       {:type :checkbox
                        :on-change (fn [ev]
                                     (when (checked? ev) (reset! action-type :apply)))})]
      "Apply from template"]]))

(defn add-user-if-not-present [users user]
  (if (or (nil? user) (some #(= (:id %) (:id user)) users))
   users
   (into [user] users)))

(defn alert [options task-id]
  (let [enabled (atom true)
        before-due-days (atom @(:before-due-days options))
        past-due-days (atom @(:past-due-days options))
        errors (or (:errors-atom options) (atom {}))
        update-fn (fn []
                    (reset! (:on? options) @enabled)
                    (reset! (:enabled options) @enabled)
                    (reset! (:before-due-days options) @before-due-days)
                    (reset! (:past-due-days options) @past-due-days))
        success-fn (fn [response]
                     (->> (model/task-details task-id (util/date-string (:complete-by options)))
                          (p/map (fn [response]
                                   (reset! (:task options) response)
                                   (update-fn)))))
        toggle-alert-fn (fn []
                          (if (:edited? options)
                            (update-fn)
                            (controller/dispatch :toggle-alert :save
                                                 {:task-id task-id
                                                  :enabled @enabled
                                                  :before-due-days @before-due-days
                                                  :past-due-days @past-due-days
                                                  :errors-atom errors
                                                  :on-success success-fn})))]
    (fn []
      [:div
       [:div.o-main-aside.u-align-items--center
        [:img.u-margin-right--xs.svg-icon--xlg   {:src (str "/static/img/icons/alert-" (if @enabled "green" "white") ".svg")}]
        [:h3 "SET ALERTS"]]
       
       [:p.u-margin-top.u-margin-bottom ""]
       [:form.c-form--edit.c-form--input-wide.u-padding-bottom--lg
        [:dl
         [:dd
          [:label
           [:input (form/set-checked
                    @enabled
                    {:type "checkbox"
                     :on-change (fn [_] (swap! enabled not))})]
           [:span.u-font-size--larger "Enable"]]
          [:span.error (:enabled @errors "")]]]
        [:dl
         [:dt [:span.u-font-size--larger "Days before due date"]]
         [:dd [:select.c-field-inline__field {:on-change (fn [ev]
                                                           ((reset-from-event before-due-days) ev))
                                              :value @before-due-days
                                              :disabled (not @enabled)}
               (for [i (range 0 31)]
                 [:option {:key i :value (str i)} (str i)])]
          [:span.error (:before-due-days @errors "")]]]
        [:dl
         [:dt [:span.u-font-size--larger "Overdue reminder interval (days)"]]
         [:dd [:select.c-field-inline__field  {:on-change (fn [ev]
                                                            ((reset-from-event past-due-days) ev))
                                               :value @past-due-days
                                               :disabled (not @enabled)}
               (for [i (range 0 31)]
                 [:option {:key i :value (str i)} (if (= i 0) "Disabled" (str i))])]
          [:span.error (:past-due-days @errors "")]]]]
       [:footer.o-space-between
        [:button
         {:type     :submit
          :on-click (handler
                     (fn []
                       (common/hide-modal :alert)
                       (toggle-alert-fn)))}
         (if (:edited? options) "Continue" "Save")]]])))

(defn toggle-alert [options task-id]
  (let [errors (atom {})]
    (fn [options task-id]
      [:span
       {:on-click (when-not (:disabled options)
                    (fn [ev]
                      (let [scroll-top (.-scrollTop js/document.documentElement)
                            x-right-adjustment 50
                            x-left-adjustment -440
                            x-adjustment (if (= "left" (:position options)) x-left-adjustment x-right-adjustment)
                            y-adjustment 70
                            x (+ (.-clientX ev) x-adjustment)
                            y (- (.-clientY ev) y-adjustment)]
                        (common/show-modal :alert [alert options task-id]
                                           {:modal-class "modal-alert"
                                            :scroll-top scroll-top
                                            :x x
                                            :y y}))))}
       [:img.svg-icon--md.u-cursor--pointer  {:src (str "/static/img/icons/alert-" (if @(:on? options) "green" "white") ".svg")}]])))

(defn alert-edit [options object-id]
  [:span.u-vertical-align--middle
   [toggle-alert (assoc options :edited? true) object-id]
   [:span.u-margin-left--xs.u-vertical-align--middle
   (if @(:on? options)
      [:span
       (str @(:before-due-days options) " days before due date.")
       (when-not (#{0 "0"} @(:past-due-days options))
         [:span  (str " Overdue reminder interval (" @(:past-due-days options) " days).")])]
     "Alerts disabled")]])

(defn update-alert-count! []
  (when (and
          (= :logged-in (api/get-auth-info :auth-state))
          (not (auth-model/is-user-license-admin)))
    (controller/dispatch :alert-count :load
      {:on-success #(swap! state/alert-count-recent assoc :value % :timestamp (js/Date.now))})))

(defn alert-counter []
  (notify/register-handler "alert_count"
    (fn [payload]
      (swap! state/alert-count-recent assoc :value payload :timestamp (js/Date.now))))
  (fn []
    (let [alert-num (:value @state/alert-count-recent)]
      [:span
       (if (> alert-num 0)
          [:a {:href "#"
               :on-click (handler (fn [e]
                                    (reset! state/display-collection-nav false)
                                    (reset! state/task-tabs-active :alerts)
                                    (.assign js/window.location (.-href (.-target e)))))}
           [:img.svg-icon--lg {:src "/static/img/icons/alert-nav.svg"}]
           [:span.c-alert-counter alert-num]]
          [:img.svg-icon--lg {:src "/static/img/icons/alert-nav.svg"}])])))

(defn simple-task-edit [options collection task parent permitted-groups]
  (let [errors (atom {})
        rules (atom [])
        users (atom [])
        task-type (or (:task-type options) (atom (if (:compliance task) :compliance :task)))
        action-type (:action-type options)
        priority-editable (not (or (:compliance task) (= :compliance @task-type)))
        group (atom (:id (first permitted-groups)))
        include-inactive-collections (atom false)
        allow-group-choice (and (not parent) (> (count permitted-groups) 1))
        name (atom (or (:name task) ""))
        description (atom (or (:description task) ""))
        assign-to (atom (get-in task [:user :id]))
        rule (atom (str (get-in task [:rule :id])))
        complete-by (atom (when-let [complete-by (:complete_by task)]
                            (tz/parsed-date-to-browser-date (time-coerce/to-date (util/parse-datetime complete-by)))))
        repeat-until (atom (when-let [repeat-until (:repeat_until task)]
                             (tz/parsed-date-to-browser-date (time-coerce/to-date (util/parse-datetime repeat-until)))))
        priority (atom (or (:priority task) "2"))
        assignments (atom (get-initial-ui-assignments (:task_collections task)))

        primary-collection-id-global (atom (:collection (first (filterv #(:main %) @assignments))))

        assignments-to-delete (atom #{})
        deleted_assignments (atom #{})
        category (atom (get-in task [:category :id]))
        load-users (fn [collection-ids]
                     (->> (collection-model/permitted-users {:task-assign true} collection-ids)
                          (p/map (fn [response] (reset! users (add-user-if-not-present response (:user task)))))
                          (process-error)))
        dispositions (subscribe :automation-dispositions)
        load-dispositions (fn [collection-ids]
                            (controller/dispatch :automation-dispositions :load {:family-id @group
                                                                                 :page nil
                                                                                 :order nil
                                                                                 :assignments collection-ids}))
        asigned-disposition (atom {:id (get-in task [:disposition :id])})
        label (atom (:labels task))
        load-labels (fn []
                      (controller/dispatch :label-list :load {:family-id @group
                                                              :object-type admin-model/object-type-task-template-group
                                                              :errors-atom errors}))
        alert (get-in task [:cycle 0 :alert])
        alert-options {:on? (atom (:enabled alert))
                       :enabled (atom (:enabled alert))
                       :before-due-days (atom (if alert (:before_due_days alert) 0))
                       :past-due-days (atom (if alert (:past_due_days alert) 0))
                       :edited? true
                       :task task
                       :complete-by (:complete_by task)}]
    
    (when-let [collection-ids (not-empty (if parent
                                           (:parent-collection-ids parent)
                                           (get-collection-ids @assignments)))]
      (load-users collection-ids))
    
    (controller/dispatch :label-list :clear)
    (if (model/has-task-permission {:group_collection_id @group
                                    :recurring false
                                    :type 1} (if task :modify :add))
      (load-dispositions (get-collection-ids @assignments))
      (controller/dispatch :automation-dispositions :clear))
    (load-labels)
    
    (add-watch assignments :task-edit-users-and-dispositions (fn [_ _ _ new-assignments]
                                                               (load-labels)
                                                               (load-users (get-collection-ids new-assignments))
                                                               (when (auth-model/is-user-group-admin @group)
                                                                 (load-dispositions (get-collection-ids new-assignments)))))
    (fn []
      [:form.c-form--edit.o-media {:on-submit (handler
                                               (fn []
                                                 (task-submit options task errors parent
                                                              (merge
                                                               {:collection_id (get-collection-ids @assignments)
                                                                :group_id @group
                                                                :deleted_collection_id (vec @assignments-to-delete)
                                                                :main_collection_id (:collection (first (filterv (fn [assignment] (:main assignment)) @assignments)))
                                                                :category_id @category
                                                                :name @name
                                                                :description @description
                                                                :user_id (to-value @assign-to)
                                                                :rule_id (to-value @rule)
                                                                :complete_by (and @complete-by (util/local-date-time-to-date-string @complete-by))
                                                                :repeat_until (and @repeat-until (util/local-date-time-to-date-string @repeat-until))
                                                                :disposition_id (to-value (:id @asigned-disposition))
                                                                :label_id (vec (for [lb @label :when (not (:new lb))] (:id lb)))
                                                                :label_name (vec (for [lb @label :when (:new lb)] (:name lb)))
                                                                :enabled @(:enabled alert-options)
                                                                :before_due_days @(:before-due-days alert-options)
                                                                :past_due_days @(:past-due-days alert-options)}
                                                               
                                                               (link-model/parent-params parent)
                                                               (when true
                                                                 {:priority @priority})))))}

       [:div
        (when-not task
          [:fieldset
           [action-type-chooser task-type action-type task parent]])

        (when-not parent
          [:fieldset
           [:legend "Ownership and access"]

           (when allow-group-choice
             [:dl
              [:dt "Family"]
              [:dd [group-chooser permitted-groups group]]])

           (when @group
             [:dl
              [collection-field-header include-inactive-collections]
              [:dd
               [assignments-edit-notable-redesign {:include-inactive-atom include-inactive-collections} assignments errors collection assignments-to-delete group
                primary-collection-id-global]]])])

        [:fieldset
         [:legend "Task Name"]
         [:dl
          [:dt "Custom Name"]
          [:dd
           [:input.u-full-width {:type "text" :value @name :on-change (reset-from-event name)}]
           [:span.error (:name @errors "")]]]

         [:dl
          [:dt "Service Category"]
          [:dd [category-component/category-chooser-fuzzy (when task
                                                            {:additional-categories [(:category task)]}) group category nil] [:span.error (:category_id @errors "")]]]
         [:dl
          [:dt "Assign label"]
          [:dd
           [label-component/label-chooser-multi {:allow-empty true
                                                 :allow-create-new true} @group label]
           [:span.error (:label-chooser @errors "")]]]]

        [:fieldset
         [:legend "Task Details"]
         [:dl
          [:dt "Task Description"]
          [:dd
           [:textarea {:value @description :on-change (reset-from-event description)}]
           [:span.error (:description @errors "")]]]

         [:dl
          [:dt "Assign to"]
          [:dd [auth-component/user-chooser-fuzzy nil @users assign-to] [:span.error (:user_id @errors "")]]]

         [:dl
          [:dt (if (seq @rule) "Starting From" "Complete by")]
          [:dd
           [pikaday/date-selector {:date-atom complete-by}]
           [:span.error (:complete_by @errors "")]
           (when (seq @rule)
             [:span "Until: "
              [pikaday/date-selector {:date-atom repeat-until}]
              [:span.error (:repeat_until @errors "")]])]]

         (when priority-editable
           [:dl
            [:dt "Priority"]
            [:dd [priority-chooser nil priority] [:span.error (:priority @errors "")]]])
         
         (when
             (and (model/has-task-permission {:group_collection_id @group
                                              :recurring false
                                              :type 1} (if task :modify :add))
               (not-empty (:results @dispositions))
               (not-empty (get-collection-ids @assignments)))
           [:dl
            [:dt "Assign disposition"]
            [:dd
             [automation/disposition-chooser-fuzzy {:allow-empty true} asigned-disposition]
             [:span.error (:disposition-chooser-fuzzy @errors "")]]])
         
         [:dl
          [:dt "Set Alert"]
          [alert-edit alert-options (:id task)]]]
        
        [:footer.o-space-between

         (if-let [back-cb (:back-cb options)]
           [:button {:on-click (handler #(back-cb))} "Close"]
           [:button {:on-click util/back} "Back"])
         [:button {:type "submit"} "Save"]]]])))

(defn multistep-task-add [options collection parent permitted-groups]
  (let [errors (atom {})
        users (atom [])
        task-type (:task-type options)
        action-type (:action-type options)
        is-compliance (when task-type (= :compliance @task-type))
        group (atom (:id (first permitted-groups))) ;; group as in family
        allow-group-choice (and (not parent) (> (count permitted-groups) 1))

        group-name (atom "")
        name (atom "")
        description (atom "")
        assign-to (atom nil)
        rule (atom nil)
        complete-by (atom nil)
        repeat-until (atom nil)
        priority (atom "2")
        signature-scope (atom nil)
        assignments (atom (get-initial-ui-assignments nil))
        include-inactive-collections (atom false)
        primary-collection-id-global (atom (:collection (first (filterv #(:main %) @assignments))))
        assignments-to-delete (atom #{})
        category (atom nil)

        load-users (fn [collection-ids]
                     (->> (collection-model/permitted-users nil collection-ids)
                          (p/map (fn [response] (reset! users response)))
                          (process-error)))
        dispositions (subscribe :automation-dispositions)
        load-dispositions (fn [collection-ids]
                            (controller/dispatch :automation-dispositions :load {:family-id @group
                                                                                 :page nil
                                                                                 :order nil
                                                                                 :assignments collection-ids}))
        asigned-disposition (atom nil)
        show-disposition-chooser-by-rule (atom (if is-compliance false true))
        rule-list (subscribe :rule-list)
        label (atom nil)
        load-labels (fn []
                      (controller/dispatch :label-list :load {:family-id @group
                                                              :object-type admin-model/object-type-task-template-group
                                                              :errors-atom errors}))
        keep-document-date (atom false)]
    

    (when-let [collection-ids (not-empty (if parent
                                           (:parent-collection-ids parent)
                                           (get-collection-ids @assignments)))]
      (load-users collection-ids))
    
    (add-watch assignments :task-edit-users-and-dispositions (fn [_ _ _ new-assignments]
                                                               (load-labels)
                                                               (load-users (get-collection-ids new-assignments))
                                                               (when (auth-model/is-user-group-admin @group)
                                                                 (load-dispositions (get-collection-ids new-assignments)))))

    (add-watch rule :change-rule (fn [_ _ _ new-rule]
                                   (let [disposition-allowed-rule-ids (map str (map #(get % :id) (filter #(contains? disposition-allowed-rule-types (:type %)) @rule-list)))]
                                     (if (some #(= new-rule %) disposition-allowed-rule-ids)
                                       (reset! show-disposition-chooser-by-rule true)
                                       (do
                                         (reset! show-disposition-chooser-by-rule false)
                                         (reset! asigned-disposition nil))))))

    (if (model/has-task-permission {:group_collection_id @group
                                    :recurring is-compliance
                                    :type 1} :add)
      (load-dispositions (get-collection-ids @assignments))
      (controller/dispatch :automation-dispositions :clear))
    (controller/dispatch :label-list :clear)
    (load-labels)

    (fn []
      [:form.c-form--edit.o-media
       {:on-submit (handler
                    (fn []
                      (task-submit options nil errors parent
                                   (merge
                                    {:group_id @group
                                     :collection_id (get-collection-ids @assignments)
                                     :deleted_collection_id (vec @assignments-to-delete)
                                     :main_collection_id (:collection (first (filterv (fn [assignment] (:main assignment)) @assignments)))
                                     :category_id @category
                                     :name @name
                                     :group_name @group-name
                                     :description @description
                                     :user_id (to-value @assign-to)
                                     :rule_id (to-value @rule)
                                     :complete_by (and @complete-by (util/local-date-time-to-date-string @complete-by))
                                     :repeat_until (and @repeat-until (util/local-date-time-to-date-string @repeat-until))
                                     :multi_step true
                                     :priority @priority
                                     :signature_scope @signature-scope
                                     :disposition_id (to-value (:id @asigned-disposition))
                                     :label_id (vec (for [lb @label :when (not (:new lb))] (:id lb)))
                                     :label_name (vec (for [lb @label :when (:new lb)] (:name lb)))
                                     :keep_document_date @keep-document-date}
                                    (link-model/parent-params parent)))))}

       [:fieldset
        [action-type-chooser task-type action-type nil parent]]

       [:fieldset
        [:legend "Ownership and access"]

        (when allow-group-choice
          [:dl
           [:dt "Family"]
           [:dd [group-chooser permitted-groups group]]])

        [:dl
         [collection-field-header include-inactive-collections]
         [:dd
          [assignments-edit-notable-redesign {:include-inactive-atom include-inactive-collections} assignments errors collection assignments-to-delete group
           primary-collection-id-global]]]]

       [:fieldset
        [:legend (str (if is-compliance "Compliance" "Task") " Name")]
        [:dl
         [:dt "Custom Name"]
         [:dd
          [:input.u-full-width {:type "text" :value @group-name :on-change (reset-from-event group-name)}]
          [:span.error (:group-name @errors "")]]]

        [:dl
         [:dt "Service Category"]
         [:dd [category-component/category-chooser-fuzzy nil group category] [:span.error (:category_id @errors "")]]]
        
        [:dl
         [:dt "Assign label"]
         [:dd
          [label-component/label-chooser-multi {:allow-empty true
                                                :allow-create-new true} @group label]
          [:span.error (:label-chooser @errors "")]]]

        (when is-compliance
          [:dl
           [:dt "Repeat"]
           [:dd
            [rule-chooser {:recurring-object-type :compliance
                           :must-repeat true} rule]
            [:span.error (:rule_id @errors "")]]])]

       [:fieldset
        [:legend "Step 1" (when (seq @name) [:span " - " @name])]
        [:dl
         [:dt "Name"]
         [:dd
          [:input.u-full-width {:type "text" :value @name :on-change (reset-from-event name)}]
          [:span.error (:name @errors "")]]]
        [:dl
         [:dt "Description"]
         [:dd
          [:textarea {:value @description :on-change (reset-from-event description)}]
          [:span.error (:description @errors "")]]]
        [:dl
         [:dt "Assign To"]
         [:dd [auth-component/user-chooser-fuzzy nil @users assign-to] [:span.error (:user_id @errors "")]]]

        [:dl
         [:dt (if @rule "Starting From" "Complete By")]
         [:dd
          [pikaday/date-selector {:date-atom complete-by}]
          [:span.error (:complete_by @errors "")]
          (when @rule
            [:span "Until: "
             [pikaday/date-selector {:date-atom repeat-until}]
             [:span.error (:repeat_until @errors "")]])]]
        [:dl
         [:dt "Priority"]
         [:dd [priority-chooser nil priority] [:span.error (:priority @errors "")]]]
        [:dl
         [:dt "Step Type"]
         [:dd [signature-scope-chooser {:compliance  is-compliance} @group signature-scope] 
          (when (model/is-dropbox-sign-signature-scope @signature-scope)
            [keep-document-date-checker {:keep-document-date-atom keep-document-date :errors-atom  errors}])
          [:span.error (:signature_scope @errors "")]]]

        (when
          (and (not-empty (get-collection-ids @assignments))
               (and (not-empty (:results @dispositions)) @show-disposition-chooser-by-rule))
          [:dl
           [:dt "Assign disposition"]
           [:dd
            [automation/disposition-chooser-fuzzy {:allow-empty true} asigned-disposition]
            [:span.error (:disposition-chooser-fuzzy @errors "")]]])]

       [:footer.o-space-between
        (if-let [back-cb (:back-cb options)]
          [:button {:on-click (handler #(back-cb))} "Close"]
          [:button {:on-click util/back} "Back"])
        [:button {:type "submit"} "Save"]]])))

(defn multistep-edit-group-details [group action-row]
  [:table.edit.u-no-borders.h
   [:tbody
    [:tr
     [:th (str (if (:compliance @group) "Compliance" "Task Group") " Name")]
     [:td (:name @group)]]
    [:tr
     [:th "Category"]
     [:td (get-in @group [:category :name])]]
    [:tr
     [:th "Collections"]
     [:td.assignments [assignment-list (get-assignments @group)]]]]
   (when (:compliance @group)
     [:tbody
      [:tr
       [:th "Repeat"]
       [:td (get-in @group [:rule :name])]]
      [:tr
       [:th "Repeat until"]
       [:td (if (:repeat_until @group) (util/date-reformat(:repeat_until @group)))]]])
   [:tbody
    action-row]])

;TODO Confirm its safe to delete
(defn multistep-edit-step-details [group step index action-row]
  [:tbody
   [:tr.divider
    [:th {:col-span 2} (str "Step " (+ 1 index) " - " (model/task-name step))]]
   [:tr
    [:th "Title"]
    [:td (model/task-name step)]]
   [:tr
    [:th "Description"]
    [:td (:description step)]]
   [:tr
    [:th (if (:rule_id @group) "Starting From" "Complete by")]
    [:td (util/date-reformat (step :complete_by))]]
   ;; (when (:rule_id group)
   ;;   [:tr
   ;;    [:th "Repeat Until"]
   ;;    [:td (util/date-reformat (get-in step [:last_schedule :repeat_until]))]])
   [:tr
    [:th "Assigned User"]
    [:td (auth-model/get-full-name (:user step))]]
   (when-not (:compliance @group)
     [:tr
      [:th "Priority"]
      [:td (model/priority-name step)]])
   action-row])

(defn multistep-edit-step-form [step task-atom cancel-cb change-step-cb show-delete? delete-step-cb]
  (let [errors (atom {})
        users (subscribe :permitted-users)
        group (atom (model/task-to-group-data @task-atom))
        priority-editable (not (:compliance @group))
        index (or (:step_idx step) (-> (count (:cycle (model/task-to-group-data @task-atom))) (+ 1)))
        default-complete-by (:complete_by (last (:cycle (model/task-to-group-data @task-atom))))
        name (atom (or (model/task-name step) ""))
        description (atom (or (:description step) ""))
        assign-to (atom (:user_id step))
        complete-by (atom (tz/parsed-date-to-browser-date (if-let [complete-by (:complete_by step)]
                                                            (time-coerce/to-date (util/parse-datetime complete-by))
                                                            (time-coerce/to-date (util/parse-datetime default-complete-by)))))

        is-group-admin (auth-model/is-user-group-admin (:group_collection_id @task-atom))
        protect-controls (and (model/is-any-signature-step step) (not is-group-admin))
        priority (atom (or (:priority step) "2"))
        signature-scope (atom (or (:signature_scope step) nil))
        load-users (fn [collection-ids]
                     (->> (collection-model/permitted-users (if (:compliance @group)
                                                              {:compliance-assign true}
                                                              {:task-assign true}) collection-ids)
                          (p/map (fn [response] (reset! users (add-user-if-not-present response (:user step)))))
                          (process-error)))
        assignments (atom (mapv (fn [task-collection] (:collection_id task-collection)) (:task_collections @group)))
        dispositions (subscribe :automation-dispositions)
        load-dispositions (fn [collection-ids]
                            (controller/dispatch :automation-dispositions :load {:family-id (:group_collection_id @task-atom)
                                                                                 :page nil
                                                                                 :order nil
                                                                                 :assignments collection-ids}))
        asigned-disposition (atom  {:id (get-in step [:disposition :id])})
        hide-disposition-chooser-by-rule (and (:compliance @group) (not (contains? disposition-allowed-rule-types (get-in @group [:rule :type]))))
        signature-status (subscribe :signature-status)
        is-signature-pending? false #_(= document-model/signature-status-pending (:status (get @signature-status (:id step))))
        alert (get-in step [:alert])
        alert-options {:on? (atom (:enabled alert))
                       :enabled (atom (:enabled alert))
                       :before-due-days (atom (if alert (:before_due_days alert) 0))
                       :past-due-days (atom (if alert (:past_due_days alert) 0))
                       :edited? true}
        keep-document-date (atom (or (:keep_document_date step) false))]
    
    (letfn [(submit [e force]
              (let [complete-by-date (and @complete-by (util/local-date-time-to-date-string @complete-by))
                    submit-func (if step (partial model/task-update (:task_id step)) (partial model/task-add-to-group (:id @group)))
                    first_step (first (:cycle @group))]
                
                (->> (submit-func

                      (merge
                       {:name @name
                        :description @description
                        :user_id (valid/validate-with-list (str (to-value @assign-to)) @users #(str (:id %)))
                        :complete_by complete-by-date
                        :first_step_id (:task_id first_step)
                        :first_step_complete_by (util/date-string (:complete_by first_step))
                        :signature_scope @signature-scope
                        :force (when force "yes")
                        :disposition_id (to-value (:id @asigned-disposition))
                        :enabled @(:enabled alert-options)
                        :before_due_days @(:before-due-days alert-options)
                        :past_due_days @(:past-due-days alert-options)
                        :keep_document_date @keep-document-date}

                       (when priority-editable
                         {:priority @priority})))

                     (p/map (fn [task-data]
                              (let [location (:redirect task-data)
                                    new-date (get-in task-data [:redirect :complete_by])
                                    new-task-id (get-in task-data [:redirect :task_id])]

                                (->> (model/task-editable-cycle (:task_id location) (util/date-string (:complete_by location)))
                                     (p/map (fn [response]
                                              (reset! group (model/task-to-group-data response))
                                              (->> (model/task-details (:id response) (util/date-string new-date))
                                                   (p/map (fn [response]
                                                            (reset! task-atom response)
                                                            (change-step-cb new-task-id (util/date-string new-date))
                                                            (cancel-cb)))
                                                   (process-error))))
                                     (process-error)))))

                     (process-compliance-conflicts-error nil #(submit e %))
                     (process-error errors))

                (.preventDefault e)))]
      (if (model/has-task-permission @task-atom :modify)
        (load-dispositions @assignments)
        (controller/dispatch :automation-dispositions :clear))
      (fn [step task-atom cancel-cb change-step-cb show-delete? delete-step-cb]

        [:form.c-form--edit.c-form--spreaded {:on-submit #(submit % false)}
         [:span.o-space-between
          [:h3.c-task-center__name__blue (str "Step " index ": " (when (seq @name) " - " @name))]
          (when show-delete?
            [:button
             {:on-click (util/handler (fn [_]
                                        (let 
                                         [text "Are you sure you want to delete this step?"
                                          errors                     (atom {})
                                          control-phrase             (atom "")]
                                          (letfn [(delete-func [force control-phrase]
                                                               (->> (model/task-delete (:task_id step) (util/date-string (:complete_by step)) force control-phrase)
                                                                    (p/map (fn [_]
                                                                             (let [first-step (first (filterv #(not= (:task_id %) (:task_id step)) (:cycle @task-atom)))]
                                                                               (->> (model/task-editable-cycle (:task_id first-step) (util/date-string (:complete_by first-step)))
                                                                                    (p/map (fn [response]
                                                                                             (reset! group (model/task-to-group-data response))
                                                                                             (->> (model/task-details (:id response) (util/date-string (:complete_by response)))
                                                                                                  (p/map (fn [response]
                                                                                                           (reset! task-atom response)
                                                                                                           (delete-step-cb))))))))
                                                                             (common/hide-controled-confirmation-modal)))
                                                                    (process-compliance-conflicts-error nil delete-func)
                                                                    (process-error errors)))]
                                            (if (:compliance @task-atom)
                                              (common/show-controled-confirmation-modal
                                               {:title         "Compliance step delete"
                                                :text           text
                                                :ok-cb          (fn []
                                                                  (delete-func false control-phrase))
                                                :errors         errors
                                                :control-phrase control-phrase})
                                              (when (js/confirm text)
                                                (delete-func false nil)))))))} "Delete"])]

         [:dl
          [:dt "Name"]
          [:dd [:input.u-full-width {:type "text" :value @name :on-change (reset-from-event name)
                                     :disabled protect-controls}]]
          [:dd  [:span.error (:name @errors "")]]]

         [:dl
          [:dt "Description"]
          [:dd [:textarea {:value @description :on-change (reset-from-event description)
                           :disabled protect-controls}]]
          [:dd [:span.error (:description @errors "")]]]

         [:dl
          [:dt "Assign To"]
          [:dd [auth-component/user-chooser-fuzzy nil @users assign-to]]
          [:dd [:span.error (:user_id @errors "")]]]

         [:dl
          [:dt (if (:rule_id @group) "Starting From" "Complete by")]
          [:dd [pikaday/date-selector {:date-atom complete-by}]]
          [:dd [:span.error (:complete_by @errors "")]]]

         (when priority-editable
           [:dl
            [:dt "Priority"]
            [:dd [priority-chooser {:disabled protect-controls} priority]]
            [:dd [:span.error (:priority @errors "")]]])

         [:dl
          [:dt "Step Type"]
          [:dd [signature-scope-chooser
                {:disabled (or protect-controls is-signature-pending?)
                 :compliance (:compliance @group)}
                (:group_collection_id @task-atom) signature-scope]       
           (when (model/is-dropbox-sign-signature-scope @signature-scope)
             [keep-document-date-checker {:keep-document-date-atom keep-document-date :errors-atom  errors}])
           [:dd [:span.error (:signature_scope @errors "")]]]]
         (when-not hide-disposition-chooser-by-rule
           (when (and (not-empty (:results @dispositions)) (not-empty @assignments))
             [:dl
              [:dt "Assign disposition"]
              [:dd
               [automation/disposition-chooser-fuzzy {:allow-empty true} asigned-disposition]
               [:span.error (:disposition-chooser-fuzzy @errors "")]]]))
         [:dl
          [:dt "Set Alert"]
          [disable-tool  {:disabled (:not_dependent step)
                          :message "Alert can not be set for independent step"
                          :component [alert-edit (assoc alert-options :disabled (:not_dependent step)) (:task_id step)]}]]
         
         [:footer.o-flex-align--space-between
          [:button {:on-click cancel-cb} "Cancel"]
          [:button {:type :submit} "Save"]]]))))

(defn show-compliance-edit-conflicts-modal! [options error-response proceed-fn]
  (reset!
    state/compliance-edit-conflicts-modal
    {:enabled true
     :proceed-fn proceed-fn
     :page 1
     :step-expanded-atom (atom {})
     :conflicting-occurrences (get-in error-response [:response :body :data])}))

(defn process-compliance-conflicts-error [options submit-func prom]
  (p/error (fn [e]
             (if (and
                  (= "immutable_data_exists" (get-in e [:response :body :type]))
                  (seq (get-in e [:response :body :data])))
               (do
                 (common/hide-controled-confirmation-modal)
                 (show-compliance-edit-conflicts-modal! options e submit-func))
               (throw e)))
           prom))

(defn disposition-rule-list? [group]
  (and (some #(or (:disposition %) false) (get-in group [:cycle]))
       (contains? disposition-allowed-rule-types (get-in group [:rule :type]))))

(defn multistep-edit-group-edit [cancel-cb permitted-groups task]
  (let [errors (atom {})
        group (atom (model/task-to-group-data @task))
        group-collection (atom (:id (first permitted-groups)))
        allow-group-choice (> (count permitted-groups) 1)

        name (atom (or (:name @group) ""))
        category (atom (:category_id @group))
        rule (atom (get-in @group [:rule :id]))
        repeat-until (atom (when-let [repeat-until (:repeat_until @group)]
                             (tz/parsed-date-to-browser-date (time-coerce/to-date (util/parse-datetime repeat-until)))))
        assignments (atom (get-initial-ui-assignments (:task_collections @group)))
        include-inactive-collections (atom false)
        primary-collection-id-global (atom (:collection (first (filterv #(:main %) @assignments))))

        assignments-to-delete (atom #{})
        
        label (atom (:labels @task))
        load-labels (fn []
                      (controller/dispatch :label-list :load {:family-id @group-collection
                                                              :object-type admin-model/object-type-task-template-group
                                                              :errors-atom errors}))
        submit (fn [e]
                 (let [first_step (first (:cycle @group))]
                   (letfn [(submit-func [force]
                             (->> (model/group-update (:id @group)
                                                      {:name @name
                                                       :category_id @category
                                                       :complete_by (:complete_by @group)
                                                       :rule_id @rule
                                                       :repeat_until  (and @repeat-until  (util/local-date-time-to-date-string @repeat-until))
                                                       :first_step_id (:task_id first_step)
                                                       :first_step_complete_by (util/date-string (:complete_by first_step))
                                                       :group_id @group-collection
                                                       :collection_id (get-collection-ids @assignments)
                                                       :deleted_collection_id (vec @assignments-to-delete)
                                                       :main_collection_id (:collection (first (filterv (fn [assignment] (:main assignment)) @assignments)))
                                                       :force (when force "yes")
                                                       :label_id (vec (for [lb @label :when (not (:new lb))] (:id lb)))
                                                       :label_name (vec (for [lb @label :when (:new lb)] (:name lb)))})
                                  (p/map (fn [group-data]
                                           (let [location (:redirect group-data)
                                                 new-date (get-in group-data [:redirect :complete_by])]
                                             (->> (model/task-details (:task_id location) (util/date-string new-date))
                                                  (p/map (fn [response]
                                                           (reset! group (model/task-to-group-data response))
                                                           (reset! task response)
                                                           (cancel-cb)))))))
                                  (process-compliance-conflicts-error nil submit-func)
                                  (process-error errors)))]
                     (submit-func false))

                   (.preventDefault e)))]
    (controller/dispatch :label-list :clear)
    (load-labels)
    (fn [cancel-cb permitted-groups task]

      [:form.c-form--edit.c-form--spreaded {:on-submit submit}

       [:fieldset
        [:legend "Ownership and access"]

        (when allow-group-choice
          [:dl
           [:dt "Family"]
           [:dd [group-chooser permitted-groups group-collection]]])

        [:dl
         [collection-field-header include-inactive-collections]
         [:dd
          [assignments-edit-notable-redesign {:include-inactive-atom include-inactive-collections} assignments errors nil assignments-to-delete group-collection
           primary-collection-id-global]]]]

       [:fieldset
        [:legend (str (if (:compliance @group) "Compliance" "Task") " name")]

        [:dl
         [:dt "Custom Name"]
         [:dd [:input.u-full-width {:type "text" :value @name :on-change (reset-from-event name)}]]

         [:dt "Service Category"]
         [:dd [category-component/category-chooser-fuzzy (when @task
                                                           {:additional-categories [(:category @task)]}) group-collection category] [:span.error (:category_id @errors "")]]
         [:dt "Assign label"]
         [:dd
          [label-component/label-chooser-multi {:allow-empty true
                                                :allow-create-new true} @group label]
          [:span.error (:label-chooser @errors "")]]
         
         (when (:compliance @group) 
           [:section.o-row

            [:dl
             [:dt "Repeat"]
             [:dd
              [rule-chooser {:recurring-object-type (if (disposition-rule-list? @group)
                                                      :disposition
                                                      :compliance)
                             :must-repeat true
                             :disabled (not (:group_editable @group))} rule]]
             [:span.error (:rule_id @errors "")]]
            [:dl
             [:dt "Repeat until"]
             [:dd.datetimepicker.repeat-until
              [datetimepicker {:time-atom repeat-until
                               :show-time-picker false}]

              [:button {:on-click (util/handler
                                   (fn [] (reset! repeat-until (time-coerce/to-date (util/parse-datetime-local (:complete_by @group))))))}
               "End here"]
              [:span.error (:repeat_until @errors "")]]]])]
        
        (when (and (:compliance @group) (disposition-rule-list? @group))
          [:section.o-main-aside
           [:dl
            [:dt "Repeat limited due to disposition attached"]]])]
       
       [:footer.o-space-between
        [:button {:type :reset :on-click (fn [_] (cancel-cb))} "Cancel"]
        [:button {:type :submit} "Save"]]])))

(defn apply-from-template-collection-chooser [{:keys [allow-group-choice errors-atom] :as options} initial-collection collection-atom group-atom permitted-groups]
  (let [collection-name (atom (or (:name initial-collection) ""))
        collection-tree (atom {})
        include-inactive-collections (atom false)
        load-collection-tree (fn []
                               (->> (collection-model/collection-tree @group-atom true @include-inactive-collections)
                                    (p/map (fn [response] (reset! collection-tree response)))
                                    (process-error)))]
    (load-collection-tree)
    (add-watch group-atom :apply-from-template-group-change-chooser (fn [_ _ _ new-group]
                                                      (load-collection-tree)))
    (add-watch include-inactive-collections :assignments-edit-notable-include-inactive
               (fn [& args]
                 (load-collection-tree)))
    (fn [options initial-collection collection-atom group-atom permitted-groups]
      [:fieldset
       [:legend "Ownership and access"]
       (when allow-group-choice
         [:dl
          [:dt "Family"]
          [:dd [group-chooser permitted-groups group-atom]]])

       [:dl
        [collection-field-header include-inactive-collections]
        [:dd
         [nav-search
          {:on-change
           (fn [obj react-select-opts]
             (let [{:keys [value label] :as obj} (js->clj obj :keywordize-keys true)
                   id value]

               (reset! collection-atom id)
               (reset! collection-name (or label ""))))

           :value #js{:label @collection-name :value @collection-atom}
           :placeholder "Type collection name"
           :parent-id @group-atom}]

         [:button.c-assignments-edit-button
          {:href "#"
           :on-click (handler (fn []
                                (reset!
                                  state/collection-tree-modal
                                  {:enabled true
                                   :current-id @collection-atom
                                   :cb (fn [col]
                                         (reset! collection-atom (:id col))
                                         (reset! collection-name (:name col))
                                         (swap! state/collection-tree-modal assoc :enabled false))
                                   :tree-items collection-tree
                                   :primary-collection-id (atom true)
                                   :include-inactive-atom include-inactive-collections})))}
          "Select from the Collection Tree"]
         [:span.error (:collection_id @errors-atom)]]]])))

(defn apply-from-template [options collection-chooser initial-collection-obj parent permitted-groups]
  (let [collection-name (atom (or (:name initial-collection-obj) ""))
        task-type (:task-type options)
        action-type (:action-type options)
        collection (atom (:id initial-collection-obj))
        perm-types (atom #{})
        can-add-step #(contains? @perm-types (if (= @task-type :compliance) :can_add_compliance :can_add_task))
        can-modify-step #(contains? @perm-types (if (= @task-type :compliance) :can_modify_compliance :can_modify_task))
        users (atom nil)
        user-ids (atom nil) ;; IDs of users selected for steps
        has-invalid-assignments (catom (fn [] false))
        complete-by (atom (now-js-date))
        errors (atom {})
        template-group-id (atom nil)
        collection-tree (atom {})
        group (atom (:id (first permitted-groups)))
        allow-group-choice (and (not parent) (> (count permitted-groups) 1))
        load-users (fn [collection-ids]
                     (->> (collection-model/permitted-users (if (= :compliance @task-type)
                                                              {:compliance-assign true}
                                                              {:task-assign true}) collection-ids)
                          (p/map (fn [response] (reset! users response)))
                          (process-error)))
        load-perm-types (fn [collection-ids]
                          (->> (auth-model/permission-types [collection-ids])
                               (p/map (fn [types]
                                        (reset! perm-types types)))
                               (process-error)))]
    (when-let [collection-ids (not-empty (if parent
                                           (:parent-collection-ids parent)
                                           (filterv identity [@collection])))]
      (load-users collection-ids)
      (load-perm-types collection-ids))

    (add-watch collection :compliance-add-users (fn [& _]
                                                  (when @collection
                                                    (load-users [@collection])
                                                    (load-perm-types [@collection]))))
    (fn []
      [:form.c-form--edit.o-media
       {:on-submit
        (util/handler (fn []
                        (when
                          (if (and (can-modify-step) @has-invalid-assignments)
                            (js/confirm (str "Would you like to replace the invalid user assignments with " (auth-model/get-full-name (api/get-auth-info :user)) "?" ))
                            true)
                          (let [submit-data (merge
                                              {:group_id @group
                                               :collection_id @collection
                                               :template_group_id @template-group-id
                                               :user_id @user-ids
                                               :complete_by (and @complete-by (util/local-date-time-to-date-string @complete-by))}
                                              (link-model/parent-params parent))]
                            (if-let [submit-fn (:submit-fn options)]
                                   (submit-fn submit-data errors)
                                   (->>
                                     (model/templategroup-apply submit-data)
                                     (p/map (fn [group-data]
                                              (set-flash :success (str (if (= @task-type :compliance) "Compliance" "Task") " has been added"))
                                              (if-let [success-cb (:success-cb options)]
                                                (success-cb)
                                                (set-location
                                                  (str "#/task/details/"
                                                    (:next_task_id group-data) "/"
                                                    (util/date-string (:next_occurrence_time group-data)) "/")))))
                                     (process-error errors)))))))}
       [:fieldset
        [action-type-chooser task-type action-type nil]]

       (when-not parent
         [collection-chooser {:allow-group-choice allow-group-choice
                              :errors-atom errors} initial-collection-obj collection group permitted-groups])
       [apply-from-template-details-form
        (assoc options :allow-change-template-group true)
        group perm-types task-type errors users can-add-step can-modify-step has-invalid-assignments
        {:template-group-id template-group-id
         :complete-by complete-by
         :user-ids user-ids}]

       [:footer.o-space-between
        (if-let [back-cb (:back-cb options)]
          [:button {:on-click (handler #(back-cb))} "Close"]
          [:button {:on-click util/back} "Back"])
        [:button "Save"]]])))

(defn tg-name-with-label [template-group]
  (reagent/as-element
   [:span (model/templategroup-name template-group) " "
    (when (:labels template-group)
      (apply label-component/label (map :name (:labels template-group))))])) 


(defn tg-select-option [props]
  (let [list-label (get-in (js->clj props) [:data "listLabel"])]
    [:> (.-Option components) (if list-label (assoc props :children list-label) props)]))

(defn apply-from-template-details-form
  [options group-atom perm-types-atom task-type errors-atom users-atom can-add-step-fn can-modify-step-fn has-invalid-assignments-atom
   {:keys [template-group-id complete-by user-ids] :as value-atoms} ]
  (let [template-groups (atom nil)
        template-group-map (catom {})
        assign-to (atom {})
        user-chosen (atom #{}) ;; IDs of the templates where the user picked an assignee in the dropdown
        can-modify-signature #(auth-model/is-user-group-admin @group-atom)
        is-valid-assignment? (fn [assigned-user-id] (contains? (into #{} (map str (map :id @users-atom))) (str assigned-user-id)))
        assigned-user-id-map (atom {})
        get-user-ids (fn [] (mapv (fn [template] (or (some-> (@assign-to (:id template)) deref str) "")) (:task_templates (@template-group-map @template-group-id))))
        set-invalid-assignments! (fn []
                                   (reset! has-invalid-assignments-atom
                                     (seq (remove (fn [user-id] (is-valid-assignment? user-id)) (filter not-empty (get-user-ids))))))
        edit-allowed? (fn [template]
                        (or
                          (and (model/is-any-signature-step template) (not (:user_id template)) (not (can-modify-signature)) (can-add-step-fn))
                          (and (or (not (model/is-any-signature-step template)) (can-modify-signature)) (can-add-step-fn))))
        get-assigned-user-id (fn [template] (some-> (@assign-to (:id template)) deref))
        ;; The seeded user IDs are positional, so they only apply to the group they came with.
        init-suggestion {:template-group-id @template-group-id
                         :user-ids @user-ids}
        set-initial-assigned-users! (fn [& [groups-override]]
                                      (when-let [groups (or groups-override @template-groups)]
                                      (let [flat-templates (reduce (fn [templates group] (concat templates (:task_templates group) )) [] groups)
                                            existing-assign-to @assign-to
                                            get-assigned-user-id (fn [template]
                                                                   ;; An editable step takes the user's pick, else the AARK user ID for
                                                                   ;; this group, else the template user. The form recounts the rest:
                                                                   ;; keeping them froze the signed-in user from before the users list
                                                                   ;; arrived (#3110).
                                                                   (if-let [existing-atom (and (contains? @user-chosen (:id template))
                                                                                               (existing-assign-to (:id template)))]
                                                                     @existing-atom
                                                                     (if (and (not-empty (:user-ids init-suggestion))
                                                                              (= (:template-group-id init-suggestion) (str (:task_template_group_id template))))
                                                                       (nth (:user-ids init-suggestion) (- (:ordering template) 1) nil)
                                                                       (:user_id template))))]
                                        (reset! assign-to (into {} (map (fn [template]
                                                                          [(:id template) (atom
                                                                                           (if (edit-allowed? template)
                                                                                             (get-assigned-user-id template)
                                                                                             ;; A locked step keeps a permitted template user, because the
                                                                                             ;; server rejects any other user there.
                                                                                             (if (is-valid-assignment? (str (:user_id template)))
                                                                                               (:user_id template)
                                                                                               (api/get-auth-info :user-id))))]) flat-templates)))
                                        (reset! assigned-user-id-map (into {} (map (fn [template] [(:user_id template) (:user template)]) flat-templates)))
                                        (reset! user-ids (get-user-ids))
                                        (set-invalid-assignments!))))
        load-template-groups (fn [group-id]
                               (->> (model/templategroup-list group-id @task-type "name")
                                    (p/map (fn [groups]
                                             (reset! template-group-map (into {} (map (fn [group] [(str (:id group)) group]) groups)))
                                             (set-initial-assigned-users! groups)
                                             (reset! template-groups groups)
                                             (when (and
                                                     @template-group-id
                                                     (not (contains? (set (map (comp str :id) groups)) @template-group-id)))
                                               (reset! template-group-id nil))))
                                    (process-error)))]
    (load-template-groups @group-atom)
    (add-watch group-atom :apply-from-template-group-change (fn [_ _ _ new-group]
                                                              (load-template-groups new-group)))
    (add-watch template-group-id :template-group-change (fn [& _]
                                                          (reset! user-ids (get-user-ids))
                                                          (set-invalid-assignments!)))
    (add-watch perm-types-atom :perm-types-change (fn [_ _ _ new-perm-types]
                                                    (set-initial-assigned-users!)))

    (add-watch users-atom :users-change (fn [& _]
                                          (set-initial-assigned-users!)))
    (fn [options & _]
      (let [fieldset-attrs #(when (:form-disabled options) {:disabled :disabled})]
        [:div
         [:fieldset (fieldset-attrs)
          (when-not (:hide-teplate-details-header options)
            [:legend "Template Details"])           
          [:dl
           [:dt "Template Group"]
           [:dd
            [:> Select
             (merge
               {:classNamePrefix "form-select"
                :isDisabled (not (:allow-change-template-group options))
                :options (for [group @template-groups]
                           {:value (:id group)
                            :listLabel (tg-name-with-label group)
                            :label (:name group)})

                :value (let [default-group (first (filter #(= (:id %) (js/parseInt @template-group-id)) @template-groups))]
                         {:value (:id default-group)
                          :label (if default-group
                                   (tg-name-with-label default-group)
                                   "Choose Template Group")})
                :on-change (fn [e]
                             (let [value (-> (js->clj e :keywordize-keys true) :value)]
                               (reset! template-group-id (str value))))

                :components {:Option (reagent/reactify-component tg-select-option)}}
               (:second react-select-styles))]
            [:span.error (:template_group_id @errors-atom)]]]

          (when-let [first-template-group (first @template-groups)]
            [:div
             [:dl
              [:dt (if (:compliance first-template-group) "Starting From" "Complete by")]
              [:dd [pikaday/date-selector {:date-atom complete-by
                                           :calendar-icon (:calendar-icon options)}]]
              [:dd [:span.error (:complete_by @errors-atom "")]]
              (when (:set-to-today options)
                [:dd.u-font-weight--bolder.u-font-size--smaller 
                 [:a {:on-click (fn [] 
                                  (reset! complete-by (util/local-date-time-to-date-string (js/Date.))))} 
                  "Set to today"]])]])]
        (when @template-group-id
          [:div
           (when (:assign-setps-label options)
             [:h3 (:assign-setps-label options)])
           (doall (map-indexed (fn [index template]
                                 [:fieldset (:merge (fieldset-attrs) {:key index})
                                  [:legend  {:class (:step-legend-class options)}
                                   (model/step-name index (:name template))]
                                  [:dl
                                   (when-not (:hide-assign-to-label options)
                                     [:dt "Assign to"])
                                   [:dd
                                    (let [assigned-user-id (get-assigned-user-id template)]
                                      [(if (get-in options [:user-chooser-opts :fuzzy])
                                         auth-component/user-chooser-fuzzy
                                         auth-component/user-chooser)
                                       (merge
                                        (:user-chooser-opts options)
                                        {:disabled (not (edit-allowed? template))
                                         :change-cb (fn []
                                                      (swap! user-chosen conj (:id template))
                                                      (reset! user-ids (get-user-ids))
                                                      (set-invalid-assignments!))})
                                       (if assigned-user-id
                                         (if (or (is-valid-assignment? assigned-user-id) (= "" assigned-user-id))
                                           @users-atom
                                           (if (edit-allowed? template)
                                             (conj @users-atom (update (@assigned-user-id-map assigned-user-id) :last_name str " <invalid>"))))
                                         @users-atom)
                                       (@assign-to (:id template))])
                                    [:span.error " " (get-in @errors-atom [:__meta__ :user (keyword (str index))])]]]])
                               (:task_templates ((into {} (map (fn [group] [(str (:id group)) group]) @template-groups)) @template-group-id))))
           (when-not (seq (get-in @errors-atom [:__meta__ :user]))
             [:span.error (:user_id @errors-atom "")])])]))))

(defn bulk-apply-collection-tree  [options collection-tree]
  (when @collection-tree
    [:div.collection-tree.redesign.u-margin-left (tree options @collection-tree) ]))

(defn bulk-apply-from-template [options group-id task-type template-group-id selected-collections bulk-operation-id-atom]
  (let [collection-ids (into [] @selected-collections)
        group (catom group-id)
        perm-types (atom #{})
        can-add-step #(contains? @perm-types (if (= @task-type :compliance) :can_add_compliance :can_add_task))
        can-modify-step #(contains? @perm-types (if (= @task-type :compliance) :can_modify_compliance :can_modify_task))
        has-invalid-assignments (catom (fn [] false))
        template-group-id (atom template-group-id)
        complete-by (atom (now-js-date))
        user-ids (atom nil) ;; IDs of users selected for steps
        errors (atom nil)
        load-perm-types (fn [collection-ids]
                          (->> (auth-model/permission-types [collection-ids])
                               (p/map (fn [types]
                                        (reset! perm-types types)))
                               (process-error)))
        users (atom nil)
        form-disabled (atom false)
        show-spinner (atom false)
        save-disabled (atom false)
        load-users (fn [collection-ids]
                     (->> (collection-model/permitted-users
                            (if (= :compliance @task-type)
                              {:compliance-assign true}
                              {:task-assign true}) collection-ids)
                          (p/map (fn [response] (reset! users response)))
                          (process-error)))]
    (load-users collection-ids)
    (load-perm-types collection-ids)

    (fn []
      [:form.c-form--edit.o-media
       {:on-submit
        (util/handler (fn []
                        (when
                          (if (and (can-modify-step) @has-invalid-assignments)
                            (js/confirm (str "Would you like to replace the invalid user assignments with " (auth-model/get-full-name (api/get-auth-info :user)) "?" ))
                            true)
                          (reset! save-disabled true)
                          (reset! form-disabled true)
                          (->> (model/templategroup-apply-bulk
                                 (merge
                                   {:group_id @group
                                    :collection_id collection-ids
                                    :template_group_id @template-group-id
                                    :user_id @user-ids
                                    :complete_by (and @complete-by (util/local-date-time-to-date-string @complete-by))}))
                               (p/map (fn [operation-id]
                                        (reset! show-spinner true)
                                        (reset! bulk-operation-id-atom operation-id)
                                        (reset! errors nil)))
                               (p/error (fn [e]
                                          (reset! form-disabled false)
                                          (reset! save-disabled false)
                                          (throw e)))
                               (process-error errors)))))}
       [:fieldset
        [:legend "Selected collections"]
        [collection-list options collection-ids ]]

       ;; This guard dates from #187240831. The form now recounts on each users change,
       ;; so the guard only delays the form until the list arrives.
       (when @users
         [apply-from-template-details-form (assoc options :form-disabled @form-disabled)
          group perm-types task-type errors users can-add-step can-modify-step has-invalid-assignments
        {:template-group-id template-group-id
         :complete-by complete-by
         :user-ids user-ids}])
       [:footer.o-space-between
        [:button (merge
                   {:on-click (util/handler (:back-cb options))}
                   (when @bulk-operation-id-atom {:disabled :disabled})) "Back"]
        [:span
         (when @bulk-operation-id-atom
           [bulk-apply-from-template-status options group-id @bulk-operation-id-atom #(reset! show-spinner false)])
         [:span.u-margin-right]
         (if (and (not @show-spinner) @bulk-operation-id-atom)
           [:button {:type :button
                     :on-click (util/handler
                                 #(util/set-location
                                    (str (path-for :settings-bulkapply-details :operation-id @bulk-operation-id-atom)
                                         "?group_id="
                                         group-id)))}
            "Results"]
           [:button (merge
                      (when (or @save-disabled @bulk-operation-id-atom) {:disabled :disabled})
                      (when @show-spinner {:style {:width "4em"}}))
            (if @show-spinner [:img {:src "/static/img/ui/spinner.gif"
                                     :style {:height "1em"}}] "Save")])]]])))

(defn bulk-apply-from-template-status [options group-id bulk-operation-id finished-cb]
  (let [operation (atom nil)
        status-interval-id (atom nil)
        stop-refresh (fn [] (when @status-interval-id
                              (js/clearInterval @status-interval-id)
                              (reset! status-interval-id nil)))
        load-operation-status (fn []
                                (->> (admin-model/group-admin-bulk-operation group-id bulk-operation-id)
                                     (p/map (fn [op]
                                              (reset! operation op)
                                              (when (contains? #{"d" "f"} (get-in @operation [:details :status]))
                                                (stop-refresh)
                                                (finished-cb))))
                                     (process-error)))]
    (reset! status-interval-id (js/setInterval #(load-operation-status) 3000))
    (reagent/create-class
      {:reagent-render
       (fn [options group-id bulk-operation-id]
         [:span
          (case (get-in @operation [:details :status])
            "d" "Template application succeeded"
            "f" "Template application failed"
            "Template application in progress")])
       :component-will-unmount #(js/clearInterval @status-interval-id)})))

(defn bulk-apply-from-template-flow [options group-id task-type template-group-id]
  (let [selected-collections (atom #{})
        form-step (atom :choose)
        task-type (catom (keyword task-type))
        bulk-operation-id (atom nil)
        group (atom nil)]
    (->> (collection-model/permitted-groups nil)
        (p/map (fn [permitted-groups] (reset! group (first (filterv #(= (util/str->int group-id) (:id %)) permitted-groups)))))
        (process-error))
    (fn []
      [:section.redesign.u-shadow--bottom
       [header
        :title (str "Bulk apply a template in " (:name @group))
        :simple? true](case @form-step
                        :choose [bulk-apply-from-template-collection-chooser
                                 (assoc options
                                        :continue-cb #(reset! form-step :apply))
                                 group-id selected-collections]
                        :apply [bulk-apply-from-template
                                (assoc options
                                       :save-cb (fn [operation-id]
                                                  (reset! bulk-operation-id operation-id)
                                                  (reset! form-step :status))
                                       :back-cb #(reset! form-step :choose))
                                group-id task-type template-group-id selected-collections bulk-operation-id]
         :status [bulk-apply-from-template-status options group-id @bulk-operation-id])])))


(defn bulk-apply-from-template-collection-chooser [options group-id selected-collections]
  (let [collection-tree (atom nil)
        collection-types (atom nil)
        collection-type (atom nil)
        visible-matching-collections (catom #{})
        timeout (catom nil)
        aname (atom nil)
        last-name-filter-time (atom nil)
        continue-cb (or (:continue-cb options) (fn []))
        default-collapsed (atom false)
        collapsed (atom {})
        show-spinner (atom false)
        load-collection-tree (fn []
                               (reset! show-spinner true)
                               (->> (collection-model/collection-tree group-id false false {:name @aname
                                                                                            :type_id (util/to-value @collection-type)})
                                    (p/map (fn [response]
                                             (reset! show-spinner false)
                                             (reset! visible-matching-collections #{})
                                             (reset! collection-tree response)))
                                    (p/error (fn [e] (reset! show-spinner false)
                                               (throw e)))
                                    (process-error)))
        load-collection-types (fn []
                                (->> (coltype-model/collection-types group-id nil)

                                     (p/map #(reset! collection-types %))
                                     (process-error)))]
    (load-collection-tree)
    (load-collection-types)

    (add-watch aname :aname-watch (fn [_ _ _ new-name]
                       (when (let [cnt (count new-name)] (or (zero? cnt) (> cnt 2)))
                         (when @timeout
                           (reset! show-spinner false)
                           (js/clearTimeout @timeout)
                           (reset! timeout nil))
                         (reset! show-spinner true)
                         (reset! timeout
                                 (js/setTimeout (fn []
                                                  (load-collection-tree)) 1000)))))
    (add-watch collection-type :collection-type-watch (fn [& _] (load-collection-tree)))
    (fn [options group-id]
      [:section.o-main-aside
       [:main
        [:form.c-form--edit.o-media
         [:fieldset
          [:legend "Select collections" (when @show-spinner [:img {:src "/static/img/ui/spinner.gif"
                                                                    :style {:height "1em"
                                                                            :opacity "0.4"
                                                                            :margin "-2px 5px"}}])]]
         [:div.u-margin-bottom
          [:button {:on-click (util/handler (fn [_]
                                 (reset! collapsed {})
                                 (reset! default-collapsed false)))} "Expand All"]
          [:button {:on-click (util/handler (fn [_]
                                 (reset! collapsed {})
                                 (reset! default-collapsed true)))} "Collapse All"]
          [:button {:on-click (util/handler #(swap! selected-collections clojure.set/union @visible-matching-collections))}
           "Select All Visible"]
          [:button {:on-click (util/handler #(swap! selected-collections clojure.set/difference @visible-matching-collections))}
           "Unselect All Visible"]
          [:button {:on-click (util/handler #(reset! selected-collections #{}))}
           "Reset Selection"]]
         [bulk-apply-collection-tree {:selected-collections-atom selected-collections
                                      :visible-matching-collections-atom visible-matching-collections
                                      :default-collapsed default-collapsed
                                      :collapsed collapsed}
          collection-tree]]]
       [sidebar
        [:div.filter-item.u-margin-top.c-form--edit
         [:h3.u-margin-bottom.u-border-bottom.u-cursor--pointer #_ {:on-click (util/handler #(reset! filter-collection-types nil))} "Filter by name"]
         [:div.u-flex {:style {:flex-warap "nowrap"}}
          [:input.u-width--full {:on-change (fn [ev]
                                              (reset! aname (-> ev .-target .-value))
                                              (.preventDefault ev))
                                 :value @aname
                                 :autoComplete :off}]
          [:button.c-round-button {:style {:margin "0.5em 0.5em"}
                                   :on-click (util/handler #(reset! aname nil))} "×"]]
         [:h3.u-margin-bottom.u-border-bottom.u-cursor--pointer.u-margin-top "Filter by collection type"]
         [:div.u-flex {:style {:flex-warap "nowrap"}}
          [:select.c-field-inline__field {:on-change (fn [ev]
                                                       ((reset-from-event collection-type) ev))}
           [:option {:value ""} "Not selected"]
           (doall
             (for [coltype @collection-types]
               [:option (set-selected @collection-type (:id coltype) {:key (:id coltype)
                                                                      :value (:id coltype)})
                (get-in coltype [:asset_type :name]) ": " (:name coltype)])) ]
          [:button.c-round-button {:style {:margin "0.5em 0.5em"}
                                   :on-click (util/handler #(reset! collection-type nil))} "×"]]
         [:p.u-margin-top (count @selected-collections) " collection(s) selected."]
         [:div.o-flex-align--space-between.u-margin-top
          [:button
           {:on-click (util/handler
                       #(util/set-location
                         (str (path-for :templategroup-list) "?" (util/make-params (util/remove-nil-values (:waypoint-params options))))))}
           "Back"]
          [:button (merge {:on-click (util/handler continue-cb)}
                                                                 (when (zero? (count @selected-collections))
                                                                   {:disabled :disable}))"Continue"]]]]])))

(defn tree [options tree-item]
  (let [default-collapsed (:default-collapsed options)
        selected-collections (:selected-collections-atom options)
        visible-matching-collections (:visible-matching-collections-atom options)
        collapsed (:collapsed options)
        item-id (get-in tree-item [:item_data :id])
        is-collapsed (fn [item-id] (get @collapsed item-id @default-collapsed))]
    (if (:item_data tree-item)
      (let [match (get-in tree-item [:item_data :matched])] ^{:key item-id}
        (when match (swap! visible-matching-collections conj item-id))
        [tree-view
         {:nodeLabel
          (reagent/create-element
            "label"
            (clj->js {:style {:cursor :pointer}})
            (when match
              (reagent/create-element
                "input"
                (clj->js (dissoc (set-checked (contains? @selected-collections item-id)
                                   {:onChange (fn [ev]
                                                (if (checked? ev)
                                                  (swap! selected-collections conj item-id)
                                                  (swap! selected-collections disj item-id)))})
                           :on-change))))
            (get-in tree-item [:item_data :name]))
          :collapsed (is-collapsed item-id)
          :key item-id
          :on-click (util/handler (fn [] (swap! collapsed assoc item-id (not (is-collapsed item-id)))))}
         (doall (for [subitem (:subitems tree-item)]
                  ^{:key (:id subitem)} (tree options subitem)))])
      [:div {:key (str "tree-" item-id)}
       (doall (for [subitem (:subitems tree-item)]
                ^{:key (:id subitem)} (tree options subitem)))])))

(defn task-conversion-toggler [task]
  (let [conversions (set (:conversions @task))
        reload (fn []
                 (->> (model/task-details (:id @task) (util/date-string (:complete_by @task)))
                      (p/map #(reset! task %))
                      (process-error)))
        multistep (atom (not (contains? conversions "task_to_multistep")))
        task-to-multistep (fn [ev]
                            (->> (model/single-task-to-multistep (:id @task))
                                 (p/map (fn [_] 
                                          (reload)
                                          (reset! multistep true)))
                                 (process-error)))
        multistep-to-task (fn [ev]
                            (->> (model/multistep-task-to-singlestep (:id @task))
                                 (p/map (fn [_] 
                                          (reload)
                                          (reset! multistep false)))
                                 (process-error)))
        disabled (and (not (contains? conversions "multistep_to_task")) 
                      (not (contains? conversions "task_to_multistep")))]
    
    [disable-tool {:disabled disabled
                   :message "Can't convert to single step task"
                   :component [toggler {:checked multistep
                                        :disabled disabled
                                        :size "small"
                                        :on-change (cond (contains? conversions "task_to_multistep") task-to-multistep
                                                         (contains? conversions "multistep_to_task") multistep-to-task
                                                         :else "no conversion")}]}]))

(defn is-task-group-within-edit-window [task-group]
  (is-now-within-window (util/parse-datetime (:group_created_at task-group)) task-group-max-manage-age))

(defn task-group-details [options task permitted-groups]

  (let [task (atom task)
        occurrence-slice (atom (:occurrence_slice @task))
        occurrence-slices-cache (catom {(:id @task) @occurrence-slice})
        is-edit-group? (atom false)
        complete-by (atom (:complete_by @task))
        current-step-id (atom (if-let [show-step-idx (:show-step-idx options)]
                                (-> @task :cycle (nth show-step-idx) :task_id)
                                (:id @task)))
        is-user-task-creator #(= (api/get-auth-info :user-id) (:creator_id @task))
        edit-ability (cond
                       ;; Can modify and is creator of the task -- can update signature steps within time window
                       (and (get-in @task [:perms :can_modify])
                            (some model/is-any-signature-step (:cycle @task))
                            (is-user-task-creator)) (util/self-updating-atom #(if (is-task-group-within-edit-window @task) :edit-with-timer :edit))
                       (get-in @task [:perms :can_modify]) (atom :edit)
                       (not (get-in @task [:perms :can_add])) (atom nil)
                       (not= (api/get-auth-info :user-id) (:creator_id @task)) (atom nil)
                       :else (util/self-updating-atom #(when (is-task-group-within-edit-window @task) :edit-with-timer)))
        delete-prevention-delete-ability (common-model/delete-prevention-delete-ability (atom nil) @task :group_created_at)
        delete-ability (if (get-in @task [:perms :can_delete])
                         delete-prevention-delete-ability
                         (if (and
                               (get-in @task [:perms :can_add])
                               (is-user-task-creator))
                           (util/self-updating-atom #(and (is-task-group-within-edit-window @task) @delete-prevention-delete-ability))
                           (atom false)))
        allow-highlight (atom true)]

    ;; task atom is passed down a few times - hence this watch
    (add-watch task :group-details
               (fn [key atom old-state new-state]
                 (reset! occurrence-slice (:occurrence_slice new-state))
                 (swap! occurrence-slices-cache assoc (:id new-state) (:occurrence_slice new-state))))

    (controller/dispatch :task-links :clear)
    (controller/dispatch :task-links :load {:task-id (:id @task) :complete-by (:complete_by @task)})
    (reagent/create-class
      {:component-will-unmount
       (fn [_]
         (util/stop-self-updating! edit-ability)
         (util/stop-self-updating! delete-prevention-delete-ability)
         (util/stop-self-updating! delete-ability))
       :reagent-render
       (fn []
      (let [is-compliance? (:compliance @task)]

      [:div.page-padded.redesign {:class (if (:multi_step @task)
                                                             (if (:recurring @task)"multistep recurring" "multistep")
                                                             "simple")}

       [header
        :supertitle (get-in @task [:task_collections 0 :collection :ancestors 0 :name])
        :aside-title (if is-compliance? "compliance" "task")
        :subtitles (list  (when-let [rule (:rule @task)] (format "(Repeated %s)" (clojure.string/lower-case (:name rule)))))
        :subsubtitle (when-let [category (get-in @task [:category])] [:p.u-font-size--larger [:span.type-circle [:span (:type category)]] (:name category)])
        :title (model/group-task-name (if (:multi_step @task)
                                        (assoc @task :name (-> (filter (fn [step] (= @current-step-id (:task_id step))) (:cycle @task)) first :name))
                                        @task))
        :aside-subtitles (list ["Created" (when-let [date (get-in @task [:created_at])] (util/date-reformat date))]
                           (when-let [repeat-until (:repeat_until @task)] ["Repeated Until" (util/date-reformat repeat-until)])
                           (when (:recurring @task) ["First Occurrence" (when-let [date (get-in @task [:first :complete_by])] (util/date-reformat date))] )
                           (when (:recurring @task) ["Last Occurrence" (when-let [date (get-in @task [:last :complete_by])] (util/date-reformat date))]))
        :controls [:div
                   [:div.u-vertical-align--middle (when-not (:compliance @task)
                                                    [:span
                                                     [:span.single-step "Single Step"] 
                                                     (task-conversion-toggler task) 
                                                     [:span.multi-step "Multi Step"]])]
                   [:div.row.icons
                    (when @edit-ability
                      (let [editable? (:group_editable @task)
                            edit-icon (fn [on-click]
                                        [disable-tool {:disabled  (not editable?)
                                                       :message   "Edit disabled"
                                                       :component [:img.svg-icon--md.u-cursor--pointer
                                                                   {:src      "/static/img/icons/edit.svg"
                                                                    :title    "Edit"
                                                                    :on-click (when editable? on-click)}]}])]
                        [:div.edit
                         [countdown-for-ability nil (util/parse-datetime (:group_created_at @task)) task-group-max-manage-age edit-ability delete-ability]
                         (if (:multi_step @task)
                           (when-not @is-edit-group?
                             (edit-icon #(swap! is-edit-group? not)))
                           (edit-icon #(set-location (str "#/task/edit/" (:id @task) "/" (model/complete-by-date @task) "/"))))]))
                    (when @delete-ability
                      [:img.svg-icon--md.u-cursor--pointer
                       (merge
                         {:src "/static/img/icons/delete.svg"
                          :title (str "Delete" (if (:compliance @task) " compliance" " task"))
                          :on-click (fn [ev]
                                      (let [errors                     (atom {})
                                            control-phrase             (atom "")
                                            title                      (str (if (:compliance @task) "Compliance" "Task") " delete")
                                            text                       (str "Are you sure you want to delete \""
                                                                         (or (not-empty (:group_name @task)) (:name @task)) "\"?")]
                                        (if (:compliance @task)
                                          (common/show-controled-confirmation-modal
                                            {:title         "Compliance delete"
                                             :text           text
                                             :ok-cb          (fn []
                                                               (->> (model/group-delete (:group_id @task) control-phrase)
                                                                 (p/map
                                                                   (fn []
                                                                     (go-to-deletion-waypoint
                                                                       :task-list
                                                                       :query-params
                                                                       (str "task_type=compliance"))
                                                                     (common/hide-controled-confirmation-modal)))
                                                                 (process-error errors)))
                                             :errors         errors
                                             :control-phrase control-phrase})
                                          (common/show-confirmation-modal
                                            {:title   "Task delete"
                                             :text   text
                                             :ok-cb  (fn []
                                                       (->> (model/group-delete (:group_id @task) nil)
                                                         (p/map
                                                           (fn []
                                                             (go-to-deletion-waypoint
                                                               :task-list
                                                               :query-params
                                                               (str "task_type=simple"))
                                                             (common/hide-confirmation-modal)))
                                                         (process-error errors)))
                                             :errors errors}))))}
                         (when (:deletion_locked @task) {:disabled :disabled}))])]]
        :label (map :name (:labels @task))
        :options {}]

       [:div {:class (if (:recurring @task ) "o-media" "o-media--bottom-shadow-1" )}

        (if (:multi_step @task)

          (if @is-edit-group?
            [multistep-edit-group-edit #(reset! is-edit-group? false) permitted-groups task]

            [:section
             [assignment-list-with-header {:hide-expander true} (get-assignments @task)]
             [linked-items-all-multi-step nil task]
             (when-let [cr (:collection_review @task)]
               (let [label (str "Collection Review - " (:collection_name cr) " - " (util/date-string (:saved_at cr)))]
                 [:div.c-task__review-report
                  [common/pdf-download-button
                   {:ajax-url          (str "/collection/" (:collection_id cr) "/review/" (:review_id cr) "/report")
                    :temp-url-ajax-url (str "/collection/" (:collection_id cr) "/review/" (:review_id cr) "/report-url")
                    :component         :a.c-task__review-report__link
                    :open-new-tab      true}
                   label]]))])

          [:section
           [assignment-list-with-header {:hide-expander true} (get-assignments @task)]
           [linked-items-all-single-step nil task]
           (when-let [cr (:collection_review @task)]
             (let [label (str "Collection Review - " (:collection_name cr) " - " (util/date-string (:saved_at cr)))]
               [:div.c-task__review-report
                [common/pdf-download-button
                 {:ajax-url          (str "/collection/" (:collection_id cr) "/review/" (:review_id cr) "/report")
                  :temp-url-ajax-url (str "/collection/" (:collection_id cr) "/review/" (:review_id cr) "/report-url")
                  :component         :a.c-task__review-report__link
                  :open-new-tab      true}
                 label]]))])]

       (when (:recurring @task)
         (let [occurence-slice-count (count @occurrence-slice)]

           [:div.c-occurrences-nav (when (< occurence-slice-count 4) {:class "narrow"})

           [:div.c-occurrences-nav__dates
            (when-let [previous (:previous @task)]
              [:a.c-occurrences-nav__previous {:href (str "#/task/details/" (:task_id previous) "/" (util/date-string (:complete_by previous)) "/")}])

            (doall
              (let [tasks-count (count @occurrence-slice)
                    opacity-range (* (/ 1 tasks-count) 2)
                    calculate-opacity (fn [idx] (* opacity-range (+ idx 1)))
                    middle (/ tasks-count 2)
                    reverse-index-after-mid (fn [idx] (if (> idx middle) (- (- tasks-count 1) idx) idx))]

                (map-indexed
                  (fn [idx occ]
                    [:span.c-occurrences-nav__occurrence
                     {:key (:complete_by occ) :style {:opacity (calculate-opacity (reverse-index-after-mid idx))}
                      :class (when (= (:complete_by occ) @complete-by) "is-active")}

                     [:span.complete-status
                      [:span (merge {} (when (:complete occ) {:class "complete"}))]]

                     [:a {:href (str "#/task/details/" (:task_id occ) "/" (util/date-string (:complete_by occ)) "/")}
                      (util/date-reformat (:complete_by occ) util/date-format-full-year)]]) @occurrence-slice)))

            (when-let [next (:next @task)]
              [:a.c-occurrences-nav__next {:href (str "#/task/details/" (:task_id next) "/" (util/date-string (:complete_by next)) "/")}])]]))

       [task-details-component {:highlight-comment-id (:highlight-comment-id options)
                                :highlighted (and (:highlighted options) @allow-highlight)
                                :change-step-cb (fn [task-id complete-by-value]
                                                  (reset! allow-highlight false)

                                                  (.replaceState js/history nil ""
                                                                 (path-for :task-details
                                                                                      :id task-id
                                                                                      :complete_by complete-by-value))

                                                  (reset! current-step-id task-id)

                                                  (if-let [step-occurrence-slice (@occurrence-slices-cache task-id)]
                                                    ;; Using cache
                                                    (do
                                                      (reset! occurrence-slice step-occurrence-slice)
                                                      (reset! complete-by complete-by-value))
                                                    ;; Loading task details
                                                    (->> (model/task-details task-id (util/date-string complete-by-value))
                                                         (p/map (fn [{step-occurrence-slice :occurrence_slice
                                                                      complete-by-value :complete_by}]
                                                                  (reset! occurrence-slice step-occurrence-slice)
                                                                  (reset! complete-by complete-by-value)
                                                                  (swap! occurrence-slices-cache assoc task-id step-occurrence-slice)))
                                                        (process-error))))
                                :permitted-groups permitted-groups
                                :edit-ability-atom edit-ability
                                :delete-ability-atom delete-ability} task current-step-id ]]))})))

(defn step-date [options index task step-details-info update-fn]
  (let [component-node (atom nil)
        step-date->js  (fn [step] (some-> step :complete_by (str "T00:00:00") js/Date.))
        shift-min-date (fn [] (some-> (get-in @task [:cycle (dec index)]) step-date->js))]
   (reagent/create-class
     {:component-did-mount (fn [_]
                             (when (not (:compliance @task))
                               (js/Pikaday. #js {:field (sel1 @component-node :input.date)
                                                 :trigger (sel1 @component-node :span.date)
                                                 :onSelect (fn [selected-date]
                                                             (update-fn selected-date step-details-info false))}))
                             (when (not (:compliance @task))
                               (js/Pikaday. #js {:field   (sel1 @component-node :input.shift)
                                                 :trigger (sel1 @component-node :span.shift)
                                                 :minDate (shift-min-date)
                                                 :onSelect (fn [selected-date]
                                                             (update-fn selected-date step-details-info true))})))
      :reagent-render (fn [{:keys [last-complete-index] :as options} index task step-details-info update-fn]
                        [:div.c-task-center__due {:ref #(reset! component-node %)}
                         [:input.date {:value (:complete_by step-details-info) :type "hidden"}]
                         [:input.shift {:value (:complete_by step-details-info) :type "hidden"}]
                         [:span.date {:class (when-not (:editable step-details-info) "u-non-clickable")}
                          (util/date-reformat (:complete_by step-details-info))]
                         (when-not (:compliance @task) [:span.shift.date-shift-button {:class (util/classes
                                                                                               (when-not (:editable step-details-info) "u-non-clickable")
                                                                                               (when-not (or (nil? last-complete-index) (> index last-complete-index))
                                                                                                 "u-display--none"))}
                                                        " ↕"])])})))

(defn independent-group-setup [group-mode-atom group-step-indexes-atom step-idx]
  (reset! group-mode-atom true)
  (swap! group-step-indexes-atom #(if (contains? % step-idx)
                               (disj % step-idx)
                               (conj % step-idx))))

(defn task-details-component [{:keys [highlight-comment-id change-step-cb permitted-groups highlighted]} task current-step-id]
  (let [is-compliance? (:compliance @task)

        create-comments-summary (fn [task] (into {} (mapv (fn [step] [(keyword (str (:task_id step))) (atom nil)]) (:cycle @task))))

        comments-summary (atom (create-comments-summary task))

        load-comments-summary (fn [task-id complete-by]
                                (->> (model/task-comments-summary task-id complete-by)
                                     (p/map #(doseq [[step-id-kw summary] %] (reset! (step-id-kw @comments-summary) summary)))
                                     (process-error)))


        scroll-after-occurrences? (atom false)

        create-collapsed-map (fn [task-value]
                               (into {} (map (fn [step]
                                               [(-> step :task_id str keyword)
                                                {:linked-comments-collapsed? (atom false)
                                                 :comments-collapse? (atom true)
                                                 :edit-collapsed? (atom true)}]) (:cycle @task-value))))

        collapsed-map (atom (create-collapsed-map task))

        _ (load-comments-summary (:id @task) (util/date-string (:complete_by @task)))

        update-step-date (fn [date step shift]
                           (let [first-step (get-in @task [:cycle 0])
                                 updated-date-formatted (util/local-date-time-to-date-string date)]

                             (->> (model/task-update (:task_id step)
                                                     (merge {:name (:name step)
                                                             :description (:description step)
                                                             :user_id (:user_id step)
                                                             :complete_by updated-date-formatted
                                                             :first_step_id (:task_id first-step)
                                                             :first_step_complete_by (:complete_by first-step)
                                                             :priority (:priority step)
                                                             :signature_scope (:signature_scope step)}
                                                            (when shift {:edit_type "shift_steps"})))

                                  (p/map (fn [response]
                                           (let [new-date (get-in response [:redirect :complete_by])]

                                             (set-flash :success "Date changed")

                                             ;on succesful answer update task information
                                             (->> (model/task-details (:task_id step) (util/date-string new-date))

                                                  (p/map (fn [response]
                                                           (change-step-cb (:task_id step) updated-date-formatted)
                                                           (reset! task response)))))))

                                  (p/error (fn [err]
                                             (if (= (:status err) 422)
                                               (let [validation-errors (valid/field-errors (get-in err [:response :body]))]
                                                 (if (contains? validation-errors :complete_by)
                                                   (set-flash :error (:complete_by validation-errors))
                                                   (throw err)))
                                               (throw err))))
                                  (process-error))))

        add-task-form-show? (atom false)
        group-mode (atom false)
        group-step-indexes (atom nil)
        set-group-step-indexes (fn []
                                 (reset! group-step-indexes (set (map :step_idx (filter :not_dependent (:cycle @task))))))
        _ (set-group-step-indexes)
        initial-group-step-indexes (atom @group-step-indexes)
        group-setup-cb (fn [step-idx] (independent-group-setup group-mode group-step-indexes step-idx))]
    
    (add-watch task :watcher
               (fn [key task-atom old-task new-task]
                 (let [new-task-cycle-count (-> new-task :cycle count)
                       old-task-cycle-count (-> old-task :cycle count)
                       last-step (-> new-task :cycle last)
                       first-step (-> new-task :cycle first)]

                   (when-not (= new-task-cycle-count old-task-cycle-count)

                     (reset! collapsed-map (create-collapsed-map task-atom))
                     (reset! comments-summary (create-comments-summary task-atom))

                     ;if new-step was added - change-step-cb to newly added.
                     ;Otherwise (e.g. step was deleted) - change-step-cb to first remaining step
                     (if (> new-task-cycle-count old-task-cycle-count)
                       (change-step-cb (:task_id last-step) (:complete_by last-step))
                       (change-step-cb (:task_id first-step) (:complete_by first-step)))))))

    (controller/dispatch :permitted-users :load
                         (merge
                          {:collection-ids (mapv #(:id %) (:collections @task))}
                          (if (:compliance @task)
                            {:compliance-assign true}
                            {:task-assign true})))

    (reagent/create-class

     {:display-name "task-details-component"

      :reagent-render
      (fn [options task]
        (let [step-edited? (some (fn [[k v]] (not @(:edit-collapsed? v))) @collapsed-map)
              multi-step (@task :multi_step)
              more-than-one-step? (> (-> @task :cycle count) 1)
              [first-unsigned-index _] (first (filter (fn [[index step]] step)
                                                      (map-indexed (fn [index step]
                                                                     [index (and (not (:complete step)) (or
                                                                                                         (model/is-signature-step step)
                                                                                                         (model/is-boir-link-sign-step step)
                                                                                                         (model/is-cycle-signature-step step)))])
                                                                   (:cycle @task))))
              [first-incomplete-index _] (first (filter (fn [[index step]] step)
                                                        (map-indexed (fn [index step] [index (not (:complete step))]) (:cycle @task))))
              [last-complete-index _] (last (filter (fn [[index complete]] complete)
                                                    (map-indexed (fn [index step] [index (:complete step)]) (:cycle @task))))]

          [:div.task-details.c-task-center.u-shadow--bottom {:class (when (or @add-task-form-show? step-edited?) "u-non-clickable")}
           (when @group-mode
              [group-independent-tasks {:group-mode group-mode
                                        :group-step-indexes group-step-indexes
                                        :initial-group-step-indexes initial-group-step-indexes
                                        :cancel-cb (fn []
                                                     (reset! group-step-indexes @initial-group-step-indexes)
                                                     (reset! group-mode false))} task])
           (doall
            (map-indexed
              (fn [index step-details-info]
                (let [step-id-keyword (-> step-details-info :task_id str keyword)
                      step-edit-collapsed? (:edit-collapsed? (step-id-keyword @collapsed-map))
                      is-highlighted (and (= (:id @task) (:task_id step-details-info)) (:highlighted options))
                      alert (:alert step-details-info)
                      alert-options {:on? (atom (:enabled alert))
                                     :enabled (atom (:enabled alert))
                                     :before-due-days (atom (if alert (:before_due_days alert) 0))
                                     :past-due-days (atom (if alert (:past_due_days alert) 0))
                                     :edited? false
                                     :complete-by  (:complete_by step-details-info)
                                     :task task}
                      is-current-step? (= @current-step-id (:task_id step-details-info))
                      is-independent-step? (some #(= % (:step_idx step-details-info)) @group-step-indexes)
                      is-orphan? (fn []
                                   (let [steps (:cycle @task)
                                         step-idx (:step_idx (nth steps index))
                                         nondependent-forbidden? (fn [step]
                                                                   (or
                                                                     (boolean (get-in step [:alert :enabled]))
                                                                     (contains? model/nondependent-group-forbidden-step-types (:signature_scope step))))]
                                     (cond
                                       (= (count steps) 1) true
                                       (= step-idx 1) (nondependent-forbidden? (nth steps (inc index)))
                                       (= step-idx (count steps))  (nondependent-forbidden? (nth steps (dec index)))
                                       (and (> step-idx 1) (< step-idx (count steps))) (and (nondependent-forbidden? (nth steps (dec index)))
                                                                                               (nondependent-forbidden? (nth steps (inc index))))
                                       :else false)))]

                  [:div.o-main-aside.c-task-center__wrapper
                   {:class (str (if (and (not @add-task-form-show?)
                                         multi-step
                                         is-current-step?) "is-active "
                                    (when (not multi-step) "is-single-task"))

                                (when (not @step-edit-collapsed?) " is-edited ")
                                (condp = (:signature_scope step-details-info)
                                  model/signature-type-step " is-step-signarue "
                                  model/signature-type-document " is-step-signarue "
                                  model/signature-type-boir-link-sign " is-step-signarue "
                                  model/signature-type-cycle " is-cycle-signarue "
                                  " ")
                                (when is-highlighted " is-highlighted "))

                   :key (:task_id step-details-info)

                   :on-click (fn [e] (let [task-id (:task_id step-details-info)]
                                       (when-not (= task-id @current-step-id)
                                         (if @group-mode
                                           (when-not (or (:enabled alert) 
                                                         (contains? model/nondependent-group-forbidden-step-types (:signature_scope step-details-info)) 
                                                         (is-orphan?))
                                             (group-setup-cb (:step_idx step-details-info)))
                                           (change-step-cb task-id (:complete_by step-details-info))))))}
                  (when multi-step
                    [:aside.o-main-aside__aside--x-small-fixed.c-task-center__summary-wrapper.o-media--bottom-shadow {:key index
                                                                                                                      :class (when is-independent-step? "is-independent")}
                     [:div.c-task-center__summary
                      [:span] [:span]
                      [:div.c-task-center__controls
                       [:div.c-task-center__alert
                        [disable-tool  {:disabled is-independent-step?
                                        :message "Alert can not be set for independent steps"
                                        :component [toggle-alert (merge alert-options
                                                                        (when (or is-independent-step? @group-mode) {:disabled :disabled})) (:task_id step-details-info)]}]]
                       [:div.c-task-center__independent-group
                        (when (not is-compliance?)
                          (let [disabled? (or (:enabled alert) 
                                              (not @step-edit-collapsed?) 
                                              (is-orphan?)
                                              (contains? model/nondependent-group-forbidden-step-types (:signature_scope step-details-info)))]
                            (when (get-in @task [:perms :can_modify])
                              [disable-tool 
                               {:disabled disabled?
                                :message (cond
                                           (:enabled alert) "Step can not be marked as independent for step with alert enabled"
                                           (not @step-edit-collapsed?) "Step can not be marked as independent while editing"
                                           (is-orphan?) "Step can not be marked as independent for single step group"
                                           :else "Mark step as independent disabled")
                                :component [:span (when-not disabled?
                                                    {:class "u-cursor--pointer"
                                                     :on-click (util/handler (fn []
                                                                               (group-setup-cb (:step_idx step-details-info))))})
                                            [:img  {:src "/static/img/icons/group-steps.svg"}]]}])))]]
                      
                      [:span.c-task-center__step-number (+ 1 index) "."]  
                      
                      [:h3.c-task-center__name (model/task-name step-details-info)]

                      [:span.c-task-center__status
                       ;;  Display check mark
                       (when (and (:complete step-details-info)
                                  (not (model/is-cycle-signature-step step-details-info))
                                  (not (model/is-signature-step step-details-info))
                                  (not (model/is-boir-link-sign-step step-details-info))
                                  (not (model/is-document-signature-step step-details-info)))
                         [:span.c-task-center__complete])
                       
                       ;; Display padlock
                       (if (model/is-cycle-signature-step step-details-info)
                         [signature-status model/signature-type-cycle (:complete step-details-info)]
                         
                         [:span
                          (when (or (model/is-signature-step step-details-info) (model/is-document-signature-step step-details-info) (model/is-boir-link-sign-step step-details-info))
                            [signature-status model/signature-type-step (:complete step-details-info)])
                          (when (model/has-cycle-signature step-details-info)
                            [signature-status model/signature-type-cycle true])])] [step-date {:last-complete-index last-complete-index} index task step-details-info update-step-date]
                      [:span] (when-let [user (:user step-details-info)] [:div.c-task-center__assigned-to
                                                                          (auth-model/get-full-name user)])
                      [:span] [:span
                               (when (and (not is-compliance?) (:priority step-details-info))
                                 [:div.c-task-center__priority {:class (str/replace (model/priority-name step-details-info) " " "-")} [:b "Priority: "] (model/priority-name step-details-info)])]]])

                  [:main.c-task-center__details.o-media--bottom-shadow {:key (:task_id step-details-info) :id (:task_id step-details-info)}

                   (if @step-edit-collapsed?

                      [step-details
                       {:highlight-comment-id (:highlight-comment-id options)
                        :is-highlighted is-highlighted
                        :first-unsigned-index first-unsigned-index
                        :first-incomplete-index first-incomplete-index
                        :last-complete-index last-complete-index
                        :conversations-reload-cb (partial load-comments-summary (:id @task) (util/date-string (:complete_by @task)))
                        :update-counter (fn [counter-swapper]
                                          (let [updated-step-details
                                                (update-in step-details-info [:counters :comment_count] counter-swapper)]

                                           (swap! task assoc-in [:cycle index] updated-step-details)))

                       :collapsed-map (@collapsed-map (-> step-details-info :task_id str keyword))
                       :change-step-cb change-step-cb
                       :permitted-groups permitted-groups
                       :edit-ability-atom (:edit-ability-atom options)
                       :delete-ability-atom (:delete-ability-atom options)}
                      step-details-info task (step-id-keyword @comments-summary)]
                     [multistep-edit-step-form step-details-info task #(reset! step-edit-collapsed? true) change-step-cb more-than-one-step? set-group-step-indexes])]]))

             (:cycle @task)))

           (when multi-step
             (if @add-task-form-show?

               [:div.o-media.c-task-center__add {:class (when @add-task-form-show? "u-clickable")}

                [multistep-edit-step-form nil task #(reset! add-task-form-show? false) change-step-cb false nil]]

               (when (and (:group_editable @task) (not (model/is-cycle-signature-step (last (:cycle @task)))))
                 [:div.o-media.o-flex-align--right
                  [:button {:disabled (when step-edited? true)
                            :on-click #(reset! add-task-form-show? true)} "Add Step +"]])))]))})))


(defn- step-details [{:keys [conversations-reload-cb collapsed-map highlight-comment-id update-counter change-step-cb permitted-groups is-highlighted]}
                     step-details-info task comments-summary]

  (let [task-id (:task_id step-details-info)
        comments-count (atom (if-let [comment-count (get-in step-details-info [:counters :comment_count])] comment-count 0))
        notify-user-choices (subscribe :permitted-users)]
    (fn [{:keys [conversations-reload-cb collapsed-map highlight-comment-id update-counter _ _ is-highlighted]
          :as options}
         step-details-info task comments-summary]

      (let [step-complete-by (model/complete-by-date step-details-info)
            multi-step? (@task :multi_step)]

        [:div {:ref (fn [elem] (when (and elem is-highlighted)
                                  (-> elem
                                      (.scrollIntoView #js {:behavior "smooth" :block "center"}))))}
         (if multi-step?
           [multi-step-task (select-keys options [:first-unsigned-index
                                                  :first-incomplete-index
                                                  :last-complete-index
                                                  :edit-ability-atom
                                                  :delete-ability-atom]) task step-details-info {:collapsed-map collapsed-map}]
           [single-task task :change-step-cb change-step-cb :permitted-groups permitted-groups])

         [comment-comp/comments-summary @comments-summary]

         (let [comment-errors (atom {})
               attach-to-all (catom "no")]

           [comment-comp/expandable-conversation-list
            (merge
              {:highlight-comment-id highlight-comment-id
               :users @notify-user-choices
               :user-perms (:perms @task)
               :rich-text true
               :errors-atom comment-errors
               :comment-count comments-count
               :comments-collapse? (collapsed-map :comments-collapse?)
               :reload-cb conversations-reload-cb
               :step-complete-bv step-complete-by
               :add-func (fn [conversation conversation-id note subject body notify-user-ids notify-cc-user-ids include-body allow-inbox-reply revised-comment-id]
                           (model/task-add-comment
                             task-id
                             (let [complete-by (util/date-string (:complete_by step-details-info))]
                               (if conversation
                                 (when (:occurrence_id conversation) complete-by)
                                 (when (= @attach-to-all "no") complete-by)))
                             conversation-id
                             note
                             subject
                             body
                             notify-user-ids
                             notify-cc-user-ids
                             include-body
                             allow-inbox-reply
                             "task"
                             revised-comment-id))

               :update-func (fn [comment-id subject body notify-user-ids notify-cc-user-ids include-body allow-inbox-reply]
                              (model/task-update-comment
                                task-id
                                comment-id
                                subject
                                body
                                notify-user-ids
                                notify-cc-user-ids
                                include-body
                                allow-inbox-reply))

               :delete-func (fn [comment-id notify-user-ids]
                              (model/task-delete-comment
                                task-id
                                comment-id
                                notify-user-ids))
               :update-counter update-counter}

              (when (:recurring @task)
                {:extra-edit-new-conversation-components [:div.attach-to "Attached to: " [:select {:on-change (reset-from-event attach-to-all)}
                                                                                          [:option (option-value @attach-to-all "yes") "All"]
                                                                                          [:option (option-value @attach-to-all "no") "This occurrence (" (util/date-reformat (:complete_by step-details-info)) ")"] ]]}))

            (fn []
              (model/task-comments (:task_id step-details-info) step-complete-by "task"))])]))))

(defn description-section [description-data options]

  (let [collapsed? (atom false)]

    (fn [description-data options]

      [:div.o-collapsable {:class (when @collapsed? "is-collapsed ") }

       [:h4.c-heading [:span "Description:"]
        [:a.o-collapsable__expander {:on-click (fn [] (swap! collapsed? not))}]]
       [:p.u-preserve-whitespace description-data]])))

(defn linked-items-with-chooser [task show-task-linked-items
                                 {:keys [linked-items-comments-summary-collapsed?
                                         parent-type exclude-types type disabled]} options]
  (let [all-task-links (subscribe :task-links)
        task-links (track! (fn [] (get-in @all-task-links [(:id task) "_all_"])))
        occurrence-links (track! (fn [] (get-in @all-task-links [(:id task) (model/complete-by-date task)])))
        load-linked-items (fn []
                            (controller/dispatch :task-links :load {:task-id (:id task) :complete-by (model/complete-by-date task)}))]

    (fn [task show-task-linked-items
         {:keys [linked-items-comments-summary-collapsed? parent-type exclude-types type disabled]} options]
      [:div
       [:h4.c-heading.o-margin-elements--md
        [:span "Related Records " (link/linked-items-counter @occurrence-links (when show-task-linked-items @task-links) true)]
        [link/link-add-chooser {:exclude-types #{exclude-types}
                                :initial-collection-id (:id (first (:collections task)))
                                :parent-collection-ids (mapv #(:id %) (:collections task))
                                :parent {:type type
                                         :id (:id task)
                                         :complete-by  (:complete_by task)}
                                :disabled disabled
                                :linked-items-documents-download [link/linked-items-documents-download-form (:download_key @occurrence-links)]}]]

       [link/linked-items {} [(link/link-map-entry {:parent-type parent-type
                                                          :parent-id (:occurrence_id task)
                                                          :reload load-linked-items
                                                          :disabled disabled} (:children @occurrence-links))
                                    (when show-task-linked-items
                                      (link/link-map-entry {:disabled disabled :items-type "parent"} (:parents @task-links)))]]])))

(defn single-task [task & {:keys [change-step-cb permitted-groups]}]

  (let [document-collapsed? (atom false)

        collapsed? (atom false)

        datepicker-mount-fns (atom [])

        group (atom (:id (first permitted-groups))) ;; group as in family

        update-task-date (fn [selected-date]
                           (let [updated-date (util/local-date-time-to-date-string selected-date)]

                            (->> (model/single-task-update (:id @task)
                                                           {:complete_by updated-date
                                                            :group_id @group
                                                            :collection_id (mapv (fn [collection] (:collection_id collection)) (:task_collections @task))
                                                            :user_id (get-in @task [:cycle 0 :user_id])
                                                            :name (:name @task)
                                                            :main_collection_id (:collection_id (first (filterv
                                                                                          #(:main %)
                                                                                          (:task_collections @task))))
                                                            :priority (:priority @task)
                                                            :category_id (get-in @task [:category :id])
                                                            :description (:description @task)
                                                            :rule_id (to-value (get-in task [:rule :id]))
                                                            :repeat_until (:repeat_until @task)})

                                 (p/map (fn [response]

                                          (set-flash :success "Date changed")

                                          ;on succesful answer update task information
                                          (->> (model/task-details (:id @task) updated-date)

                                               (p/map (fn [response]
                                                        (reset! task response)
                                                        (controller/dispatch :task-links :load {:task-id (:id @task) :complete-by updated-date})
                                                        (change-step-cb (:id @task) updated-date))))))
                                 (process-error))))]

    (reagent/create-class
      {:display-name "single-task"

       :component-did-mount (fn [_]
                              (doseq [func @datepicker-mount-fns] (func)))
       :reagent-render
      (fn [task]
        (let [alert (get-in @task [:cycle 0 :alert])
              alert-options {:on? (atom (:enabled alert))
                             :enabled (atom (:enabled alert))
                             :before-due-days (atom (if alert (:before_due_days alert) 0))
                             :past-due-days (atom (if alert (:past_due_days alert) 0))
                             :edited? false
                             :task task
                             :complete-by (:complete_by @task)
                             :position alert-position-left}]
          
          [:div {:class (when @collapsed? "is-collapsed")}
           [:div.o-flex-align--space-between
            [:div
             [:b "Assigned to:"]
             (when-let [user (:user @task)] [:p (auth-model/get-full-name user)])]

            [:div
             [:span.c-task-center__priority {:class (str/replace (model/priority-name @task) " " "-")} 
              [:b "Priority: "] [:span (model/priority-name @task)]]
             
             [:div.u-vertical-align--middle.u-padding-bottom--xs 
              {:ref (fn [com]
                      (when com
                        (swap! datepicker-mount-fns conj (fn []
                                                           (js/Pikaday. #js {:field (sel1 com :input)
                                                                             :trigger (sel1 com :span)
                                                                             :onSelect (fn [selected-date]
                                                                                         (update-task-date selected-date))})))))}
              [:b "Due: "]
              [:input {:value (:complete_by @task) :type "hidden"}]
              [:span {:class (when-not (:editable @task) "u-non-clickable")}
               (util/date-reformat (:complete_by @task))]
              [:span [toggle-alert alert-options (:id @task)]]]
             [:div.u-vertical-align--middle [toggle-complete-button nil task nil]]
             [:div.u-font-size--xsmall
                (when (:complete @task)
                  [:label
                   (util/date-format-date-hour-minute (util/parse-datetime-local (:client_complete_time @task))) 
                   (when-let [completed-by-user (not-empty (get-in @task [:cycle 0 :completed_by_user]))]
                     [:span [:br] "by " (auth-model/get-full-name completed-by-user)])])]]]

           (when-let [step-description-data (not-empty (get-in @task [:cycle 0 :description]) )]
             [description-section step-description-data nil])

           [linked-items-with-chooser @task (not (boolean (:rule task)))
            {:linked-items-comments-summary-collapsed? collapsed?
             :parent-type "to"
             :type link/type-task-occurrence
             :object-type "task"}]]))})))

(defn toggle-complete-button [options task step]
  (let [complete? (atom (:complete (if step step @task)))
        errors (atom nil)
        token (atom nil)
        toggle-complete (fn [occ]
                          (->> (model/task-toggle-complete
                                 (when (model/is-any-signature-step step) {:skip-default-fail true})
                                 (if step (:task_id occ) (:id occ))
                                 (util/date-string (:complete_by occ))
                                 (not (:complete occ))
                                 @token)
                               (p/map (fn [_]
                                        (update-alert-count!)
                                        (->> (model/task-details
                                               (if step (:task_id occ) (:id occ))
                                               (util/date-string (:complete_by occ)))
                                             (p/map (fn [response]
                                                      (reset! task response)
                                                      (reset! complete? (boolean (:complete response))))))))))]

    (fn [options task step]
      [:span.u-vertical-align--middle 
       [:label.complete {:class (when @complete? "completed")}         
        (condp = (:signature_scope step)
          model/signature-type-step (if @complete? "Unsign" "Sign")
          model/signature-type-boir-link-sign (if @complete? "Unsign" "Sign")
          model/signature-type-document (if @complete? "Unsign" "Sign")
          model/signature-type-cycle (str (if @complete? "Unsign " "Sign ") (if (:compliance @task) "compliance" "task"))
          "Complete")

        [disable-tool {:disabled (:disabled options)
                       :message (:title options)
                       :component [toggler (merge {:checked complete?
                                                   :on-change (util/handler (fn []
                                                                              (if-not (model/is-any-signature-step step)
                                                                                (->> (toggle-complete (if step step @task))
                                                                                     (process-error))
                                                                                (do (reset! errors nil)
                                                                                    (reset! token nil)
                                                                                    (reset! state/step-sign-auth-modal {:enabled true
                                                                                                                        :errors-atom errors
                                                                                                                        :token-atom token
                                                                                                                        :toggle-complete (partial toggle-complete (if step step @task))})))))}
                                                  (when (:disabled options) {:disabled :disabled}))]}]]])))

(defn signature-status [scope signed?]
  [:span.c-signature-status
   [padlock nil signed? (= scope model/signature-type-cycle)]])

(defn drobox-sign-button [options step family-id]
  (let [all-task-links (subscribe :task-links)
        occurrence-links (track! (fn [] (get-in @all-task-links [(:task_id step) (model/complete-by-date step)])))
        has-pdfs? (fn [] (some #(get-in % [:is_pdf] true) (concat (:parents @occurrence-links) (:children @occurrence-links))))
        signature-status (subscribe :signature-status)
        *create-step (atom :signers)]
    (controller/dispatch :signature-status :load [{} {:occurrence_id (:id step)}])
    (fn [options step]
      (if (contains? @signature-status (:id step))
        (let [sgn (get @signature-status (:id step))
              has-pdfs (has-pdfs?)]
          [:span
           [:button (merge {:on-click (util/handler
                                        (fn []
                                          (common/show-modal :signature-create [signature/dropbox-sign-modal step family-id] {:modal-class :c-signature-create})))}
                      (when (or
                              (not has-pdfs)
                              (not (nil? (:status sgn)))
                              (:complete step))
                        (merge
                          {:disabled :disabled}
                          (when-not has-pdfs {:title "PDF documents must be linked to step before you can Send for Signature"}))))
            (case (:status sgn)
              "c" "Signature Obtained"
              nil "Send for Signature"
              "xp" "Pending Signature Cancellation"
              "Pending Signature")]
           " "
           (when (and sgn (not= "x" (:status sgn)))
             [:button {:on-click (util/handler
                                   (fn []
                                     (controller/dispatch :signature-status :load [{} {:occurrence_id (:id step)}])
                                     (common/show-modal :signature-details [#'signature/signature-details nil sgn] nil)))} "Signature Details"])]);;
        [:span]))))

(defn e-file-boir-buttons [options task step]
  (let [submissions (subscribe :boir-occurrence-submissions)
        current-submission (subscribe :boir-occurrence-current-submission)]
    (controller/dispatch :boir-occurrence-submissions :clear)
    (controller/dispatch :boir-occurrence-current-submission :clear)
    (when (and (:id step) (not (zero? (:id step))))
      (controller/dispatch :boir-occurrence-submissions :load {:occurrence-id (:id step)})
      (controller/dispatch :boir-occurrence-current-submission :load {:occurrence-id (:id step)}))
    (fn [options task step]
      [:span
       [:button (merge {:on-click #(util/set-location
                                     (str
                                       (path-for :collection-boir-efile-preview :id (:id (first (filter collection-model/is-boir-collection (:collections @task)))))
                                       "?task_id="
                                       (:task_id (model/get-first-task-with-signature-type (:cycle @task) model/signature-type-boir-e-file))))}
                  (when (or (not (get (:boir_efile_enabled @state/family-settings) (:group_collection_id @task))) 
                                 @current-submission 
                                 (:complete step))
                    {:disabled :disabled}))
        (cond
          (:complete step) "E-File Accepted"
          (model/is-efile-accepted @current-submission) "E-File Accepted"
          (model/is-efile-rejected @current-submission) "E-File Rejected"
          (model/is-efile-pending @current-submission) "E-File Pending"
          :else "E-File BOIR")] " "
       (when (seq (:submissions @submissions))
         [boir-transmission-details-button
          {:occurrence-id (:id step)}
          task
          (:id (first (filter collection-model/is-boir-collection (:collections @task))))
          (vec (map :id (:submissions @submissions)))])])))

(defn multi-step-task [options task step {:keys [collapsed-map]}]

  (let [index (:step_idx step)
        linked-items-comments-summary-collapsed? (atom false)
        step-complete-time (fn [step] (when (:complete step) (util/parse-datetime (:complete_time step))))
        manage-ability-check-interval (catom nil)
        is-group-admin (auth-model/is-user-group-admin (:group_collection_id @task))
        toggle-complete-ability (atom (task-signature/toggle-complete-ability
                                        step index
                                        (:first-unsigned-index options)
                                        (:first-incomplete-index options)
                                        (:last-complete-index options)))]

    (reagent/create-class
      {:component-will-unmount
       (fn [_]
         (when @manage-ability-check-interval (js/clearInterval @manage-ability-check-interval))
         (reset! manage-ability-check-interval nil))
       :reagent-render
       (fn [options task step {:keys [collapsed-map]}]
      (when @manage-ability-check-interval (js/clearInterval @manage-ability-check-interval))
      (reset! manage-ability-check-interval
              (js/setInterval (fn [& args]
                                (reset! toggle-complete-ability
                                        (task-signature/toggle-complete-ability
                                         step (- index 1)
                                         (:first-unsigned-index options)
                                         (:first-incomplete-index options)
                                         (:last-complete-index options)))) 500))

      [:div
       [:div.o-margin-elements--xs.o-flex-align--right.o-flex-align-items-center.u-vertical-align--middle 
        (when (and (= model/signature-type-boir (:signature_scope step))
                   (not (:compliance @task))
                   (some collection-model/is-boir-collection (:collections @task)))
          [:button {:on-click #(util/set-location
                                (str
                                 (path-for :collection-boir-preview :id (:id (first (filter collection-model/is-boir-collection (:collections @task)))))
                                 "?task_id="
                                 (:task_id
                                  (or
                                   (model/get-first-task-with-signature-type (:cycle @task) model/signature-type-boir-link)
                                   (model/get-first-task-with-signature-type (:cycle @task) model/signature-type-boir)))))}
           "Generate BOIR"])

        (when
         (and (model/is-any-signature-step step) (:complete step) (task-signature/toggle-complete-able @toggle-complete-ability))

          [countdown nil (step-complete-time step) task-signature/unsign-max-time "Time to unsign"])
        
        (when (model/is-dropbox-sign-step step)
          [drobox-sign-button options step (:group_collection_id @task)]) " "
        (when (model/is-boir-efile-step step)
          [e-file-boir-buttons options task step])
        (when (and
               (not (model/is-dropbox-sign-step step))
               (not (model/is-boir-efile-step step)))
          [:div.u-display--block.u-margin-left--md
           [:div
            [toggle-complete-button {:disabled (not (task-signature/toggle-complete-able @toggle-complete-ability))
                                     :title (task-signature/toggle-complete-reason @toggle-complete-ability)} task step]]
           [:div.u-font-size--xsmall
            (when (:complete step)
              [:label
               (util/date-format-date-hour-minute (util/parse-datetime-local (:client_complete_time step))) 
               (when-let [completed-by-user (:completed_by_user step)] 
                 [:span [:br] "by " (auth-model/get-full-name completed-by-user)])])]])
        
        
        
        (when (or is-group-admin
                  ;; Modifications to signature steps only allowed wihin edit time window for non- family admin users:
                  (and (model/is-any-signature-step step) (= :edit-with-timer @(:edit-ability-atom options)))
                  ;; Regular steps:
                  (and (not (model/is-any-signature-step step)) @(:edit-ability-atom options)))
          [:label
           [disable-tool {:disabled (not (:editable step))
                          :message "Edit disabled"
                          :component [:img.svg-icon--md.u-margin-left--md.u-cursor--pointer  {:src "/static/img/icons/edit.svg"
                                                                                              :on-click (when (:editable step)
                                                                                                          (fn []
                                                                                                            (reset! (:comments-collapse? collapsed-map) true)
                                                                                                            (reset! (:edit-collapsed? collapsed-map) false)))}]}]])]
       
       
       (when-let [step-description-data (not-empty (:description step))]
         [description-section step-description-data nil])

       [linked-items-with-chooser (assoc step
                                         ;; step mimicking a task
                                         :id (:task_id step)
                                         :occurrence_id (:id step)
                                         :collections (:collections @task))
        (not (boolean (:rule task)))
        {:linked-items-comments-summary-collapsed? (collapsed-map :linked-comments-collapsed?)
         :parent-type "to"
         :type link/type-task-occurrence
         :object-type "task"
         :disabled (model/is-locked-by-signature step)}]])})))

(defn fincen-comm-log-download-button [occurrence-id]
  (let [submissions-response  (subscribe :boir-occurrence-submissions)]
    (controller/dispatch :boir-occurrence-submissions :load {:occurrence-id occurrence-id})
    (fn []
      [:form {:method :post
              :target "_blank"
              :action "/download/fincen_comm_log/"
              :style {:display :inline}}
       [:input {:type :hidden
                :name :key
                :value (:download_key @submissions-response)}]
       [:input {:type :hidden
                :name :attachment
                :value "no"}]
       [:button "Download log"]])))

(defn linked-items-all-multi-step [options task]
  (let [show-task-linked-items (boolean (:rule @task))
        steps (:cycle @task)
        task-links (subscribe :task-links)
        step-links (track! (fn [] (update-vals @task-links (fn [value] (value "_all_")))))
        load-linked-items (fn []
                            (controller/dispatch :task-links :load {:task-id (:id @task) :complete-by (:complete_by @task)}))

        count-linked-items #(reduce + (mapv (fn [step] (count (:children (@step-links (:task_id step))))) steps))]

    (fn [options task]
      (when show-task-linked-items
        [:div
         [:h4.c-heading.o-margin-elements--md
          [:span "Related Records"]
          [link/link-add-chooser {:exclude-types #{}
                                  :initial-collection-id (:id (first (:collections @task)))
                                  :parent-collection-ids (mapv #(:id %) (:collections @task))
                                  :parent {:type link/type-task
                                           :id (:id @task)}}]]

         [link/linked-items {} (concat
                                (map (fn [step]
                                       (link/link-map-entry {:parent-type "t"
                                                             :parent-id (:task_id step)
                                                             :reload load-linked-items} (:children (@step-links (:task_id step))))) steps)
                                (map (fn [step]
                                       (link/link-map-entry {:items-type "parent"} (:parents (@step-links (:task_id step))))) steps))]]))))

(defn linked-items-all-single-step [options task]
  (let [show-task-linked-items (boolean (:rule @task))
        task-linked-items (atom nil)
        occurrence-linked-items (atom nil)
        load-linked-items (fn []
                            (->> (link-model/task-links (:id @task))
                                 (p/map #(reset! task-linked-items %))
                                 (process-error))
                            (->> (link-model/occurrence-links (:id @task) (model/complete-by-date @task) "task")
                                 (p/map #(reset! occurrence-linked-items %))
                                 (process-error)))]
    (load-linked-items)
    (fn []
      [:div
       (when show-task-linked-items
         [:div.linked-items
          [:dl
           [:dt "RELATED RECORDS (ALL):"
            [link/link-add-chooser {:exclude-types #{}
                                    :initial-collection-id (:id (first (:collections @task)))
                                    :parent-collection-ids (mapv #(:id %) (:collections @task))
                                    :parent {:type link/type-task
                                             :id (:id @task)}}]]
           [link/linked-items {} [(link/link-map-entry {:parent-type "t"
                                                              :parent-id (:id @task)
                                                              :reload load-linked-items} (:children @task-linked-items))
                                        (link/link-map-entry {:items-type "parent"} (:parents @task-linked-items))]]]])])))

(defn event-list-buttons [collection-id filter-show list-show]
  [:p
   (when (has-perm :can_add_event)
     [:button {:on-click #(set-location (str "#/event/add/?collection_id=" collection-id))} "Add event"]) " "
   (when list-show
     (if @list-show
       [:span [:button {:on-click (util/handler (fn []
                                                  (reset! list-show false)
                                                  (reset! filter-show false)))} "Go to calendar"] " "]
       [:span [:button {:on-click (util/handler (fn []
                                                  (reset! list-show true)))} "Upcoming events"] " "]))
   [:button {:on-click (util/handler #(swap! filter-show not))} "Filter"] " " ])

(defn event-list-or-calendar [collection-id filter-show list-show]
  (add-watch filter-show :filter-show-show-list (fn [_ _ _ show] (when show (reset! list-show true))))
  (fn [collection-id filter-show]
    (if @list-show
      [:div.u-shadow--bottom [event-list collection-id nil filter-show false]]
      [:div.o-media.u-shadow--bottom
       [calendar {:events (fn [start end timezone cb]
                            (->> (model/event-list
                                   collection-id @state/include-descendants
                                   (time-format/unparse (time-format/formatters :date-hour-minute-second) (time-core/date-time (.year start) (inc (.month start)) (.date start)))
                                   (time-format/unparse (time-format/formatters :date-hour-minute-second) (time-core/date-time (.year end) (inc (.month end)) (.date end)))
                                   nil nil nil nil nil nil true false)
                                 (p/map (fn [response]
                                          (cb (clj->js (mapv (fn [event-data]
                                                               {:id (:id event-data)
                                                                :key (:key event-data)
                                                                :start (time-coerce/to-date (util/parse-datetime-local (:client_start event-data)))
                                                                :end (time-coerce/to-date (util/parse-datetime-local (:client_end event-data)))
                                                                :allDay (:all_day event-data)
                                                                :title (str (:name (first (:collections event-data))) ": " (:name event-data))
                                                                :complete_by (:complete_by event-data)})
                                                             (:events response))))))
                                 (process-error)))
                  :event-click (fn [cal-ev ev view]
                                 (let [cal-ev (js->clj cal-ev)]
                                   (set-location (str "#/event/details/" (cal-ev "key") "/"))))
                  :day-click (fn [date ev view]
                               (set-location (str "#/event/add/?start_time=" (.toISOString date) )))}]])))

(defn event-get-url-ui-state [] (some-> (:event-filter (util/get-location-params)) (util/base64-url-unmarshal)))
(defn event-ui-state-value [akey]
  (or (akey (event-get-url-ui-state)) ((keyword (str "event-filter-" (name akey))) @ui-state)))


(defn filter-items-exclude [all-items selected-items exclude]
  (if exclude
    (remove (set selected-items) all-items)
    selected-items))

(defn event-list [collection-id assigned-to-current-user filter-show first_only]
  (let [current-page (atom 1)
        errors (atom nil)
        events (atom nil)
        next-page (atom nil)
        filter-show (or filter-show (atom false))
        filter-collection-id (atom (or (event-ui-state-value :collection-id) collection-id))
        filter-include-subcollections (atom (or (event-ui-state-value :include-subcollections) @state/include-descendants))
        filter-collection-types (atom (set (event-ui-state-value :collection-types)))
        filter-categories (atom (set (event-ui-state-value :categories)))
        filter-start-time (atom (or (some->> (event-ui-state-value :start-time) (time-format/parse (time-format/formatters :date-hour-minute-second))) (tz/now-for-user)))
        filter-end-time (atom (some->> (event-ui-state-value :end-time) (time-format/parse (time-format/formatters :date-hour-minute-second))))
        filter-invited-users (atom (or (event-ui-state-value :invited-users) (into #{} (when assigned-to-current-user [(api/get-auth-info :user-id)]))))

        filter-all-categories (atom #{})
        filter-categories-exclude (atom false)
        filter-collection-types-exclude (atom false)

        load-events (fn [page]
                      (reset! current-page page)
                      (->> (model/event-list @filter-collection-id @filter-include-subcollections
                                             (and @filter-start-time (time-format/unparse (time-format/formatters :date-hour-minute-second) @filter-start-time))
                                             (and @filter-end-time (time-format/unparse (time-format/formatters :date-hour-minute-second) @filter-end-time))
                                             (into [] (mapcat identity @filter-collection-types)) @filter-collection-types-exclude
                                             (into [] (mapcat identity (filter-items-exclude @filter-all-categories @filter-categories @filter-categories-exclude)))
                                             (into [] @filter-invited-users) 10 @current-page false first_only)
                           (p/map (fn [events-response]
                                    (reset! events (:events events-response))
                                    (reset! next-page (:next_page events-response))
                                    (reset! errors nil)))
                           (process-error errors)))]

    (add-watch state/include-descendants :include-descendants-documents #(reset! filter-include-subcollections %4))
    (doall (for [astate [filter-collection-id filter-include-subcollections
                         filter-collection-types filter-collection-types-exclude filter-categories filter-categories-exclude
                         filter-start-time filter-end-time filter-invited-users ]]
             (add-watch astate (keyword (gensym "event-filter"))
                        (fn [_ _ olds news] (when (not= olds news) (load-events 1))))))


    (when-not @events
      (load-events @current-page))

    (run!
      (let [list-state {:collection-id @filter-collection-id
                        :include-subcollections @filter-include-subcollections
                        :collection-types @filter-collection-types
                        :categories @filter-categories
                        :start-time (some->> @filter-start-time (time-format/unparse (time-format/formatters :date-hour-minute-second)))
                        :end-time (some->> @filter-end-time (time-format/unparse (time-format/formatters :date-hour-minute-second)))
                        :invited-users @filter-invited-users
                        :page @current-page
                        :filter-collection-types-exclude @filter-collection-types-exclude}]

        (util/set-location-params {:event-filter (util/base64-url-marshal list-state)})))

    (reagent/create-class
      {:component-will-unmount
       ;; state/include-descendants is a module-level atom; the watch must not
       ;; survive this component (#2884). The gensym-keyed watches are on local atoms.
       (fn [_]
         (remove-watch state/include-descendants :include-descendants-documents))
       :reagent-render
       (fn [& _]
      [:div.o-main-aside
       (if (seq @events)
         [:main.o-main-aside__main
          [:table.event-list.t-table-redesign
           [:thead
            [:tr
             [:th.assignments "Collections"]
             [:th.icon]
             [:th.title "Title"]
             [:th "Category"]
             [:th.date "Date"]]]
           [:tbody
            (doall (for [event (take 50 @events)]
                     [:tr {:key (:key event)}
                      [:td.assignments [assignment-list (get-assignments event)]]
                      [:td.icon {:class "event"}]
                      [:td.title [:a {:href (str "#/event/details/" (:key event) "/")} (:name event)]]
                      [:td (get-in event [:category :name])]
                      [:td.date (model/event-time-string event "M/d/yy")]]))]

           [tfoot-paginator
            [paginator [] 0 (when (> @current-page 1) (handler #(load-events (- @current-page 1))))
             (when @next-page (handler #(load-events (+ @current-page 1)))) true] 5 (or @next-page (> @current-page 1))]]]

         [:div.o-main-aside__main [:p.o-media--bottom-shadow "No matching events."]])

       (when @filter-show
         [event-filter
          {:collection-top-ancestor-id collection-id}
          errors
          filter-collection-id
          filter-include-subcollections
          filter-collection-types
          filter-all-categories
          filter-categories
          filter-categories-exclude
          filter-invited-users
          filter-start-time
          filter-end-time
          filter-show
          filter-collection-types-exclude])])})))

(defn main-event-list []
  (let [filter-show (atom false)]
    (fn []
      [common/header-tab-wrapper
       [:span [:img.tab-header {:src "/static/img/icons/event-blue.svg"}] "Events"]
       [event-list-or-calendar nil filter-show state/events-list-show]
       [event-list-buttons nil filter-show state/events-list-show]])))

(defn event-filter [options errors filter-collection-id filter-include-subcollections filter-collection-types filter-all-categories filter-categories filter-categories-exclude filter-invited-users filter-start-time filter-end-time filter-show filter-collection-types-exclude]
  (let [task-type "event"
        top-collection-id (:collection-top-ancestor-id options)
        initial-colleciton-id @filter-collection-id
        categories (atom [])
        load-categories (fn []
                          (->> (model/task-filter-categories task-type @filter-collection-id @filter-include-subcollections)
                               (p/map (fn [response]
                                        (reset! categories response)
                                        (reset-choice filter-categories response #(:id %) #{})
                                        (reset! filter-all-categories (map :id (util/merge-objects-by-name @categories)))))
                               (process-error)))
        collection-types (atom [])
        load-collection-types (fn []
                                (->> (model/task-filter-collection-types
                                      task-type @filter-collection-id @filter-include-subcollections)
                                     (p/map (fn [response]
                                              (reset! collection-types response)
                                              (reset-choice filter-collection-types response #(:id %) #{})))
                                     (process-error)))
        users (atom [])
        load-users (fn []
                     (->> (model/event-filter-invited-users task-type @filter-collection-id @filter-include-subcollections)
                          (p/map #(reset! users (concat [{:id 0
                                                          :first_name "Nobody"}
                                                         {:id -1
                                                          :first_name "Inactive users"}] %)))
                          (process-error)))
        load-filter-data (fn []
                           (load-categories)
                           (load-collection-types)
                           (load-users))
        collapsed-default (not (common/mobile?))
        collapsed? (atom {:collection collapsed-default
                          :collection-type collapsed-default
                          :category collapsed-default
                          :user collapsed-default
                          :date collapsed-default
                          :created collapsed-default})
        toggle-collapsed (fn [key]
                           (swap! collapsed? assoc key (not (get @collapsed? key))))
        collapsed-all? (atom true)
        toggle-collapsed-all (fn [value]
                               (swap! collapsed? (fn [c-map]
                                                   (zipmap (keys c-map) (repeat value)))))
        clear-trigger (atom false)
        clear-all (fn []
                    (doseq [[filter-atom value]
                            [[filter-include-subcollections false]
                             [filter-collection-id nil]
                             [filter-categories #{}]
                             [filter-categories-exclude false]
                             [filter-collection-types #{}]
                             [filter-collection-types-exclude false]
                             [filter-invited-users #{}]
                             [filter-start-time (tz/now-for-user)]
                             [filter-end-time nil]]]
                      (reset! filter-atom value))
                    (swap! clear-trigger not))]

    (load-filter-data)
    (add-watch filter-collection-id :filter-collection-id-task-filter  #(load-filter-data))
    (add-watch filter-include-subcollections :include-subcollections-task-filter #(load-filter-data))

    (fn []
      [sidebar-rounded
       [:div.o-media--margin {:class (when (common/mobile?) :mobile)}
        [:div.filter-top
         [common/filter-top filter-show clear-all toggle-collapsed-all collapsed-all?]
         (when @filter-collection-id
           [:label [:input.include-subcollections
                    (form/set-checked
                     @filter-include-subcollections
                     {:type "checkbox"
                      :on-change (fn [ev] (swap! filter-include-subcollections not))})]
            "Subcollections"])]

        [:div.filter-item [nested-select filter-collection-id {:initial-id initial-colleciton-id
                                                               :top-id top-collection-id
                                                               :limit-ancestors true
                                                               :label "Collection"
                                                               :children-loader collection-model/collection-list-promise
                                                               :ancestors-loader collection-model/collection-ancestors
                                                               :sizer default-select-sizer
                                                               :clear true
                                                               :collapsed (:collection @collapsed?)
                                                               :collapse-fn (fn []
                                                                              (toggle-collapsed :collection))
                                                               :clear-trigger clear-trigger
                                                               :mobile (common/mobile?)}]]
        [common/collection-type-filter         
         {:extra-option [filter-exclude {:disabled (not (seq @filter-collection-types))} filter-collection-types-exclude]
          :header-extra [:a.o-collapsable__expander {:on-click #(toggle-collapsed :collection-type)}]
          :collapsed (:collection-type @collapsed?)
          :clear true} collection-types filter-collection-types]
        [common/category-filter
         {:extra-option [filter-exclude {:disabled (not (seq @filter-categories))} filter-categories-exclude]
          :header-extra [:a.o-collapsable__expander {:on-click #(toggle-collapsed :category)}]
          :collapsed (:category @collapsed?)
          :clear true} categories filter-categories]
        [common/user-filter               
         {:header-extra [:a.o-collapsable__expander {:on-click #(toggle-collapsed :user)}]
          :collapsed (:user @collapsed?)
          :clear true} users filter-invited-users "Invited users"]
        [:div.filter-item.u-padding-top.u-border-top--light-green 
         [:div.u-padding-bottom--xs
          [:div
           [:b
            [:span.u-padding-right--xs  "From date"] 
            [datetimepicker {:cljs-time true
                             :time-atom filter-start-time
                             :show-time-picker false
                             :green-box true}]]
           
           [:b
            [:span.u-padding-left--xs.u-padding-right--xs  "To date"] 
            [datetimepicker {:cljs-time true
                             :time-atom filter-end-time
                             :show-time-picker false
                             :green-box true}]]]
          [:span.error (:start @errors "")]]]]])))

(defn event-submit [task errors parent form-data]
  (let [submit-func (if task (partial model/event-update (:id task)) model/event-add)]
    (->> (submit-func form-data)
         (p/map (fn [task-data]
                  (set-flash :success "Event saved")
                  (if (get-in task-data [:perms :can_view])
                    (set-location (str "#/event/details/" (:key task-data) "/"))
                    (when parent
                      (util/set-location (link/parent-info-url parent))))))
         (process-error errors))))

(defn event-edit [collection task parent initial-start-time permitted-groups]
  (let [errors (atom {})
        rules (atom [])
        users (atom [])

        group (atom (:id (first permitted-groups)))
        allow-group-choice (and (not parent) (> (count permitted-groups) 1))
        name (atom (or (:name task) ""))
        location (atom (or (:location task) ""))
        description (atom (or (:description task) ""))
        original-invited-users (into #{} (map #(:user_id %) (:invitations task)))
        original-attendee-users (into #{} (map #(:user_id %) (:attendees task)))
        invited-users (atom original-invited-users)
        attendee-users (atom original-attendee-users)
        rule (atom (get-in task [:rule :id]))
        is-recurring (fn [] (boolean (to-value @rule)))
        modify-occurrence (atom (or (is-recurring) (seq original-invited-users))) ;; When editing a recurring task, default to "This occurrence"
        show-invited-users (fn [] (boolean (and task (or (is-recurring) (seq original-invited-users)) @modify-occurrence)))
        repeat-until (atom (when-let [repeat-until (:repeat_until task)]
                             (time-coerce/to-date (util/parse-datetime-local repeat-until))))
        all-day (atom (:all_day task))
        default-start-time (let [default-start-time (timepicker/get-default-start-time)
                                 browser-offset (.getTimezoneOffset (now-js-date))
                                 offset (.offset (.zone (.-tz js/moment) (tz/get-user-timezone)) (now-millis)) ]
                             (time-coerce/to-date (plus (minus (time-coerce/from-date default-start-time) (time-core/minutes offset)) (time-core/minutes browser-offset))))
        start-time (atom (time-coerce/to-date
                           (if task
                             (time-coerce/to-date (util/parse-datetime-local (:start task)))
                             (if initial-start-time
                               (time-coerce/to-date (util/parse-datetime-local initial-start-time))
                               default-start-time))))
        end-time (atom (when task
                         (time-coerce/to-date (util/parse-datetime-local (:end task)))))
        timezone (atom (or (:timezone task) (tz/get-user-timezone)))
        assignments (atom (get-initial-ui-assignments (when-let [cols (:task_collections task)]
                                                        (mapv (fn [col]
                                                                {:collection (:collection col)
                                                                 :collection_id (:collection_id col)
                                                                 :main (:main col)}) cols))))

        include-inactive-collections (atom false)
        primary-collection-id-global (atom (:collection (first (filterv #(:main %) @assignments))))

        assignments-to-delete (atom #{})
        category (atom (get-in task [:category :id]))

        load-users (fn [collection-ids]
                     (->> (collection-model/permitted-users {:event-invite true} collection-ids)
                          (p/map (fn [response] (reset! users response)))
                          (process-error)))
        adjust-end-time (fn [all-day-value delta]
                          (reset! end-time (time-coerce/to-date (plus (time-coerce/from-date @end-time) delta))))
        timezones (atom nil)
        load-timezones (fn [] (->> (auth-model/timezone-list)
                                   (p/map #(reset! timezones %))
                                   (process-error)))]

    (load-users (if parent
                  (:parent-collection-ids parent)
                  (get-collection-ids @assignments)))
    (load-timezones)
    (add-watch assignments :task-edit-users #(load-users (get-collection-ids @assignments)))
    (add-watch modify-occurrence :modify-occurrence-reset-other-list (fn [_ _ _ occ]
                                                                        (if occ
                                                                          (reset! attendee-users original-attendee-users)
                                                                          (reset! invited-users original-invited-users))))
    (add-watch rule :rule-watch (fn [_ _ old-rule new-rule]
                                  (when-not (to-value old-rule)
                                    (reset! modify-occurrence (boolean (to-value new-rule))))))
    (when @all-day (adjust-end-time @all-day (days -1)))

    (fn []
      [:div.redesign.u-shadow--bottom

       (if task
         [header
          :supertitle (get-in task [:collections 0 :ancestors 0 :name])
          :aside-title "event"
          :title [:span [:span.u-font-weight--lighter "Edit event: "] (:name task)]
          :subsubtitle (when-let [category (get-in task [:category])] [:p.u-font-size--larger [:span.type-circle [:span (:type category)]] (:name category)])
          :aside-subtitles (list ["Created" (when-let [date (get-in task [:created_at])] (util/date-reformat date)) ]
                                 ["Modified" (when-let [date (get-in task [:updated_at])] (util/date-reformat date))])]

         [header
          :title (str "Add a new event" (if collection (str " to " (:name collection)) ""))
          :simple? true])

       [:form.c-form--edit.o-media
        {:on-submit (util/handler
                      (fn []
                        (let [start-time-in-tz (time-core/to-default-time-zone (time-coerce/from-date @start-time))
                              end-time-in-tz (time-core/to-default-time-zone (time-coerce/from-date @end-time))
                              start (if @all-day
                                      (time-core/floor start-time-in-tz time-core/day)
                                      (minus start-time-in-tz (minutes (.getTimezoneOffset @start-time))))
                              end (if @all-day
                                    (plus (time-core/floor end-time-in-tz time-core/day) (days 1))
                                    (minus end-time-in-tz (minutes (.getTimezoneOffset @end-time))))
                              set-or-nobody (fn [id-set] (if (seq id-set) id-set #{0}))
                              permitted-invited-user-ids (filterv #(contains? (set (map :id @users)) %) @invited-users)
                              permitted-attendee-user-ids (filterv #(contains? (set (map :id @users)) %) @attendee-users)
                              invited-user-ids (into [] (if (= @invited-users original-invited-users) #{} (set-or-nobody permitted-invited-user-ids)))
                              attendee-user-ids (into [] (if (= @attendee-users original-attendee-users) #{} (set-or-nobody permitted-attendee-user-ids)))]
                          (event-submit
                            task errors parent
                            (merge {:group_id @group
                                    :collection_id (get-collection-ids @assignments)
                                    :main_collection_id (:collection (first (filterv (fn [assignment] (:main assignment)) @assignments)))
                                    :category_id @category
                                    :name @name
                                    :location @location
                                    :description @description
                                    :invited_user_id invited-user-ids
                                    :attendee_user_id attendee-user-ids
                                    :all_day @all-day
                                    :complete_by (:complete_by task)
                                    :start (time-format/unparse (time-format/formatters :date-hour-minute-second) (time-coerce/from-date start))
                                    :end (time-format/unparse (time-format/formatters :date-hour-minute-second) (time-coerce/from-date end))
                                    :rule_id (to-value @rule)
                                    :timezone @timezone
                                    :repeat_until (when @repeat-until (time-format/unparse
                                                                        (time-format/formatters :date)
                                                                        (time-core/to-default-time-zone (time-coerce/from-date @repeat-until))))}
                                   (link-model/parent-params parent)
                                   (when (some? assignments-to-delete ) {:deleted_collection_id (vec @assignments-to-delete)}))))))}

        (when (or allow-group-choice (not parent))
          [:fieldset
           [:legend "Ownership and access"]

           (when allow-group-choice
             [:dl
              [:dt "Family"]
              [:dd [group-chooser permitted-groups group]]])

           (when-not parent
             [:dl
              [collection-field-header include-inactive-collections]
              [:dd [assignments-edit-notable-redesign {:include-inactive-atom include-inactive-collections} assignments errors collection assignments-to-delete group
                    primary-collection-id-global]]])])


        [:fieldset
         [:legend "Event"]

         [:dl
          [:dt "Name"]
          [:dd
           [:input.u-full-width {:type "text" :value @name :on-change (reset-from-event name)}]
           [:span.error (:name @errors "")]]]

         [:dl.when
          [:dt "When"]
          [:dd
           [:label [:input (set-checked @all-day
                                        {:on-click (fn [ev]
                                                     (reset! all-day (checked? ev)))})] "All day"]]]

         [:dl
          [:dd
           (if @all-day
             [datetimepair {:start-time-atom start-time
                            :end-time-atom end-time
                            :key :allday
                            :show-time-picker false}]

             [datetimepair {:start-time-atom start-time
                            :key :regular
                            :end-time-atom end-time}]) " "
           [:span.error (:start @errors)]
           [:span.error (:end @errors)]]]

         [:dl
          [:dt "Timezone"]
          [:dd
           [:select {:on-change (reset-from-event timezone)}
            [:option {:value ""} "Choose..."]
            (doall
              (for [tz @timezones]
                [:option (set-selected @timezone tz {:value tz :key tz}) tz]))]
           [:span.error (:timezone @errors "")]]]
         [:dl.u-flex.o-margin-elements--medium
          [:div [:dt "Repeat"]
           [:dd.when
            [rule-chooser {:recurring-object-type :event} rule]
            [:span.error (:rule_id @errors "")]]]

          (when (to-value @rule)
            [:div
             [:dt "Until"]
             [:dd
              [datetimepicker {:time-atom repeat-until
                               :show-time-picker false}]
              [:span.error (:repeat_until @errors "")]]])]]

[:fieldset
 [:legend "Details"]

 [:dl
  [:dt "Service Category"]
  [:dd [category-component/category-chooser-fuzzy nil group category] [:span.error (:category_id @errors "")]]]

 [:dl
  [:dt "Location"]
  [:dd
   [:input.u-full-width {:type "text" :value @location :on-change (reset-from-event location)}]
   [:span.error (:location @errors "")]]]

 [:dl
  [:dt "Event Description"]
  [:dd
   [:textarea {:value @description :on-change (reset-from-event description)}]
   [:span.error (:description @errors "")]]]

 (when (seq @users)
   [:dl
    [:dt "Invite"]
    [:dt
     (when (and task @rule)
       [:select {:on-change (fn [ev] (reset! modify-occurrence (= (-> ev .-target .-value) "occ")))}
        [:option (merge (when @modify-occurrence {:selected "selected"}) {:value "occ"}) "This occurrence (" (util/date-reformat (:complete_by task)) ")"]
        [:option (merge (when-not @modify-occurrence {:selected "selected"}) {:value "event"}) "Event"]])]

    (let [users-atom (if (show-invited-users) invited-users attendee-users)]
      [:blockquote.o-3-columns.u-white-background.u-blue-color.c-blockquote
       [:ul

        (doall
          (for [auser @users]
            (let [user-id (:id auser)]
              [:li {:key (:id auser)}
               [:label
                [:input (set-checked
                          (contains? @users-atom user-id)
                          {:on-click (fn [ev]
                                       (let [selected (-> ev .-target .-checked)]
                                         (if selected
                                           (swap! users-atom conj user-id)
                                           (swap! users-atom disj user-id))))})]
                (auth-model/get-full-name auser)]])))]])

    [:span.error (:assignment_user @errors "")]])]

[:footer.o-flex-align--space-between
 [:button {:on-click util/back} "Back"]
 [:button {:type "submit"} "Save"]]]])))

(defn step-sign-auth-modal []
  (let [{:keys [errors-atom token-atom]} @state/step-sign-auth-modal
        uses-mfa (:uses-mfa (api/get-auth-info :user))]
    [modal [:div
            [:h3 "Please sign-in to confirm"]
            [:form.c-form--edit
             [:fieldset [:dl
                         [:dt (if uses-mfa "Authentication token" "Password")]
                         (when token-atom [:dd [:input.u-full-width {:type (if uses-mfa :text :password)
                                                                     :autofocus :autofocus
                                                                     :value @token-atom
                                                                     :on-change (reset-from-event token-atom)}]
                                           (when errors-atom [:span.error (:token @errors-atom)])])]]
             [:footer.o-space-between
              [:button {:type :button
                        :on-click (util/handler #(reset! state/step-sign-auth-modal {:enabled false}))} "Cancel"]
              [:button {:type :submit
                        :on-click (util/handler (fn []
                                                  (->> ((:toggle-complete @state/step-sign-auth-modal))
                                                       (p/map (fn []
                                                                (reset! state/step-sign-auth-modal {:enabled false})))
                                                       (p/error (fn [err] (case  (:status err)
                                                                           401 (reset! errors-atom {:token (str "Invalid " (if uses-mfa "token" "password"))})
                                                                           400 (reset! errors-atom {:token (get-in err [:response :body :message])})
                                                                           403 (reset! errors-atom {:token "You don't have permissions to perform this action."})
                                                                            (throw err)))))))} "OK"]]]]
     state/step-sign-auth-modal]))

(def compliance-conflicts-page-size 10)

(defn compliance-edit-conflicts-modal []
  (let [child-links (subscribe :child-links)]
    (add-watch
      state/compliance-edit-conflicts-modal
      :load-conflicts-data
      (fn [_ _ old-state new-state]
        (let [old-conflicting-occurrences (:conflicting-occurrences old-state)
              new-conflicting-occurrences (:conflicting-occurrences new-state)]
          (when (and (seq new-conflicting-occurrences) (not= old-conflicting-occurrences new-conflicting-occurrences))
            (controller/dispatch
              :child-links
              :load
              {:link-ids (vec (flatten (filter
                                         identity
                                         (concat
                                           (map :links_ids new-conflicting-occurrences)
                                           (map :global_links_ids new-conflicting-occurrences)))))})))))
    (fn []
      (let [step-expanded (:step-expanded-atom @state/compliance-edit-conflicts-modal)
            steps (:conflicting-occurrences @state/compliance-edit-conflicts-modal)
            page (:page @state/compliance-edit-conflicts-modal)
            step-key (fn [step] (str (:task_id step) "-" (:complete_by step)))
            step-expanded? (fn [step] (@step-expanded (step-key step)))
            cycle-class (fn [cycle-idx]
                          ((into {} (map vector (distinct (map :cycle_idx steps)) (cycle ["odd" "even"] ))) cycle-idx))]
        [modal
         [:div.c-compliance-conflicts
          [:h3 "Compliance edit conflicts"]
          [:p [:span.error "The occurrences below have items or comments that will be deleted"]]
          [:table.t-table-redesign.nopadding
           [:tbody [:tr
                    [:th.name "Step"]
                    [:th.middle.due-date "Due Date"]
                    [:th.expander]]]
           [:tbody
            (when steps
              (doall
                (for [step (subvec steps 0 (min (count steps) (* page compliance-conflicts-page-size)))]
                  (let [step-link (fn [title] [:a {:href (path-for :task-details :id (:task_id step) :complete_by (:complete_by step))
                                                   :on-click (fn [ev] (.stopPropagation ev))
                                                   :target "_blank"} title])
                        toggle-step-expanded! (fn [] (swap! step-expanded update (step-key step) not))
                        comments-count (+ (or (:global_comments_count step) 0)
                                          (or (:comments_count step) 0))
                        link-ids (seq (concat (:links_ids step) (:global_links_ids step)))]
                    (list
                      [:tr.c-compliance-conflict.o-collapsable {:class (util/classes (cycle-class (:cycle_idx step)) (when-not (step-expanded? step) "is-collapsed"))
                                                                :on-click (util/handler toggle-step-expanded!)}
                       [:td.name (when (step-expanded? step){:class :nodivider}) [step-link (model/step-name (:step_idx step) (model/task-name step))]]
                       [:td.middle.due-date (when (step-expanded? step){:class :nodivider})[step-link (util/date-reformat (:complete_by step))]]
                       [:td (if (step-expanded? step){:class "nodivider right"} {:class :right}) [:a.o-collapsable__expander]]]
                      (when (step-expanded? step)
                        [:tr.c-compliance-conflict {:class (cycle-class (:cycle_idx step))}
                         [:td.u-nopadding--top {:colspan "3"}
                          (when (or link-ids (not (zero? comments-count)))
                            [:p "Linked Items"
                             [:ul
                              (doall
                                (for [link-id link-ids]
                                  (let [child (get-in @child-links [(keyword (str link-id)) :child])]
                                    [:li [:span.c-linked-items__item {:class (util/classes (:object_type child) (when (or (get-in child [:group :compliance])
                                                                                                                          (get-in child [:task :group :compliance])) :compliance)) }
                                          [link/list-item {:anchor-attrs {:target "_blank"}} child]]])))
                              (when-not (zero? comments-count)
                                [:p [:div.comment-icon-small] (step-link (str comments-count " comment(s)"))])]])]]))))))]
           [tfoot-paginator
            [load-more (util/handler #(swap! state/compliance-edit-conflicts-modal assoc :page (inc page)))] 3 (< (* page compliance-conflicts-page-size) (count steps))]]
          [:footer.o-space-between.u-margin-top
           [:button {:on-click (util/handler #(reset! state/compliance-edit-conflicts-modal {:enabled false}))} "Cancel"]
           [:button {:on-click (util/handler (fn []
                                               (let [proceed-fn (:proceed-fn @state/compliance-edit-conflicts-modal)]
                                                 (reset! state/compliance-edit-conflicts-modal {:enabled false})
                                                 (proceed-fn true))))} "Proceed anyway"]]]
         state/compliance-edit-conflicts-modal]))))


(defn fincen-timestamp [input-date]
  (when input-date
    (let [parsed-date (util/parse-datetime input-date) ;; 1/02/06 15:04:05
        formatter (time-format/formatter "MM/d/yyyy HH:mm:ss")]
    (time-format/unparse formatter parsed-date))))

(defn raw-response [_]
  (let [is-open (atom false)]
    (fn [event]
      [:div
       [:p {:class (str "boir-transcript-toggle-text " (when @is-open "open"))
            :on-click  #(swap! is-open not)} "Raw response"]
       [:span.boir-transcript-toggle-content
        (util/html-elem :p (:pretty_response_json event))]])))

(defn event-has-validation-errors [response]
  (seq (:validationErrors response)))

(defn event-system-error [_]
  (fn [response]
    (when (:error response)
      [:li (str "Error: " (get-in  response [:error :message]))])))

(defn event-errors [_]
  (fn [response]
    (when (seq (filter #(seq (:ErrorCode %)) (:errors response))) ;; if no errors, fincen sends one empty error object - filter it out
      [:<>
       [:li "Errors:"]
       [:li [:ul
             (for [error (:errors response)]
               [:li (:ErrorCode error) ": " (:ErrorText error)])]]
       [event-system-error response]])))

(defn query-response [event]
  (if-let [event-response (:response_json event)]
    (case (:request_type event)
      1 [:span "ProcessID: " (:processId event-response)]
      2 [:div
         [:ul
          [:li "Upload Status: " (activity/id-upload-status (:code event-response))]]]
      3 [:div
         [:ul
          [:li "Submission Status: " (activity/submision-status (:submissionStatus event-response))]]]
      4 [:div
         [:ul.boir-transcript-nested-list
          (when (:submissionStatus event-response)
            [:li "Submission Status: " (activity/submision-status (:submissionStatus event-response))])
          (when (:fincenID event-response)
            [:li "Received FinCEN ID: " (:fincenID event-response)])
          (when (:initiatedTimestamp event-response)
            [:li "Initiated Timestamp (UTC): " (fincen-timestamp (:initiatedTimestamp event-response))])
          [event-errors event-response]
          [event-system-error event-response]
          (when (event-has-validation-errors event-response)
            [:<>
             [:li "Validation Errors:"]
             [:li [:ul
                   (for [error (:validationErrors event-response)]
                     [:li (if (:errorMessage error)
                            (str (:errorMessage error) (when (:location error) (str " Location: " (:location error) ".")))
                            error)])]]])]]
      5 [:div
         (let [status (:status event-response)]
           (when status
             [:ul.boir-transcript-nested-list
              (when (:submissionStatus status)
                [:li "Submission Status: " (activity/submision-status (:submissionStatus status))])
              (when (:fincenID status)
                [:li "Received FinCEN ID: " (:fincenID status)])
              (when (:initiatedTimestamp status)
                [:li "Initiated Timestamp: " (fincen-timestamp (:initiatedTimestamp status))])
              [event-errors status]
              [event-system-error status]]))]
      "Unknown request type")
    (when (:error event) [:span "Communication error"])))

(defn boir-transmission-details [_ task-atom _ submission-ids]
  (let [submissions (subscribe :boir-submissions)
        last-submission (track! (fn [] (first @submissions)))
        load-submissions (fn []
                           (controller/dispatch :boir-submissions :load {:submission-id submission-ids}))]
    (load-submissions)

    (fn [options _ collection-id _]
      [:div
       [:div.boir-transcript-header.u-margin-bottom
        [:h2.u-bold "Transmission Details "]
        [:div
         [fincen-comm-log-download-button (:occurrence-id options)] " "
         [:button (merge
                   {:on-click (util/handler
                               (fn []
                                 (->>
                                  (api/ajaxp (str "/boir/file/collection/" collection-id "/reset/") {:method :post})
                                  (p/map (fn [_]
                                           (controller/dispatch :boir-occurrence-current-submission :load {:occurrence-id (:occurrence-id options)})
                                           (load-submissions)))
                                  (process-error))))}
                   (when-not (:current @last-submission)
                     {:disabled :disabled}))
          "Reset"]]]
       (doall
        (for [submission @submissions]
          [:div.u-margin-bottom--lg
           [:h3.u-margin-bottom.u-border-bottom "Submission (UTC) " (fincen-timestamp (:created_at submission))]

           [:ul.u-margin-bottom--lg
            [:li (str  "ProcessID: " (:process_id submission))]
            [:li (str  "Submission time (UTC): " (fincen-timestamp (:created_at submission)))]
            [:li (str  "Submitter: " (:user_first_name submission) " " (:user_last_name submission))]
            [:li (str  "Status: " (activity/submision-status (:status submission)))]
            (when (:transcript_download_key submission)
              [:li "Transcript file: "
               (let [form (atom nil)]
                 [:form  {:method :post
                          :ref #(reset! form %)
                          :action (str "/download/document/")
                          :target "_blank"
                          :style {:display :inline}}
                  [:input {:type :hidden
                           :name :key
                           :value (:transcript_download_key submission)}]
                  [:input {:type :hidden
                           :name :attachment
                           :value "no"}]
                  [:input {:type :hidden
                           :name :btn
                           :value "1"}]
                  [:a.u-bold {:on-click (util/handler (fn [] (when-let [f @form] (.submit f))))}
                   "Download"]])])
            [:li (str  "Latest update (UTC): " (fincen-timestamp (:status_updated_at submission)) " ")
             [:a.u-bold {:on-click (util/handler
                                     (fn []
                                       (controller/dispatch :boir-efile-status :load
                                         {:submission-id (:id submission)
                                          :on-success (fn []
                                                        (->> (model/task-details (:id @task-atom) (:complete_by @task-atom))
                                                          (p/map (fn [response]
                                                                   (reset! task-atom response)
                                                                   (when-not (:complete response)
                                                                     (controller/dispatch :boir-occurrence-current-submission :load
                                                                       {:occurrence-id (:occurrence-id options)}))))
                                                          (process-error))
                                                        (load-submissions))})))}
              "Refresh"]]]

           [:div.boir-transcript-container
            [:div.boir-transcript-timeline
             (for [event (:events submission)]
               [:div.boir-transcript-entry
                [:div.boir-transcript-time (fincen-timestamp (:created_at event))]
                [:div.boir-transcript-details
                 [:h3.u-margin-bottom--small (:request_type_description event)]
                 [query-response event]
                 (when (:pretty_response_json event)
                   [raw-response event])]
                [:div.boir-transcript-circle]])]]]))])))

(defn boir-transmission-details-button [options task-atom collection-id submission-ids]
  [:button
   {:on-click (util/handler
                (fn []
                  (common/show-modal :transmission-details [boir-transmission-details options task-atom collection-id submission-ids] nil)))
    :ref (fn [elem]
           (when (and
                   elem
                   (= "1" (:fs (util/get-location-params))))
             (.scrollIntoView elem)
             (.click elem)
             (util/set-location-params {:fs "0"})))}
   "Transmission Details"])

(defn group-independent-tasks [options task]
  (let [group-mode (:group-mode options)
        group-step-indexes (:group-step-indexes options)
        initial-group-step-indexes (:initial-group-step-indexes options)
        was-not-empty? (boolean (seq @group-step-indexes))
        success-fn (fn [response]
                     (->> (model/task-details (:id @task) (util/date-string (:complete_by @task)))
                          (p/map (fn [response]
                                   (reset! task response)
                                   (reset! initial-group-step-indexes @group-step-indexes))))
                     (reset! group-mode false))
        errors-atom (atom nil)
        error-fn (fn [response]
                   (api/handle-error-response errors-atom response)
                   (when @errors-atom
                     (set-flash :error (clojure.string/join ", " (remove nil? (map @errors-atom [:group_step_indexes :task_group_id]))))))
        
        can-save (fn [idxs]
                   (if (empty? idxs) 
                     was-not-empty?
                     (every? (fn [n]
                               (some #(or (= (inc n) %) (= (dec n) %)) idxs))
                             idxs)))
        format-group (fn [group]
                       (cond
                         (empty? group) "No groups"
                         (= (count group) 1) (str "Step " (first group) " to ...")
                         :else (str "Step " (first group) " to " (last group))))
        
        group-formatter (fn [idxs]
                          (let [sorted-idxs (sort idxs)
                                groups (reduce (fn [acc n]
                                                 (let [last-group (peek acc)]
                                                   (if (or (empty? last-group) (= (inc (last last-group)) n))
                                                     (conj (pop acc) (conj last-group n))
                                                     (conj acc [n]))))
                                               [[]] sorted-idxs)
                                formatted-groups (map format-group groups)]
                            [:div
                             [:p (str "Group" (when (> (count groups) 1) "s") ":")]
                             [:h3 (clojure.string/join ", " formatted-groups)]] ))
        
        save-group (or (:save-group-fn options)
                     (fn []
                       (controller/dispatch :group-independent-tasks :save {:task-group-id (:group_id @task)
                                                                            :group-step-indexes @group-step-indexes
                                                                            :on-success success-fn
                                                                            :on-error error-fn
                                                                            :errors-atom errors-atom})))]
    (fn [options task]
        [:div       
         [:div.o-flex-align__element-floating-bottom-left
          [:div.o-media--medium.u-white-background.u-shadow--around
           [:div.is-active
            [:h4 "Select two or more consecutive steps to make independent group."]
            [:div.u-margin-bottom
             (group-formatter @group-step-indexes)]
            [:div.o-main-aside 
             [:main [:button.c-button--small {:style {:visibility "visible" :opacity "1"}
                                              :on-click (util/handler
                                                         (:cancel-cb options))} "Cancel"]]
             [:div.o-flex-align--right
              [:button.c-button--small (merge  
                                        {:style {:visibility "visible" :opacity "1"}
                                         :on-click (util/handler
                                                    (fn []
                                                      (save-group)))}
                                        (when-not (can-save @group-step-indexes) {:disabled :disabled})) "Save"]]]]]]])))

(defn keep-document-date-checker [options] 
  [:label
   [:input.u-margin-left--xs (form/set-checked
                              @(:keep-document-date-atom options)
                              {:type "checkbox"
                               :on-change (fn [_] (swap! (:keep-document-date-atom options) not))})]
   "Keep current document date after signature completed "
   [:span.error (:keep-document-date @(:errors-atom options) "")]])
